import React, { useState, useEffect } from "react";
import { Alert, Form, Row, Col, Button, FormFeedback, FormGroup, Label, Input, UncontrolledPopover, PopoverBody, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Link } from "react-router-dom";
import ConfigData from '../../../config.json';
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import SingleUploadfile from '../../common/single-uploadfile';
import MultipleUploadfile from '../../common/multiple-uploadfile';
import MultipleDownloadfile from '../../../components/common/multiple-downloadfile';
import { getFilterOldFileName, setFormDataUploadFile, setStringFileNameToArray, setShowFileName, TransformColumnToArray } from '../../utils/format-value';
import { getDomain, ValidateNumber, formatNumberWithComma, ValidateNumberWithoutDecimal, getFillArray, } from '../../utils/check-value';
import { IconAlertError, IconAlertReturn, IconAlertSuccess, IconBin, IconLoading } from '../../../components/common/popup-alert';

const RequestFormDbd = ({ dataFormDbd, dataFormRequest, onSaveDraft, onSave, onCancelRequest}) => {
    const history = useHistory();
    const modelAddFormBranch = { branchoffice_ic_location: '', branchoffice_ic_tel: '', branchoffice_ic_email: '', branchoffice_ic_fax: '', branchoffice_ic_file: '', file_branchoffice_ic_file: '' };
    const modelCloseFormBranch = { branchoffice_dc_location: '' };
    const modelEditFormBranch = { branchoffice_edit_clocation: '', branchoffice_edit_nlocation: '' };
    const modelLiquidator = { dtc_liquidator: '' };
    const modelAuditor = { dtc_auditor: '' };
    const modelCtp = { ts_ctp_transferor: '', ts_ctp_transferee: '', ts_ctp_amountshare: '', ts_ctp_pershare: null, ts_ctp_totalshare: null, ts_ctp_paydate: null, ts_ctp_file: '', file_ts_ctp_file: '' }
    const modelCodOut = { cod_out_name: '', cod_out_name_en: '' }
    const modelCodAdd = { cod_add_name: '', cod_add_name_en: '', cod_add_tel: '', cod_add_email: '', cod_add_file: '', file_cod_add_file: '' }
    const [dataDetail, setDataDetail] = useState([]);
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [isDisableds, setIsDisableds] = useState(false);

    const [emailLegalAuthorized , setEmailLegalAuthorized] = useState([]);
    const [emailLegalAdmin , setEmailLegalAdmin] = useState([]);
    const [formTemp, setFormTemp] = useState({});
    const [showCommentApprover, setShowCommentApprover] = useState(false);
    const userEmail = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
    const autoCompletes = "on";
    // Thailand is UTC+7
    const thaiTimezoneOffset = 7 * 60; 
    const offsetInMilliseconds = thaiTimezoneOffset * 60 * 1000;
    const thaiDateTime = new Date(new Date().getTime() + offsetInMilliseconds);
    // Format the date for MySQL DATETIME
    const newDateTime = thaiDateTime.toISOString().slice(0, 19).replace("T", " ");

    const [startDate, setStartDate] = useState(null);
    const [coaShareDate, setCoaShareDate] = useState(null);
    
    const [shipDate, setShipDate] = useState(null);
    const [sentDate, setSentDate] = useState(null);
    const [dataUser, setDataUser] = useState([]);
    const [dataCompany, setDataCompany] = useState([]);
    const [selectCompany, setSelectCompany] = useState(null);
   
    const [selectBank, setSelectBank] = useState(null);
    const [dataLanguage, setDataLanguage] = useState([]);
    const [dataConfidential, setDataConfidential] = useState([]);
    const [selectConfidential, setSelectConfidential] = useState(null);

    // State to manage the checkbox's checked status
    const [isCheckedCompanyOther, setIsCheckedCompanyOther] = useState(false);
    const [companyDisabled, setCompanyDisabled] = useState(false);
    const [otherCompanyDisabled, setOtherCompanyDisabled] = useState(true);
    const [companyPlaceholder, setCompanyPlaceholder] = useState("ระบุชื่อในการทำสัญญา");
    const [otherCompanyPlaceholder, setOtherCompanyPlaceholder] = useState("");
    const [isShowModal, setIsShowModal] = useState();
    const [isShowDeleteModal, setIsShowDeleteModal] = useState();
    const [isShowModalLimit, setIsShowModalLimit] = useState();
    const [itemToDelete, setItemToDelete] = useState(null);
    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    const [checkboxIccapAcknowledged, setCheckboxIccapAcknowledged] = useState("0");
    const [selectRadioColAcknowledged, setSelectRadioColAcknowledged] = useState("0");

    const [checkboxIcSelect, setCheckboxIcSelect] = useState("0");
    const [checkboxDcSelect, setCheckboxDcSelect] = useState("0");
    const [checkboxOtSelect, setCheckboxOtSelect] = useState("0");
    const [checkboxObjectiveAdd, setCheckboxObjectiveAdd] = useState("0");
    const [checkboxObjectiveEdit, setCheckboxObjectiveEdit] = useState("0");
    const [checkboxObjectiveMain, setCheckboxObjectiveMain] = useState("0");

    const [selectRadioDecrease, setSelectRadioDecrease] = useState("0");

    const [fileEditSeal, setFileEditSeal] = useState([]);
    const [fileNameEditSealMultiple, setFileNameEditSealMultiple] = useState("");

    const [fileHeadOffice, setFileHeadOffice] = useState([]);
    const [fileNameHeadOfficeMultiple, setFileNameHeadOfficeMultiple] = useState("");

    const [fileBranchOffice, setFileBranchOffice] = useState([]);
    
    const [fileObjectiveAdd, setFileObjectiveAdd] = useState([]);
    const [fileNameObjectiveAddMultiple, setFileNameObjectiveAddMultiple] = useState("");

    const [fileObjectiveEdit, setFileObjectiveEdit] = useState([]);
    const [fileNameObjectiveEditMultiple, setFileNameObjectiveEditMultiple] = useState("");

    const [fileBylawAdd, setFileBylawAdd] = useState([]);
    const [fileNameBylawAddMultiple, setFileNameBylawAddMultiple] = useState("");

    const [fileBylawEdit, setFileBylawEdit] = useState([]);
    const [fileNameBylawEditMultiple, setFileNameBylawEditMultiple] = useState("");

    const [fileCtp, setFileCtp] = useState([]);
    const [fileCod, setFileCod] = useState([]);

    const [fileLiquidator, setFileLiquidator] = useState([]);
    const [fileNameLiquidatorMultiple, setFileNameLiquidatorMultiple] = useState("");
    
    const [fileBalancesheet, setFileBalancesheet] = useState([]);
    const [fileNameBalancesheetMultiple, setFileNameBalancesheetMultiple] = useState("");

    const [fileDocs, setFileDocs] = useState([]);
    const [fileNameDocsMultiple, setFileNameDocsMultiple] = useState("");
    
    const [fileExample, setFileExample] = useState([]);

    const [formAddBranchOffice, setFormAddBranchOffice] = useState(null);
    const [formCloseBranchOffice, setFormCloseBranchOffice] = useState(null);
    const [formEditBranchOffice, setFormEditBranchOffice] = useState(null);
    const [formLiquidator, setFormLiquidator] = useState(null);
    const [formAuditor, setFormAuditor] = useState(null);
    const [formCtp, setFormCtp] = useState(null);
    const [formCodOut, setFormCodOut] = useState(null);
    const [formCodAdd, setFormCodAdd] = useState(null);

    const [checkBoxAddBranchOffice, setCheckBoxAddBranchOffice] = useState("0"); 
    const [checkBoxCloseBranchOffice, setCheckBoxCloseBranchOffice] = useState("0"); 
    const [checkBoxEditBranchOffice, setCheckBoxEditBranchOffice] = useState("0"); 
    const [checkBoxCodOut, setCheckBoxCodOut] = useState("0"); 
    const [checkBoxCodAdd, setCheckBoxCodAdd] = useState("0"); 

    const [checkboxes, setCheckboxes] = useState({
        iccap_select: "0",
        dccap_select: "0",
        edit_name_select: "0",
        edit_seal_select: "0",
        headoffice_select: "0",
        branchoffice_select: "0",
        objective_select: "0",
        bylaws_select: "0",
        cod_select: "0",
        coa_select: "0",
        ts_select: "0",
        dtc_select: "0",
        col_select: "0",
        other_select: "0",
    });
    const [isShowSection, setIsShowSection] = useState({
        iccap_select: "0",
        dccap_select: "0",
        edit_name_select: "0",
        edit_seal_select: "0",
        headoffice_select: "0",
        branchoffice_select: "0",
        objective_select: "0",
        bylaws_select: "0",
        cod_select: "0",
        coa_select: "0",
        ts_select: "0",
        dtc_select: "0",
        col_select: "0",
        other_select: "0",
    });

    const checkboxMapping = {
        "1": "iccap_select",
        "2": "dccap_select",
        "3": "edit_name_select",
        "4": "edit_seal_select",
        "5": "headoffice_select",
        "6": "branchoffice_select",
        "7": "objective_select",
        "8": "bylaws_select",
        "9": "cod_select",
        "10": "coa_select",
        "11": "ts_select",
        "12": "dtc_select",
        "13": "col_select",
        "14": "other_select",
    };

    const toggleCheckbox = (checkboxKey) => {
        setIsShowSection((prevState) => ({
            ...prevState,
            [checkboxKey]: prevState[checkboxKey] === "1" ? "0" : "1",
        }));
    };

    const handleDeleteClick = (itemId) => {
        setItemToDelete(itemId);       // กำหนด item ที่ต้องการลบ
        setIsShowDeleteModal(true);    // แสดง Modal
    };

    const handleDecreasRadio = (e) => {
        const value = e.target.value;
        setSelectRadioDecrease(value);
        //console.log(value);
        if(value === "1"){
            validation.setFieldValue("dccap_reducap_valuepershare", null);
            validationDraft.setFieldValue("dccap_reducap_valuepershare", null);
        } else {
            validation.setFieldValue("dccap_reducap_commonstock", null);
            validation.setFieldValue("dccap_reducap_preferredstock", null);
            validationDraft.setFieldValue("dccap_reducap_commonstock", null);
            validationDraft.setFieldValue("dccap_reducap_preferredstock", null);
        }
        validation.handleChange("dccap_reducap_type")(e.target.value);
        validationDraft.handleChange("dccap_reducap_type")(e.target.value);
        setIsSaveEnabled(true);
    };

    const handleColAcknowledged = (e) => {
        const value = e.target.value;
        setSelectRadioColAcknowledged(value);
        validation.handleChange("col_acknowledged")(e.target.value);
        validationDraft.handleChange("col_acknowledged")(e.target.value);
        setIsSaveEnabled(true);
        if( value === "1"){
            setSentDate(""); // optional: ถ้าคุณแสดงค่าจาก state นี้
            validation.setFieldValue("col_docs_sent_date", "", true);
            validationDraft.setFieldValue("col_docs_sent_date", "", true);
        } else {
            setShipDate(""); // optional: ถ้าคุณแสดงค่าจาก state นี้
            validation.setFieldValue("col_docs_ship_date", "", true);
            validationDraft.setFieldValue("col_docs_ship_date", "", true);
        }
    };
    
    const [ischeckedBylawAddSelect, setIscheckedBylawAddSelect] = useState("0");
    const [ischeckedBylawEditSelect, setIscheckedBylawEditSelect] = useState("0");

    const areAllCheckboxesZero = Object.values(checkboxes).every(value => value === "0");

    const isShowSectionCheckbox = (fieldName) => {
        return checkboxes[fieldName] === "1" || dataDetail[fieldName] === "1";
    };

    const isSelectedCheckbox = (fieldName) => {
        return tempCheckboxes[fieldName] === "1" || dataDetail[fieldName] === "1";
    };

    const [tempCheckboxes, setTempCheckboxes] = useState({ ...checkboxes }); // ใช้สำหรับเก็บค่าชั่วคราวของ Checkbox

    const handleTempCheckboxChange = (e) => {
        const { name, checked } = e.target;
        const value = checked ? "1" : "0";
        setTempCheckboxes((prevTempCheckboxes) => ({
            ...prevTempCheckboxes,
            [name]: value,
        }));
        setIsSaveEnabled(true);
    };

    // ฟังก์ชัน submit ที่จะอัปเดตค่า checkboxes จาก tempCheckboxes
    const selectFormDoc = () => {
        setIsShowModal(false)
        setCheckboxes(tempCheckboxes); // อัปเดต checkboxes ด้วยค่าชั่วคราวจาก tempCheckboxes
    };

    const confirmDelete = () => {
        const keyToReset = checkboxMapping[itemToDelete]; // ดึงชื่อคีย์ตาม mapping
        if (dataFormDbd.id > 0) {
            setDataDetail((prevCheckboxes) => {
                // clear all value inside section
                if (keyToReset === "iccap_select") {
                    const fieldsToReset = [
                        "iccap_regiscap_amount",
                        "iccap_regiscap_commonstock",
                        "iccap_regiscap_preferredstock",
                        "iccap_regiscap_valuepershare",
                        "iccap_addcap_amount",
                        "iccap_addcap_commonstock",
                        "iccap_addcap_preferredstock",
                        "iccap_addcap_valuepershare",
                        "iccap_newcap_amount",
                        "iccap_newcap_stock",
                        "iccap_newcap_valuepershare",
                        "iccap_paymentpershare",
                        "iccap_paymentdate",
                        "iccap_bank_account",
                        "iccap_bank_name",
                        "iccap_bank_no",
                        "iccap_bank_branch",
                        "iccap_acknowledged"
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ["iccap_bank_account", "iccap_bank_name", "iccap_bank_no", "iccap_bank_branch", "iccap_acknowledged"].includes(field) 
                            ? ""  
                            : null; 
                        return acc;
                    }, {});

                    setStartDate("");
                    setCheckboxIccapAcknowledged("0");

                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "dccap_select"){
                    const fieldsToReset = [
                        "dccap_regiscap_amount",
                        "dccap_regiscap_commonstock",
                        "dccap_regiscap_preferredstock",
                        "dccap_regiscap_valuepershare",
                        "dccap_reducap_amount",
                        "dccap_reducap_type",
                        "dccap_reducap_commonstock",
                        "dccap_reducap_preferredstock",
                        "dccap_reducap_valuepershare",
                        "dccap_newcap_amount",
                        "dccap_newcap_commonstock",
                        "dccap_newcap_preferredstock",
                        "dccap_newcap_valuepershare",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ["dccap_reducap_type"].includes(field) 
                            ? ""  
                            : null; 
                        return acc;
                    }, {});

                    setSelectRadioDecrease("0");

                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "edit_name_select"){
                    const fieldsToReset = [
                        "edit_name_th",
                        "edit_name_en",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});

                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "edit_seal_select"){
                    const fieldsToReset = [
                        "edit_seal_ink",
                        "edit_seal",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});
                    
                    setFileEditSeal([]);

                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "headoffice_select"){
                    const fieldsToReset = [
                        "headoffice_clocation",
                        "headoffice_nlocation_th",
                        "headoffice_nlocation_en",
                        "headoffice_file",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});
                    
                    setFileHeadOffice([]);

                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "branchoffice_select"){
                    const fieldsToReset = [
                        "branchoffice_ic_select",
                        "doc_add_branch",
                        "branchoffice_dc_select",
                        "doc_close_branch",
                        "branchoffice_edit_select",
                        "doc_edit_branch",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        if (field === "doc_add_branch") {
                            acc[field] = [{ ...modelAddFormBranch }];
                        } else if (["doc_close_branch"].includes(field)) {
                            acc[field] = [{ ...modelCloseFormBranch }];
                        } else if (["doc_edit_branch"].includes(field)) {
                            acc[field] = [{ ...modelEditFormBranch }];
                        } else if (["dtc_auditorfee"].includes(field)) {
                            acc[field] = null;
                        } else {
                            acc[field] = "";
                        }
                        return acc;
                    }, {});

                    setCheckboxIcSelect("0");
                    setCheckboxDcSelect("0");
                    setCheckboxOtSelect("0");

                    setFormAddBranchOffice([{...modelAddFormBranch}]);
                    setFormCloseBranchOffice([{...modelCloseFormBranch}]);
                    setFormEditBranchOffice([{...modelEditFormBranch}]);
                    setFileBranchOffice(setStringFileNameToArray(""));
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "objective_select"){
                    const fieldsToReset = [
                        "objective_add_select",
                        "objective_add_file",
                        "objective_add_other",
                        "objective_edit_select",
                        "objective_edit_file",
                        "objective_edit_other",
                        "objective_main_select",
                        "objective_main_other",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});

                    setCheckboxObjectiveAdd("0");
                    setCheckboxObjectiveEdit("0");
                    setCheckboxObjectiveMain("0");

                    setFileObjectiveAdd([]);
                    setFileObjectiveEdit([]);
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "bylaws_select"){
                    const fieldsToReset = [
                        "bylaws_add_select",
                        "bylaws_add_file",
                        "bylaws_edit_select",
                        "bylaws_edit_file",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});

                    setIscheckedBylawAddSelect("0");
                    setIscheckedBylawEditSelect("0");
                    
                    setFileBylawAdd([]);
                    setFileBylawEdit([]);
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "cod_select"){
                    const fieldsToReset = [
                        "doc_cod_out",
                        "doc_cod_add",
                        "cod_current_powerofdirector",
                        "cod_new_powerofdirector",
                        "cod_remark",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        if (field === "doc_cod_out") {
                            acc[field] = [{ ...modelCodOut }];
                        } else if (["doc_cod_add"].includes(field)) {
                            acc[field] = [{ ...modelCodAdd }];
                        } else {
                            acc[field] = "";
                        }
                        return acc;
                    }, {});

                    setFormCodOut([{...modelCodOut}]);
                    setFormCodAdd([{...modelCodAdd}]);
                    
                    setFileCod(setStringFileNameToArray(""));
                    setCheckBoxCodOut("0");
                    setCheckBoxCodAdd("0");
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "coa_select"){
                    const fieldsToReset = [
                        "coa_share_bath",
                        "coa_share_number",
                        "coa_share_addition",
                        "coa_share_total",
                        "coa_share_date",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});

                    setCoaShareDate("");
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "ts_select"){
                    const fieldsToReset = [
                        "doc_ctp",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        if (field === "doc_ctp") {
                            acc[field] = [{ ...modelAddFormBranch }];
                        } 
                        return acc;
                    }, {});

                    setFormCtp([{...modelCtp}]);
                    setFileCtp(setStringFileNameToArray(""));
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "dtc_select"){
                    const fieldsToReset = [
                        "dtc_powerofliquidator",
                        "dtc_liquidatoroffice_name",
                        "dtc_liquidatoroffice_file",
                        "dtc_auditoroffice",
                        "dtc_auditorfee",
                        "doc_liquidator",
                        "doc_auditor",
                        "dtc_liquidator_1",
                        "dtc_liquidator_2",
                        "dtc_liquidator_3",
                        "dtc_liquidator_4",
                        "dtc_liquidator_5",
                        "dtc_auditor_1",
                        "dtc_auditor_2",
                        "dtc_auditor_3",
                        "dtc_auditor_4",
                        "dtc_auditor_5",
                    ];
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        if (field === "doc_liquidator") {
                            acc[field] = [{ ...modelLiquidator }];
                        } else if (["doc_auditor"].includes(field)) {
                            acc[field] = [{ ...modelAuditor }];
                        } else if (["dtc_auditorfee"].includes(field)) {
                            acc[field] = null;
                        } else {
                            acc[field] = "";
                        }
                        return acc;
                    }, {});

                    setFormLiquidator([{...modelLiquidator}]);
                    setFormAuditor([{ ...modelAuditor }]);
                    setFileLiquidator([]);

                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "col_select"){
                    const fieldsToReset = [
                        "col_balancesheet_file",
                        "col_docs_file",
                        "col_acknowledged",
                        "col_docs_ship_date", 
                        "col_docs_sent_date",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        if (["col_docs_ship_date"].includes(field) || ["col_docs_sent_date"].includes(field) ) {
                            acc[field] = null;
                        } else {
                            acc[field] = "";
                        }
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});

                    setSelectRadioColAcknowledged("0");
                    setFileBalancesheet([]);
                    setFileDocs([]);
                    setShipDate("");
                    setSentDate("");
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                } else if(keyToReset === "other_select"){
                    const fieldsToReset = [
                        "other_title",
                        "other_detail",
                    ];
        
                    // ใช้ reduce() เพื่อล้างค่าทั้งหมดแบบ dynamic
                    const updatedFields = fieldsToReset.reduce((acc, field) => {
                        acc[field] = ""; // กำหนดให้ทุกฟิลด์เป็น ""
                        return acc;
                    }, {});
                    
                    return {
                        ...prevCheckboxes,
                        ...updatedFields,
                        [keyToReset]: "0" // ล้างค่า checkbox
                    };
                }
                return prevCheckboxes; // ถ้าไม่ใช่ keyToReset ที่ต้องการให้คืนค่าเดิม
            });
        } else {
            const resetKeys = [
                "iccap_select", "dccap_select", "edit_name_select", "edit_seal_select",
                "headoffice_select", "branchoffice_select", "objective_select", "bylaws_select",
                "cod_select", "coa_select", "ts_select", "dtc_select", "col_select", "other_select"
            ];
            if (resetKeys.includes(keyToReset)) {
                resetFields(keyToReset);
            }
        }
    
        // การอัพเดต checkboxes, tempCheckboxes, และการแสดงผล section
        setCheckboxes((prevCheckboxes) => {
            if (keyToReset) { // ตรวจสอบว่าคีย์นั้นมีอยู่ใน mapping
                return {
                    ...prevCheckboxes,
                    [keyToReset]: "0",
                };
            }
            return prevCheckboxes; // ถ้าไม่เจอคีย์ที่ตรงกัน ให้คืนค่าเดิม
        });
    
        setTempCheckboxes((prevTempCheckboxes) => ({
            ...prevTempCheckboxes,
            [keyToReset]: "0",
        }));
    
        setIsShowSection((prevIsShowSection) => ({
            ...prevIsShowSection,
            [keyToReset]: "0",
        }));
    
        Swal.fire({
            iconHtml: IconBin,
            title: "ลบเอกสารคำขอแล้ว<br>Request document has been deleted. ",
            showConfirmButton: false,
            showCloseButton: true,
            // showConfirmButton: false,
        }).then(() => {
            setIsShowDeleteModal(false); // ปิด Modal หลังจากลบ
        });
        
    };

    const handleCheckboxChangeCompanyOther = () => {
        const isChecked = !isCheckedCompanyOther; 
        setIsCheckedCompanyOther(isChecked); 
        //console.log(validation.values.id_business_unit);
        
        setCompanyDisabled(isChecked);
        setOtherCompanyDisabled(!isChecked);
        setCompanyPlaceholder(isChecked ? "" : "โปรดเลือก...");
        setOtherCompanyPlaceholder(isChecked ? "กรอกชื่อบริษัท" : "");
    
        const businessUnitValue = isChecked ? "-1" : "";
       
        validation.setFieldValue("id_business_unit", businessUnitValue);
        validation.setFieldValue("business_unit_other", "");
        setSelectCompany(businessUnitValue);
        
        ["id_business_unit", "business_unit_other"].forEach(field => {
            validation.setFieldError(field, null);
            validation.setFieldTouched(field, false);
        });
        setIsSaveEnabled(true);
    };

    const checkShowInputUserCoordinator = (
        (getDomain(userEmail) !== "btsgroup.co.th" || dataUser.business_unit?.toLowerCase() !== "bts group holdings public company limited") 
        && (dataFormDbd.id === 0 || dataFormRequest.request_no === "draft")
    );

    // start check condition in form
    const checkAuthorizedSubmitOrApprove = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || dataFormRequest.id_workflow_status === 4
    );

    const checkAuthorizedReturn = (
        (dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by) 
        || (dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 4)
    );

    const checkUserIsApproverShowReturnBtn = (
        dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status !== 4
    );

    // case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return ถ้าใช้
    const checkUserCreateTicketAndApproveIsSame = ( 
        dataFormRequest.request_by !== dataFormRequest.approve_request_by
    );

    const changeButtonIsStateRequestorOrApprover = (
        (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.request_by) 
        || (dataFormRequest.id_workflow_status !== 1 && dataFormRequest.id_workflow_status !== 2 && dataUser.email === dataFormRequest.create_request_by)
        || (dataFormRequest.id_workflow_status !== 4 && dataUser.email === dataFormRequest.approve_request_by) 
        || (dataFormDbd.id === 0)
    )

    const checkLoadDataRequestAndForm = (
        (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status === 0) 
        || (dataFormRequest.id_workflow_status === 4 && userEmail === dataFormRequest.request_by || dataFormRequest.id_workflow_status === 0)
        || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) 
        || (dataFormRequest.id_workflow_status === 1 && userEmail === dataFormRequest.approve_request_by) 
        || (dataFormRequest.id_workflow_status === 2 && userEmail === dataFormRequest.approve_request_by)
    );

    // end check condition in form

    useEffect(() => {
        LoadDataBusinessUnit();
        LoadDataLanguage();
        LoadDataConfidential();
        LoadProfileUser(userEmail);
        LoadFileSupportDoc();
        LoadLegalAdmin(5); // หมายถึง กลุ่มของ user admin
    }, []);

    useEffect(() => {
        if(dataFormDbd.id > 0){
            let updateddataFormDbd = {...dataFormDbd};

            if (dataFormRequest.request_no === "draft" && dataFormRequest.id_business_unit === "-1") {
                updateddataFormDbd.id_business_unit = "";
            }
            if (dataFormRequest.id_confidential_level === "0") {
                updateddataFormDbd.id_confidential_level = "";
            }
            if (dataFormDbd.term_start_date === null && dataFormDbd.term_end_date === null) {
                updateddataFormDbd.selectedTerm = "";
            }

            setDataDetail(updateddataFormDbd);
            let arrFormAddBranchOffice = TransformColumnToArray(updateddataFormDbd, modelAddFormBranch, 5);
            let arrFormCloseBranchOffice = TransformColumnToArray(updateddataFormDbd, modelCloseFormBranch, 5);
            let arrFormEditBranchOffice = TransformColumnToArray(updateddataFormDbd, modelEditFormBranch, 5);
            let arrFormliquidator = TransformColumnToArray(updateddataFormDbd, modelLiquidator, 5);
            let arrFormAuditor = TransformColumnToArray(updateddataFormDbd, modelAuditor, 5);
            let arrFormCtp = TransformColumnToArray(updateddataFormDbd, modelCtp, 5);
            let arrFormCodOut = TransformColumnToArray(updateddataFormDbd, modelCodOut, 10);
            let arrFormCodAdd = TransformColumnToArray(updateddataFormDbd, modelCodAdd, 10);
            
            setFormAddBranchOffice(arrFormAddBranchOffice);
            setCheckBoxAddBranchOffice(dataFormDbd.branchoffice_ic_select);

            setFormCloseBranchOffice(arrFormCloseBranchOffice);
            setCheckBoxCloseBranchOffice(dataFormDbd.branchoffice_dc_select);

            setFormEditBranchOffice(arrFormEditBranchOffice);
            setCheckBoxEditBranchOffice(dataFormDbd.branchoffice_edit_select);

            setFormLiquidator(arrFormliquidator);
            setFormAuditor(arrFormAuditor);

            setFormCtp(arrFormCtp);

            setFormCodOut(arrFormCodOut);
            setFormCodAdd(arrFormCodAdd);
            setCheckBoxCodOut(dataFormDbd.cod_out_select);
            setCheckBoxCodAdd(dataFormDbd.cod_add_select);

            setFileEditSeal(dataFormDbd.edit_seal ? setStringFileNameToArray(dataFormDbd.edit_seal) : []);
            setFileHeadOffice(dataFormDbd.headoffice_file ? setStringFileNameToArray(dataFormDbd.headoffice_file) : []);
            setFileObjectiveAdd(dataFormDbd.objective_add_file ? setStringFileNameToArray(dataFormDbd.objective_add_file) : []);
            setFileObjectiveEdit(dataFormDbd.objective_edit_file ? setStringFileNameToArray(dataFormDbd.objective_edit_file) : []);
            setFileBylawAdd(dataFormDbd.bylaws_add_file ? setStringFileNameToArray(dataFormDbd.bylaws_add_file) : []);
            setFileBylawEdit(dataFormDbd.bylaws_edit_file ? setStringFileNameToArray(dataFormDbd.bylaws_edit_file) : []);
 
            setFileBalancesheet(dataFormDbd.col_balancesheet_file ? setStringFileNameToArray(dataFormDbd.col_balancesheet_file) : []);
            setFileDocs(dataFormDbd.col_docs_file ? setStringFileNameToArray(dataFormDbd.col_docs_file) : []);
            setFileLiquidator(dataFormDbd.dtc_liquidatoroffice_file ? setStringFileNameToArray(dataFormDbd.dtc_liquidatoroffice_file) : []);
            setStartDate(dataFormDbd.iccap_paymentdate ?? "");
            setCoaShareDate(dataFormDbd.coa_share_date ?? "");
           
            setShipDate(dataFormDbd.col_docs_ship_date ?? "");
            setSentDate(dataFormDbd.col_docs_sent_date ?? "");
            setSelectRadioDecrease(dataFormDbd.dccap_reducap_type ?? "");
            if(dataFormRequest.request_no !== "draft" && dataFormDbd.approver_comment !== ""){
                setShowCommentApprover(true);
            }
            LoadFormTempById(dataFormRequest.id_form_temp);
        }
    }, [dataFormDbd, dataFormRequest]);

    useEffect(() => {
        if(dataFormDbd.id > 0){
            // 1. set group requestor can edit when id workflow = 4 or draft or user groupId2 when user can approve request.
            // 2,3. set group approver can edit when id workflow = 1,2
            if( (checkLoadDataRequestAndForm) ){
                setCompanyDisabled(false);
            } else if( dataFormRequest.id_workflow_status > 4 ){
                setIsDisableds(false);
                setCompanyDisabled(false);
            } else {
                setIsDisableds(true);
                setCompanyDisabled(true);
            }
            setSelectConfidential(dataConfidential.find(x => x.value === dataFormDbd.id_confidential_level?.toString()) ?? "");
            setSelectCompany(dataCompany.find(x => x.value === dataFormDbd.id_business_unit?.toString()) ?? "");
            setCheckboxIccapAcknowledged(dataFormDbd.iccap_acknowledged);
            setSelectRadioColAcknowledged(dataFormDbd.col_acknowledged);
            // setSelectBank(dataBank.find(x => x.value === dataFormDbd.id_bank_account?.toString()) ?? "");
            setCheckboxIcSelect(dataFormDbd.branchoffice_ic_select);
            setCheckboxDcSelect(dataFormDbd.branchoffice_dc_select);
            setCheckboxOtSelect(dataFormDbd.branchoffice_edit_select);
            setCheckboxObjectiveAdd(dataFormDbd.objective_add_select);
            setCheckboxObjectiveEdit(dataFormDbd.objective_edit_select);
            setCheckboxObjectiveMain(dataFormDbd.objective_main_select);
            setIscheckedBylawAddSelect(dataFormDbd.bylaws_add_select);
            setIscheckedBylawEditSelect(dataFormDbd.bylaws_edit_select);
            
            LoadLegalAuthorized(dataFormDbd.id_business_unit);
            setIsShowSection(prevState => {
                const updatedState = Object.keys(prevState).reduce((acc, key) => {
                    acc[key] = "1"; // ตั้งค่าทุก key เป็น "1"
                    return acc;
                }, {});
                return updatedState;
            });
        }
    }, [dataLanguage, dataConfidential, dataCompany, dataFormDbd]);

    const GetUrlBack = () => {
        const urlBack = (dataFormRequest.table_name !== "" && dataFormRequest.table_name !== null && dataFormRequest.table_name !== undefined) ? "/request-form/" + btoa(dataFormRequest.table_name) : "/all-type-request";
        return urlBack;
    };
    
    const LoadProfileUser = (email) => {
        let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setDataUser(respData.data[0]);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadFormTempById = (idFormTemp) =>{
        let url = ConfigData.API_URL + "form-temp/" + idFormTemp;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                setFormTemp(respData.data[0]);
                LoadFileSupportDoc(respData.data[0]?.id_request_type, respData.data[0]?.id_sub_request_type);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadLegalAuthorized = (idBusinessUnit) => {
        let url = ConfigData.API_URL + "map-user-assign/search?status=1&id_business_unit=" + idBusinessUnit;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true ){
                if(respData.data.length > 0){
                    setEmailLegalAuthorized(respData.data);
                } else {
                    // sayam@btsgroup.co.th, anchalee@btsgroup.co.th,kingkan_c@btsgroup.co.th
                    setEmailLegalAuthorized([{"email": "sayam@btsgroup.co.th"},{"email": "anchalee@btsgroup.co.th"}]);
                }
                // console.log(respData.data[0].email);
            } else {
                setEmailLegalAuthorized("");
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadLegalAdmin = (groupId) => {
        let url = ConfigData.API_URL + "user/?status=1&id_user_group=" + groupId;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            responseType: "json",
        })
        .then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setEmailLegalAdmin(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadDataBusinessUnit = () => {
        let url = ConfigData.API_URL + "business-unit/search?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString()
                    };
                });
                setDataCompany(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    
    const LoadFileSupportDoc = (idRequestType = 0, idSubRequestType = 0) => {
        const url = ConfigData.API_URL + "support-document/?status=1";
        const token = "Bearer " + localStorage.getItem("tkd");

        axios.get(url, {
            headers: {
                'Authorization': token,
            },
            responseType: "json"
        })
        .then(resp => {
            const respData = resp.data;
            const requestType = dataFormRequest.id_request_type ? dataFormRequest?.id_request_type : idRequestType;
            const subRequestType = dataFormRequest.id_sub_request_type ? dataFormRequest?.id_sub_request_type : idSubRequestType;
            if (respData.is_sucess === true && Array.isArray(respData.data)) {
                const filtered = respData.data
                    .filter(item =>
                        item.id_request_type === requestType &&
                        item.id_sub_request_type === subRequestType
                    )
                    .map(item => ({
                        name: item.name || "Example",
                        document: item.document || ""
                    }));
                setFileExample(filtered);
            }
        })
        .catch(error => {
            console.error(error);
        });
    };

    const LoadDataLanguage = () => {
        let url = ConfigData.API_URL + "language/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name,
                        value: e.id.toString(),
                    };
                });
                setDataLanguage(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataConfidential= () => {
        let url = ConfigData.API_URL + "confidential/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_th + " (" + e.name_en + ")",
                        value: e.id.toString(),
                    };
                });
                setDataConfidential(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const onCheckSaveDraft = () => {
        dataUser.email === dataFormRequest.approve_request_by ? setIsSaveEnabled(false) : setIsSaveEnabled(true);
        if(( dataUser.email === dataFormRequest.approve_request_by && dataUser.email !== dataFormRequest.request_by ) || (dataFormRequest.request_by === dataFormRequest.approve_request_by && dataUser.id_user_group === 2) || dataFormRequest.id_workflow_status === 4 || dataFormRequest.id_workflow_status === 0){
            validationDraft.submitForm();
        } else if(dataFormDbd.id_request === ""){
            validationDraft.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    }

    const onCheckSubmit = async () => {
        // ทำการ validate ฟอร์มทั้งหมด
        const errors = await validation.validateForm();
    
        // ตรวจสอบว่ามี error หรือไม่
        if (Object.keys(errors).length > 0) {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                showConfirmButton: false,
                showCloseButton: true,
            });
            // return; // หยุดการทำงานถ้ามี error
        }
    
        // ถ้าไม่มี error ให้ทำการ submit form
        if (!dataFormRequest.id_workflow_status) {
            validation.submitForm();
        } else if ( checkAuthorizedSubmitOrApprove ) {
            validation.submitForm();
        } else {
            Swal.fire({
                iconHtml: IconAlertError,
                title: "You Are not authorized to action this.",
                showConfirmButton: false,
                showCloseButton: true,
            });
        }
    };

    const onCheckReturn = () => {
        // console.log("return");
        setShowCommentApprover(true);
        validationReturn.submitForm();
        // console.log(showCommentApprover);
        if(showCommentApprover === true){
            // console.log(showCommentApprover);
            if(Object.getOwnPropertyNames(validationReturn.errors).length === 0){
                if( checkAuthorizedReturn ){
                    onReturn(dataFormRequest, validation.values);
                } else {
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "You Are not authorized to action this.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            }else {
                // ถ้ามีข้อผิดพลาด แสดงข้อความเตือน
                Swal.fire({
                    iconHtml: IconAlertError,
                    title: "กรุณากรอกข้อมูลความเห็นของผู้อนุมัติ",
                    showConfirmButton: false,
                    showCloseButton: true,
                });
            }
        }
    }

    const onReturn = (dataRequest, dataFormDbd) => {
        Swal.fire({
            icon: 'info',
            title: 'Loading...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });
  
        let isSaveSucess = true;
        (async () => {
            try{
                let dataReturn = await UpdateReturn(dataRequest.id);
                isSaveSucess = (dataReturn.is_sucess === true && isSaveSucess === true) ? true : false;
                //console.log(dataReturn);

                let str_send_to = dataRequest.request_by;

                if ( dataRequest.create_request_by && dataRequest.request_by !== dataRequest.create_request_by ) {
                    str_send_to += `,${dataRequest.create_request_by}`;
                }
                
                const dataRequestWorkFlows = {
                    "id_request": dataRequest.id,
                    "id_workflow_status" : 4,
                    "do_by" : userEmail,
                    "send_to" : str_send_to,
                    "cc_to" : null,
                    "comment" : dataFormDbd.approver_comment,
                    "document" : null,
                    "consent" : null,
                    "do_date" : newDateTime,
                };
                let dataRequestWorkFlow = await AddRequestWorkFlow(dataRequestWorkFlows);
                isSaveSucess = (dataRequestWorkFlow.is_sucess === true && isSaveSucess === true) ? true : false;
                //console.log(dataRequestWorkFlow);

                if(isSaveSucess === true){
                    let isSendMail = await SendMailReturn(dataRequestWorkFlow.data[0]);
                    if( isSendMail === true ){
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                                iconHtml: IconAlertReturn,
                                title: "Return to user who request.",
                                showConfirmButton: false,
                                showCloseButton: true,
                                // showConfirmButton: false,
                            }).then(() => {
                                // props.nextStep();
                                history.push(GetUrlBack());
                            });
                    }else{
                        Swal.close(); // Close loading spinner
                        Swal.fire({
                            iconHtml: IconAlertError,
                            title: "Failed to send email to user who request.",
                            showConfirmButton: false,
                            showCloseButton: true,
                        });
                    }
                }else{
                    Swal.close(); // Close loading spinner
                    Swal.fire({
                        iconHtml: IconAlertError,
                        title: "Failed to save data.",
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            } catch(error){
                console.log(error);
            }
        })();
    };

    const UpdateReturn = async (id) => {
        let url = ConfigData.API_URL + "request/approval-return/" + id;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.put(url,{}, { headers: { 
                                        'Authorization' : token,
                                        'User': userId,
                                    }, responseType: "json" });
            let respData = resp.data;
            // setDataIdRequest(respData.data)
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const AddRequestWorkFlow = async (dataRequestWorkFlows) => {
        let url = ConfigData.API_URL + "request-workflow/";
        let data = dataRequestWorkFlows;
        let token = "Bearer " + localStorage.getItem("tkd");
        let userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try {
            const resp = await axios.post(url, data, { headers: { 
                                'Authorization' : token,
                                'User': userId,
                            }, responseType: "json" }
                        );
            let respData = resp.data;
            return respData;
        }catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const SendMailReturn = async (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 2,
            "request_id": data.id_request,
        };
        try {
            const resp = await axios.post(url, dataReq, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        } catch(error){
            // handlerRespError(error, history);
            console.log(error);
            return false;
        }
    };

    const handleStartDateChange = (event) => {
        setIsSaveEnabled(true);
        setStartDate(event.target.value);
        validation.handleChange("iccap_paymentdate")(event.target.value);  // Trigger validation
        validationDraft.handleChange("iccap_paymentdate")(event.target.value);  // Trigger validation
        // console.log(event.target.value);
    };

    const handleShipDateChange = (event) => {
        const maxDate = new Date().toISOString().split('T')[0];
        const inputDate = event.target.value;
        setIsSaveEnabled(true);
        setShipDate(inputDate);
        if (inputDate <= maxDate) {
            validation.handleChange("col_docs_ship_date")(inputDate);
            validationDraft.handleChange("col_docs_ship_date")(inputDate);
        } else {
            validation.handleChange("col_docs_ship_date")(maxDate);
            validationDraft.handleChange("col_docs_ship_date")(maxDate);
        }
    };

    const handleSentDateChange = (event) => {
        const minDate = new Date().toISOString().split('T')[0];
        const inputDate = event.target.value;  // string yyyy-mm-dd
        setIsSaveEnabled(true);
        setSentDate(inputDate);
        if (inputDate >= minDate) {
            validation.handleChange("col_docs_sent_date")(inputDate);  // Trigger validation
            validationDraft.handleChange("col_docs_sent_date")(inputDate);  // Trigger validation
        } else {
            validation.handleChange("col_docs_sent_date")(minDate);  // Trigger validation
            validationDraft.handleChange("col_docs_sent_date")(minDate);  // Trigger validation
        }
    };

    const handleCoaShareDateChange = (event) => {
        setIsSaveEnabled(true);
        setCoaShareDate(event.target.value);
        validation.handleChange("coa_share_date")(event.target.value);  // Trigger validation
        validationDraft.handleChange("coa_share_date")(event.target.value);  // Trigger validation
    }

    const OnSetFileDocs = (files) => {
        setFileDocs(files);
        updateFileDocsNames(files);
    };

    const updateFileDocsNames = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("col_docs_file")(names);
        validationDraft.handleChange("col_docs_file")(names);
        setFileNameDocsMultiple(names);
        setIsSaveEnabled(true);
    };

    const OnSetFileBalancesheet = (files) => {
       
        setFileBalancesheet(files);
        updateFileBalancesheetNames(files);
    };

    const updateFileBalancesheetNames = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("col_balancesheet_file")(names);
        validationDraft.handleChange("col_balancesheet_file")(names);
        setFileNameBalancesheetMultiple(names);
        setIsSaveEnabled(true);
    };

    const OnSetFileLiquidator = (files) => {
        setFileLiquidator(files);
        updateFileLiquidatorNames(files);
    };

    const updateFileLiquidatorNames = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("dtc_liquidatoroffice_file")(names);
        validationDraft.handleChange("dtc_liquidatoroffice_file")(names);
        setFileNameLiquidatorMultiple(names);
        setIsSaveEnabled(true);
       
    };

    const OnSetFileBylawAdd = (files) => {
       
        setFileBylawAdd(files);
        updateFileBylawAddNames(files);
    };

    const updateFileBylawAddNames = (files) => {
       
        const names = files.map(file => file.name).join(",");
        validation.handleChange("bylaws_add_file")(names);
        validationDraft.handleChange("bylaws_add_file")(names);
        setFileNameBylawAddMultiple(names);
        setIsSaveEnabled(true);
       
    };

    const OnSetFileBylawEdit = (files) => {
       
        setFileBylawEdit(files);
        updateFileBylawEditNames(files);
    };

    const updateFileBylawEditNames = (files) => {
       
        const names = files.map(file => file.name).join(",");
        validation.handleChange("bylaws_edit_file")(names);
        validationDraft.handleChange("bylaws_edit_file")(names);
        setFileNameBylawEditMultiple(names);
        setIsSaveEnabled(true);
       
    };

    const OnSetFileObjectiveAdd = (files) => {
       
        setFileObjectiveAdd(files);
        updateFileObjectiveAddNames(files);
    };

    const updateFileObjectiveAddNames = (files) => {
       
        const names = files.map(file => file.name).join(",");
        validation.handleChange("objective_add_file")(names);
        validationDraft.handleChange("objective_add_file")(names);
        setFileNameObjectiveAddMultiple(names);
        setIsSaveEnabled(true);
       
    };

    const OnSetFileObjectiveEdit = (files) => {
        setFileObjectiveEdit(files);
        updateFileObjectiveEditNames(files);
    };

    const updateFileObjectiveEditNames = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("objective_edit_file")(names);
        validationDraft.handleChange("objective_edit_file")(names);
        setFileNameObjectiveEditMultiple(names);
        setIsSaveEnabled(true);
       
    };

    const OnSetFileEditSeal = (files) => {
        setFileEditSeal(files);
        updateFileEditSealNames(files);
    };

    const updateFileEditSealNames = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("edit_seal")(names);
        validationDraft.handleChange("edit_seal")(names);
        setFileNameEditSealMultiple(names);
        setIsSaveEnabled(true);
    };

    const OnSetFileHeadOffice = (files) => {
        setFileHeadOffice(files);
        updateFileHeadOfficeNames(files);
    };

    const updateFileHeadOfficeNames = (files) => {
        const names = files.map(file => file.name).join(",");
        validation.handleChange("headoffice_file")(names);
        validationDraft.handleChange("headoffice_file")(names);
        setFileNameHeadOfficeMultiple(names);
        setIsSaveEnabled(true);
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            iccap_regiscap_amount: dataDetail.iccap_regiscap_amount || null,
            iccap_regiscap_commonstock: dataDetail.iccap_regiscap_commonstock || null,
            iccap_regiscap_preferredstock: dataDetail.iccap_regiscap_preferredstock || null,
            iccap_regiscap_valuepershare: dataDetail.iccap_regiscap_valuepershare || null,
            iccap_addcap_amount: dataDetail.iccap_addcap_amount || null,
            iccap_addcap_commonstock: dataDetail.iccap_addcap_commonstock || null,
            iccap_addcap_preferredstock: dataDetail.iccap_addcap_preferredstock || null,
            iccap_addcap_valuepershare: dataDetail.iccap_addcap_valuepershare || null,
            iccap_newcap_amount: dataDetail.iccap_newcap_amount || null,
            iccap_newcap_stock: dataDetail.iccap_newcap_stock || null,
            iccap_newcap_valuepershare: dataDetail.iccap_newcap_valuepershare || null,
            iccap_paymentpershare: dataDetail.iccap_paymentpershare || null,
            iccap_paymentdate: dataDetail.iccap_paymentdate || null,
            iccap_bank_account: dataDetail.iccap_bank_account || "",
            iccap_bank_name: dataDetail.iccap_bank_name || "",
            iccap_bank_no: dataDetail.iccap_bank_no || "",
            iccap_bank_branch: dataDetail.iccap_bank_branch || "",
            iccap_acknowledged: dataDetail.iccap_acknowledged || "",
            dccap_regiscap_amount: dataDetail.dccap_regiscap_amount || null,
            dccap_regiscap_commonstock: dataDetail.dccap_regiscap_commonstock || null,
            dccap_regiscap_preferredstock: dataDetail.dccap_regiscap_preferredstock || null,
            dccap_regiscap_valuepershare: dataDetail.dccap_regiscap_valuepershare || null,
            dccap_reducap_amount: dataDetail.dccap_reducap_amount || null,
            dccap_reducap_type: dataDetail.dccap_reducap_type || null,
            dccap_reducap_commonstock: dataDetail.dccap_reducap_commonstock || null,
            dccap_reducap_preferredstock: dataDetail.dccap_reducap_preferredstock || null,
            dccap_reducap_valuepershare: dataDetail.dccap_reducap_valuepershare || null,
            dccap_after_reducap: dataDetail.dccap_after_reducap || "",
            dccap_newcap_amount: dataDetail.dccap_newcap_amount || null,
            dccap_newcap_commonstock: dataDetail.dccap_newcap_commonstock || null,
            dccap_newcap_preferredstock: dataDetail.dccap_newcap_preferredstock || null,
            dccap_newcap_valuepershare: dataDetail.dccap_newcap_valuepershare || null,
            edit_name_th: dataDetail.edit_name_th || "",
            edit_name_en: dataDetail.edit_name_en || "",
            edit_seal_ink: dataDetail.edit_seal_ink || "",
            edit_seal: dataDetail.edit_seal || "",
            headoffice_clocation: dataDetail.headoffice_clocation || "",
            headoffice_nlocation_th: dataDetail.headoffice_nlocation_th || "",
            headoffice_nlocation_en: dataDetail.headoffice_nlocation_en || "",
            headoffice_file: dataDetail.headoffice_file || "",
            doc_add_branch: formAddBranchOffice || [{...modelAddFormBranch}],
            doc_close_branch: formCloseBranchOffice || [{...modelCloseFormBranch}],
            doc_edit_branch: formEditBranchOffice || [{...modelEditFormBranch}],
            doc_liquidator: formLiquidator || [{...modelLiquidator}],
            doc_auditor: formAuditor || [{...modelAuditor}],
            doc_ctp: formCtp || [{...modelCtp}],
            doc_cod_out: formCodOut || [{...modelCodOut}],
            doc_cod_add: formCodAdd || [{...modelCodAdd}],
            cod_out_select: dataDetail.cod_out_select || "0",
            cod_add_select: dataDetail.cod_add_select || "0",
            branchoffice_ic_select: dataDetail.branchoffice_ic_select || "0",
            branchoffice_dc_select: dataDetail.branchoffice_dc_select || "0",
            branchoffice_edit_select: dataDetail.branchoffice_edit_select || "0",
            objective_add_select: dataDetail.objective_add_select || "0",
            objective_add_file: dataDetail.objective_add_file || "",
            objective_add_other: dataDetail.objective_add_other || "",
            objective_edit_select: dataDetail.objective_edit_select || "0",
            objective_edit_file: dataDetail.objective_edit_file || "",
            objective_edit_other: dataDetail.objective_edit_other || "",
            objective_main_select: dataDetail.objective_main_select || "0",
            objective_main_other: dataDetail.objective_main_other || "",
            bylaws_add_select: dataDetail.bylaws_add_select || "0",
            bylaws_add_file: dataDetail.bylaws_add_file || "",
            bylaws_edit_select: dataDetail.bylaws_edit_select || "0",
            bylaws_edit_file: dataDetail.bylaws_edit_file || "",
            cod_current_powerofdirector: dataDetail.cod_current_powerofdirector || "",
            cod_new_powerofdirector: dataDetail.cod_new_powerofdirector || "",
            cod_remark: dataDetail.cod_remark || "",
            coa_share_bath: dataDetail.coa_share_bath || "",
            coa_share_number: dataDetail.coa_share_number || "",
            coa_share_addition: dataDetail.coa_share_addition || "",
            coa_share_total: dataDetail.coa_share_total || "",
            coa_share_date: dataDetail.coa_share_date || null,
            dtc_powerofliquidator: dataDetail.dtc_powerofliquidator || "",
            dtc_liquidatoroffice_name: dataDetail.dtc_liquidatoroffice_name || "",
            dtc_liquidatoroffice_file: dataDetail.dtc_liquidatoroffice_file || "",
            dtc_auditoroffice: dataDetail.dtc_auditoroffice || "",
            dtc_auditorfee: dataDetail.dtc_auditorfee || null,
            dtc_remark: dataDetail.dtc_remark || "",
            col_balancesheet_file: dataDetail.col_balancesheet_file || "",
            col_docs_file: dataDetail.col_docs_file || "",
            col_acknowledged: dataDetail.col_acknowledged || "",
            col_docs_ship_date: dataDetail.col_docs_ship_date || "", 
            col_docs_sent_date: dataDetail.col_docs_sent_date || "", 
            other_title: dataDetail.other_title || "",
            other_detail: dataDetail.other_detail || "",
            iccap_select: dataDetail.iccap_select || "",
            dccap_select: dataDetail.dccap_select || "",
            edit_name_select: dataDetail.edit_name_select || "",
            edit_seal_select: dataDetail.edit_seal_select || "",
            headoffice_select: dataDetail.headoffice_select || "",
            branchoffice_select: dataDetail.branchoffice_select || "",
            objective_select: dataDetail.objective_select || "",
            bylaws_select: dataDetail.bylaws_select || "",
            cod_select: dataDetail.cod_select || "",
            coa_select: dataDetail.coa_select || "",
            ts_select: dataDetail.ts_select || "",
            dtc_select: dataDetail.dtc_select || "",
            col_select: dataDetail.col_select || "",
            other_select: dataDetail.other_select || "",
            id_confidential_level: dataDetail.id_confidential_level || 0,
            user_comment: dataDetail.user_comment || "",
            selected_check_objective: "",
            selected_check_bylaws: "",
            selected_check_branch: "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_request_no: dataFormRequest?.request_no || "",
        },
        validationSchema: Yup.object({
            id_confidential_level: Yup.string().required("กรุณาเลือก/Please select"),
            id_business_unit: Yup.string().required("กรุณาเลือก/Please select"),
            iccap_regiscap_amount: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_regiscap_commonstock: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_regiscap_preferredstock: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_regiscap_valuepershare: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_addcap_amount: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_addcap_commonstock: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_addcap_preferredstock: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_addcap_preferredstock: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_newcap_amount: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_addcap_valuepershare: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_newcap_amount: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_newcap_stock: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_newcap_valuepershare: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_paymentpershare: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_paymentdate: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            iccap_bank_account: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            iccap_bank_name: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            iccap_bank_no: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            iccap_bank_branch: Yup.string().when([], {
                is: () => isShowSectionCheckbox("iccap_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            iccap_acknowledged: Yup.mixed().when([], {
                is: () => isShowSectionCheckbox("iccap_select") && checkboxIccapAcknowledged === "0",
                then: Yup.mixed()
                    .test(
                        "is-checked",
                        "กรุณากดยอมรับเพื่อให้การอนุมัติเอกสารเสร็จสมบูรณ์/Please tick this box to complete the approval.",
                        (value) => {
                            if (Array.isArray(value)) {
                                return value.includes("on"); // ตรวจสอบว่ามี "on" อยู่ใน array
                            }
                            return value === "1"; // ตรวจสอบว่าค่าเป็น "1"
                        }
                    ),
                otherwise: Yup.mixed().notRequired(),
            }),
            edit_name_th: Yup.string().when([], {
                is: () => isShowSectionCheckbox("edit_name_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            edit_name_en: Yup.string().when([], {
                is: () => isShowSectionCheckbox("edit_name_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            edit_seal_ink: Yup.string().when([], {
                is: () => isShowSectionCheckbox("edit_seal_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            edit_seal: Yup.string().when([], {
                is: () => isShowSectionCheckbox("edit_seal_select"),
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_regiscap_amount: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_regiscap_commonstock: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_regiscap_preferredstock: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_regiscap_valuepershare: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_reducap_amount: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_reducap_type: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณาเลือกข้อใดข้อนึง/Please select"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_reducap_commonstock: Yup.string().when("dccap_reducap_type", {
                is: (dccap_reducap_type) => dccap_reducap_type === "1",
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            dccap_reducap_preferredstock: Yup.string().when("dccap_reducap_type", {
                is: (dccap_reducap_type) => dccap_reducap_type === "1",
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            dccap_reducap_valuepershare: Yup.string().when("dccap_reducap_type", {
                is: (dccap_reducap_type) => dccap_reducap_type === "2",
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            dccap_newcap_amount: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_newcap_commonstock: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_newcap_preferredstock: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_newcap_valuepershare: Yup.string()
            .nullable()
            .transform((value, originalValue) => originalValue === null ? "" : value) // แปลง null เป็น ""
            .when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            dccap_after_reducap: Yup.string().when([], {
                is: () => isShowSectionCheckbox("dccap_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            headoffice_clocation: Yup.string().when([], {
                is: () => isShowSectionCheckbox("headoffice_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            headoffice_nlocation_th: Yup.string().when([], {
                is: () => isShowSectionCheckbox("headoffice_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            headoffice_nlocation_en: Yup.string().when([], {
                is: () => isShowSectionCheckbox("headoffice_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            headoffice_file: Yup.string().when([], {
                is: () => isShowSectionCheckbox("headoffice_select"),
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            selected_check_objective :Yup.string().when(["objective_add_select", "objective_edit_select", "objective_main_select"], {
                is: () => isShowSectionCheckbox("objective_select"), // เช็คว่า isShowSectionCheckbox("objective_select") เป็น true หรือไม่
                then: Yup.string().test(
                  "check-at-least-one-selected",
                  "ต้องเลือกอย่างน้อย 1 ตัวเลือก",
                  function (_, context) {
                    const { objective_add_select, objective_edit_select, objective_main_select } = context.parent;
              
                    return !(
                      objective_add_select === "0" &&
                      objective_edit_select === "0" &&
                      objective_main_select === "0"
                    );
                  }
                ),
                otherwise: Yup.string().notRequired(), // ถ้า isShowSectionCheckbox เป็น false ไม่ต้องเช็ค
            }),
            objective_add_file: Yup.string().when("objective_add_select", {
                is: (objective_add_select) => objective_add_select === "1",
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            objective_edit_file: Yup.string().when("objective_edit_select", {
                is: (objective_edit_select) => objective_edit_select === "1",
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            objective_main_other: Yup.string().when("objective_main_select", {
                is: (objective_main_select) => objective_main_select === "1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            coa_share_bath: Yup.string().when([], {
                is: () => isShowSectionCheckbox("coa_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            coa_share_number: Yup.string().when([], {
                is: () => isShowSectionCheckbox("coa_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            coa_share_addition: Yup.string().when([], {
                is: () => isShowSectionCheckbox("coa_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            coa_share_total: Yup.string().when([], {
                is: () => isShowSectionCheckbox("coa_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            coa_share_date: Yup.string().when([], {
                is: () => isShowSectionCheckbox("coa_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            selected_check_bylaws:Yup.string().when(["bylaws_add_select", "bylaws_edit_select"], {
                is: () => isShowSectionCheckbox("bylaws_select"), // เช็คว่า isShowSectionCheckbox("objective_select") เป็น true หรือไม่
                then: Yup.string().test(
                  "check-at-least-one-selected",
                  "ต้องเลือกอย่างน้อย 1 ตัวเลือก",
                  function (_, context) {
                    const { bylaws_add_select, bylaws_edit_select } = context.parent;
              
                    return !(
                        bylaws_add_select === "0" &&
                        bylaws_edit_select === "0" 
                    );
                  }
                ),
                otherwise: Yup.string().notRequired(), // ถ้า isShowSectionCheckbox เป็น false ไม่ต้องเช็ค
            }),
            bylaws_add_file: Yup.string().when("bylaws_add_select", {
                is: (bylaws_add_select) => bylaws_add_select === "1",
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            bylaws_edit_file: Yup.string().when("bylaws_edit_select", {
                is: (bylaws_edit_select) => bylaws_edit_select === "1",
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            business_unit_other: Yup.string().when(["id_business_unit", "isDisabled"], {
                is: (id_business_unit, isDisabled) => !isDisabled && id_business_unit === "-1",
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            approve_request_by: Yup.string().when("check_request_no", {
                is: (check_request_no) => check_request_no === undefined || check_request_no === "draft",
                then: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address")
                .test('is-not-current-user', 'ไม่สามารถใช้อีเมลของผู้ใช้งานปัจจุบัน/You cannot use your own email', function(value) {
                    return value?.toLowerCase() !== userEmail; 
                }),
                otherwise: Yup.string().required("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address")
                .email("กรุณาระบุอีเมลผู้อนุมัติ/Please provide the approver's email address").matches(englishEmailRegex, "Email must be a valid English email address"),
            }),
            create_request_by: !checkShowInputUserCoordinator
            ? Yup.string().nullable()
            : Yup.string()
                .required("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .email("กรุณาระบุอีเมลผู้ประสานงาน/Please provide the coordinator's email address")
                .matches(englishEmailRegex, "Email must be a valid English email address"),
            selected_check_branch:Yup.string().when(["branchoffice_ic_select", "branchoffice_dc_select", "branchoffice_edit_select"], {
                is: () => isShowSectionCheckbox("branchoffice_select"), // เช็คว่า isShowSectionCheckbox("branchoffice_select") เป็น true หรือไม่
                then: Yup.string().test(
                  "check-at-least-one-selected",
                  "ต้องเลือกอย่างน้อย 1 ตัวเลือก",
                  function (_, context) {
                    const { branchoffice_ic_select, branchoffice_dc_select, branchoffice_edit_select } = context.parent;
              
                    return !(
                        branchoffice_ic_select === "0" &&
                        branchoffice_dc_select === "0" &&
                        branchoffice_edit_select === "0"
                    );
                  }
                ),
                otherwise: Yup.string().notRequired(),
            }),
            doc_add_branch: Yup.array().of(
                Yup.object().shape({
                    branchoffice_ic_location: Yup.string().when(["branchoffice_select", "branchoffice_ic_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_ic_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    branchoffice_ic_tel: Yup.string().when(["branchoffice_select", "branchoffice_ic_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_ic_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    branchoffice_ic_email: Yup.string().when(["branchoffice_select", "branchoffice_ic_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_ic_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").email("รูปแบบอีเมลไม่ถูกต้อง / Invalid email format").matches(englishEmailRegex, "Email must be a valid English email address"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    branchoffice_ic_fax: Yup.string().when(["branchoffice_select", "branchoffice_ic_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_ic_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    branchoffice_ic_file: Yup.string().when(["branchoffice_select", "branchoffice_ic_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_ic_select === "1",
                        then: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            doc_close_branch: Yup.array().of(
                Yup.object().shape({
                    branchoffice_dc_location: Yup.string().when(["branchoffice_select", "branchoffice_dc_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_dc_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            doc_edit_branch: Yup.array().of(
                Yup.object().shape({
                    branchoffice_edit_clocation: Yup.string().when(["branchoffice_select", "branchoffice_edit_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_edit_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    branchoffice_edit_nlocation: Yup.string().when(["branchoffice_select", "branchoffice_edit_select"], {
                        is: () => validation.values.branchoffice_select === "1" && validation.values.branchoffice_edit_select === "1",
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            doc_liquidator: Yup.array().of(
                Yup.object().shape({
                    dtc_liquidator: Yup.string().when(["dtc_select"], {
                        is: () => validation.values.dtc_select === "1" || isShowSectionCheckbox("dtc_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            dtc_powerofliquidator: Yup.string().when([], {
                is: () => isShowSectionCheckbox("dtc_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            dtc_liquidatoroffice_name: Yup.string().when([], {
                is: () => isShowSectionCheckbox("dtc_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            dtc_liquidatoroffice_file: Yup.string().when([], {
                is: () => isShowSectionCheckbox("dtc_select"),
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            doc_auditor: Yup.array().of(
                Yup.object().shape({
                    dtc_auditor: Yup.string().when(["dtc_select"], {
                        is: () => validation.values.dtc_select === "1" || isShowSectionCheckbox("dtc_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            dtc_auditoroffice: Yup.string().when([], {
                is: () => isShowSectionCheckbox("dtc_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            dtc_auditorfee: Yup.string().when([], {
                is: () => isShowSectionCheckbox("dtc_select"),
                then: Yup.string()
                    .trim()
                    .required("กรุณากรอกข้อมูล/Please fill out")
                    .nullable(), // Allow null values
                otherwise: Yup.string().notRequired().nullable(), // Allow null values
            }),
            col_balancesheet_file: Yup.string().when([], {
                is: () => isShowSectionCheckbox("col_select"),
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            col_docs_file: Yup.string().when([], {
                is: () => isShowSectionCheckbox("col_select"),
                then: Yup.string().trim().required("กรุณาแนบไฟล์/Please attachment file"),
                otherwise: Yup.string().notRequired(),
            }),
            col_acknowledged: Yup.string().when([], {
                is: () =>
                  isShowSectionCheckbox("col_select") &&
                  selectRadioColAcknowledged === "0",
                then: Yup.string()
                  .required("กรุณาเลือกข้อใดข้อนึง")
                  .test("not-zero", "กรุณาเลือกข้อใดข้อนึง", (val) => val !== "0" && !!val),
                otherwise: Yup.string().notRequired(),
            }),
            col_docs_ship_date: Yup.string().when([], {
                is: () => isShowSectionCheckbox("col_select") && selectRadioColAcknowledged === "1",
                then: Yup.string().trim().required("กรุณาเลือก/Please select").nullable(),
                otherwise: Yup.string().notRequired().nullable(),
            }),
            col_docs_sent_date: Yup.string().when([], {
                is: () => isShowSectionCheckbox("col_select") && selectRadioColAcknowledged === "2",
                then: Yup.string().trim().required("กรุณาเลือก/Please select").nullable(),
                otherwise: Yup.string().notRequired().nullable(),
            }),
            doc_ctp: Yup.array().of(
                Yup.object().shape({
                    ts_ctp_transferor: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    ts_ctp_transferee: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    ts_ctp_amountshare: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    ts_ctp_pershare: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").nullable(),
                        otherwise: Yup.string().notRequired().nullable(),
                    }),
                    ts_ctp_totalshare: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").nullable(),
                        otherwise: Yup.string().notRequired().nullable(),
                    }),
                    ts_ctp_paydate: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณาเลือก/Please select").nullable(),
                        otherwise: Yup.string().notRequired().nullable(),
                    }),
                    ts_ctp_file: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("ts_select"),
                        then: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            other_title: Yup.string().when([], {
                is: () => isShowSectionCheckbox("other_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            other_detail: Yup.string().when([], {
                is: () => isShowSectionCheckbox("other_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            doc_cod_out: Yup.array().of(
                Yup.object().shape({
                    cod_out_name: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodOut === "1" ,
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    cod_out_name_en: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodOut === "1" ,
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            doc_cod_add: Yup.array().of(
                Yup.object().shape({
                    cod_add_name: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodAdd === "1" ,
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    cod_add_name_en: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodAdd === "1" ,
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    cod_add_tel: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodAdd === "1" ,
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    cod_add_email: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodAdd === "1" ,
                        then: Yup.string().required("กรุณากรอกข้อมูล/Please fill out").email("รูปแบบอีเมลไม่ถูกต้อง / Invalid email format").matches(englishEmailRegex, "Email must be a valid English email address"),
                        otherwise: Yup.string().notRequired(),
                    }),
                    cod_add_file: Yup.string().when([], {
                        is: () => isShowSectionCheckbox("cod_select") && checkBoxCodAdd === "1" ,
                        then: Yup.string().required("กรุณาแนบไฟล์/Please attachment file"),
                        otherwise: Yup.string().notRequired(),
                    }),
                })
            ),
            cod_current_powerofdirector: Yup.string().when([], {
                is: () => isShowSectionCheckbox("cod_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            cod_new_powerofdirector: Yup.string().when([], {
                is: () => isShowSectionCheckbox("cod_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
            cod_remark: Yup.string().when([], {
                is: () => isShowSectionCheckbox("cod_select"),
                then: Yup.string().trim().required("กรุณากรอกข้อมูล/Please fill out"),
                otherwise: Yup.string().notRequired(),
            }),
        }),
        onSubmit: (values) => {
             // แปลงฟิลด์ที่ต้องการให้เป็น `int` และค่าว่างเป็น `null`
            const intFields = ['ts_ctp_pershare_1', 'ts_ctp_pershare_2', 'ts_ctp_pershare_3', 'ts_ctp_pershare_4', 'ts_ctp_pershare_5', 'id_confidential_level']; // ใส่ชื่อฟิลด์ที่ต้องการแปลงที่นี่
            const nullOnlyFields = ['iccap_regiscap_amount', 'iccap_regiscap_commonstock', 'iccap_regiscap_preferredstock', 'iccap_regiscap_valuepershare', 'iccap_addcap_amount', 'iccap_addcap_commonstock'
                ,'iccap_addcap_preferredstock', 'iccap_addcap_valuepershare', 'iccap_newcap_amount', 'iccap_newcap_stock', 'iccap_newcap_valuepershare', 'iccap_paymentpershare', 'iccap_paymentdate'
                ,'dccap_regiscap_amount', 'dccap_regiscap_commonstock', 'dccap_regiscap_preferredstock', 'dccap_regiscap_valuepershare', 'dccap_reducap_amount', 'dccap_reducap_type', 'dccap_reducap_commonstock'
                ,'dccap_reducap_preferredstock', 'dccap_reducap_valuepershare', 'dccap_newcap_amount', 'dccap_newcap_commonstock', 'dccap_newcap_preferredstock', 'dccap_newcap_valuepershare', 'coa_share_date'
                ,'ts_ctp_amountshare_1', 'ts_ctp_totalshare_1', 'ts_ctp_paydate_1', 'ts_ctp_amountshare_2', 'ts_ctp_totalshare_2', 'ts_ctp_paydate_2', 'ts_ctp_amountshare_3', 'ts_ctp_totalshare_3', 'ts_ctp_paydate_3', 'ts_ctp_amountshare_4', 'ts_ctp_totalshare_4', 'ts_ctp_paydate_4', 'ts_ctp_amountshare_5', 'ts_ctp_totalshare_5', 'ts_ctp_paydate_5', 
                ,'dtc_auditorfee'];

            intFields.forEach((field) => {
                if (values[field] === "") {
                    values[field] = null; // แปลงค่าว่างเป็น null
                } else if (values[field] !== undefined && values[field] !== null) {
                    values[field] = parseInt(values[field], 10); // แปลงเป็น int ถ้าไม่เป็นค่าว่าง
                }
            });

             // แปลงฟิลด์ที่ต้องการให้ค่าว่างเป็น null โดยไม่แปลงเป็น int
            nullOnlyFields.forEach((field) => {
                if (values[field] === "") {
                    values[field] = null; // แปลงค่าว่างเป็น null
                } else if (typeof values[field] === 'string' && field !== 'iccap_addcap_valuepershare') {
                    values[field] = values[field].toString().replace(/,/g, '');
                }
            });

            const fieldNames = [
                "iccap_select", "dccap_select", "edit_name_select", "edit_seal_select",
                "headoffice_select", "branchoffice_select", "objective_select", "bylaws_select",
                "cod_select", "coa_select", "ts_select", "dtc_select", "col_select", "other_select"
            ];
        
            fieldNames.forEach(field => {
                if (dataFormDbd.id > 0) {
                    // ตรวจสอบว่าค่าใน checkboxes เปลี่ยนแปลงจากค่าเริ่มต้น ("0")
                    values[field] = checkboxes[field] !== "0" ? checkboxes[field] : values[field];
                } else {
                    // ใช้ค่าจาก checkboxes โดยตรง
                    values[field] = checkboxes[field];
                }
            });
            values.request_no = dataFormRequest.request_no; // check request_no
            values.edit_seal = fileNameEditSealMultiple.toString() !== "" ? fileNameEditSealMultiple.toString() : values.edit_seal;
            values.headoffice_file = fileNameHeadOfficeMultiple.toString() !== "" ? fileNameHeadOfficeMultiple.toString() : values.headoffice_file;
            values.objective_add_file = fileNameObjectiveAddMultiple.toString() !== "" ? fileNameObjectiveAddMultiple.toString() : values.objective_add_file;
            values.objective_edit_file = fileNameObjectiveEditMultiple.toString() !== "" ? fileNameObjectiveEditMultiple.toString() : values.objective_edit_file;
            values.bylaws_add_file = fileNameBylawAddMultiple.toString() !== "" ? fileNameBylawAddMultiple.toString() : values.bylaws_add_file;
            values.bylaws_edit_file = fileNameBylawEditMultiple.toString() !== "" ? fileNameBylawEditMultiple.toString() : values.bylaws_edit_file;
            values.dtc_liquidatoroffice_file = fileNameLiquidatorMultiple.toString() !== "" ? fileNameLiquidatorMultiple.toString() : values.dtc_liquidatoroffice_file;
            values.col_balancesheet_file = fileNameBalancesheetMultiple.toString() !== "" ? fileNameBalancesheetMultiple.toString() : values.col_balancesheet_file;
            values.col_docs_file = fileNameDocsMultiple.toString() !== "" ? fileNameDocsMultiple.toString() : values.col_docs_file;
            values.file_edit_seal = fileEditSeal;
            values.file_headoffice_file = fileHeadOffice;
            values.file_objective_add_file = fileObjectiveAdd;
            values.file_objective_edit_file = fileObjectiveEdit;
            values.file_bylaws_add_file = fileBylawAdd;
            values.file_bylaws_edit_file = fileBylawEdit;
            values.file_dtc_liquidatoroffice_file = fileLiquidator;
            values.file_col_balancesheet_file = fileBalancesheet;
            values.file_col_docs_file = fileDocs;
            values.id_business_unit = companyDisabled === true ? "-1" : values.id_business_unit;
            // values.business_unit_other = otherCompanyDisabled === true ? "" : values.business_unit_other;
            values.id_confidential_level = values?.id_confidential_level === null ? "" : String(values?.id_confidential_level);
            values.id_workflow_status = dataFormRequest.id_workflow_status;
            values.legal_authorized = emailLegalAuthorized;
            values.legal_admin = emailLegalAdmin;
            values.approve_request_by = values.approve_request_by?.toLowerCase();
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();

            values.col_docs_ship_date = values.col_docs_ship_date === "" ? null : values.col_docs_ship_date;
            values.col_docs_sent_date = values.col_docs_sent_date === "" ? null : values.col_docs_sent_date;

            values.col_acknowledged = values.col_acknowledged === "" ? "0" : values.col_acknowledged;

            if (Array.isArray(values.iccap_acknowledged) && values.iccap_acknowledged.includes("on") || values.iccap_acknowledged === "1") {
                values.iccap_acknowledged = "1";
            } else {
                values.iccap_acknowledged = "0";
            }
            const arrฺAddBranchOffice = getFillArray(values.doc_add_branch, 5, modelAddFormBranch);
            const valueAddBranchOffice = arrฺAddBranchOffice.reduce((acc, item, index) => {
                acc[`branchoffice_ic_location_${index + 1}`] = item.branchoffice_ic_location ?? "";
                acc[`branchoffice_ic_tel_${index + 1}`] = item.branchoffice_ic_tel ?? "";
                acc[`branchoffice_ic_email_${index + 1}`] = item.branchoffice_ic_email ?? "";
                acc[`branchoffice_ic_fax_${index + 1}`] = item.branchoffice_ic_fax ?? "";
                acc[`branchoffice_ic_file_${index + 1}`] = item.branchoffice_ic_file ?? "";
                acc[`file_branchoffice_ic_file_${index + 1}`] = item.file_branchoffice_ic_file ?? [];
                return acc;
            }, {});
            const arrCloseBranchOffice = getFillArray(values.doc_close_branch, 5, modelCloseFormBranch);
            const valueCloseBranchOffice = arrCloseBranchOffice.reduce((acc, item, index) => {
                acc[`branchoffice_dc_location_${index + 1}`] = item.branchoffice_dc_location ?? "";
                return acc;
            }, {});
            const arrEditBranchOffice = getFillArray(values.doc_edit_branch, 5, modelEditFormBranch);
            const valueEditBranchOffice = arrEditBranchOffice.reduce((acc, item, index) => {
                acc[`branchoffice_edit_clocation_${index + 1}`] = item.branchoffice_edit_clocation ?? "";
                acc[`branchoffice_edit_nlocation_${index + 1}`] = item.branchoffice_edit_nlocation ?? "";
                return acc;
            }, {});
            const arrLiquidator = getFillArray(values.doc_liquidator, 5, modelLiquidator);
            const valueLiquidator = arrLiquidator.reduce((acc, item, index) => {
                acc[`dtc_liquidator_${index + 1}`] = item.dtc_liquidator ?? "";
                return acc;
            }, {});
            const arrFormAuditor = getFillArray(values.doc_auditor, 5, modelAuditor);
            const valueAuditor = arrFormAuditor.reduce((acc, item, index) => {
                acc[`dtc_Auditor_${index + 1}`] = item.dtc_auditor ?? "";
                return acc;
            }, {});
            const arrCtp = getFillArray(values.doc_ctp, 5, modelCtp);
            const valueCtp = arrCtp.reduce((acc, item, index) => {
                acc[`ts_ctp_transferor_${index + 1}`] = item.ts_ctp_transferor ?? "";
                acc[`ts_ctp_transferee_${index + 1}`] = item.ts_ctp_transferee ?? "";
                acc[`ts_ctp_amountshare_${index + 1}`] = item.ts_ctp_amountshare ?? "";
                acc[`ts_ctp_pershare_${index + 1}`] = item.ts_ctp_pershare === "" ? null : item.ts_ctp_pershare?.replace(/,/g, '');
                acc[`ts_ctp_totalshare_${index + 1}`] = item.ts_ctp_totalshare === "" ? null : item.ts_ctp_totalshare?.replace(/,/g, '');
                acc[`ts_ctp_paydate_${index + 1}`] = item.ts_ctp_paydate === "" ? null : item.ts_ctp_paydate;
                acc[`ts_ctp_file_${index + 1}`] = item.ts_ctp_file ?? "";
                acc[`file_ts_ctp_file_${index + 1}`] = item.file_ts_ctp_file ?? [];
                return acc;
            }, {});
            const arrCodOut = getFillArray(values.doc_cod_out, 10, modelCodOut);
            const valueCodOut = arrCodOut.reduce((acc, item, index) => {
                acc[`cod_out_name_${index + 1}`] = item.cod_out_name ?? "";
                acc[`cod_out_name_en_${index + 1}`] = item.cod_out_name_en ?? "";
                return acc;
            }, {});
            const arrCodAdd = getFillArray(values.doc_cod_add, 10, modelCodAdd);
            const valueCodAdd = arrCodAdd.reduce((acc, item, index) => {
                acc[`cod_add_name_${index + 1}`] = item.cod_add_name ?? "";
                acc[`cod_add_name_en_${index + 1}`] = item.cod_add_name_en ?? "";
                acc[`cod_add_tel_${index + 1}`] = item.cod_add_tel ?? "";
                acc[`cod_add_email_${index + 1}`] = item.cod_add_email ?? "";
                acc[`cod_add_file_${index + 1}`] = item.cod_add_file ?? "";
                acc[`file_cod_add_file_${index + 1}`] = item.file_cod_add_file ?? [];
                return acc;
            }, {});

            const data = Object.assign({}, values, valueAddBranchOffice, valueCloseBranchOffice, valueEditBranchOffice, valueLiquidator, valueAuditor, valueCtp, valueCodOut, valueCodAdd);

            onSave(data);
        }
    });

    const validationDraft = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_business_unit: dataDetail.id_business_unit || "",
            business_unit_other: dataDetail.business_unit_other || "",
            iccap_regiscap_amount: dataDetail.iccap_regiscap_amount || null,
            iccap_regiscap_commonstock: dataDetail.iccap_regiscap_commonstock || null,
            iccap_regiscap_preferredstock: dataDetail.iccap_regiscap_preferredstock || null,
            iccap_regiscap_valuepershare: dataDetail.iccap_regiscap_valuepershare || null,
            iccap_addcap_amount: dataDetail.iccap_addcap_amount || null,
            iccap_addcap_commonstock: dataDetail.iccap_addcap_commonstock || null,
            iccap_addcap_preferredstock: dataDetail.iccap_addcap_preferredstock || null,
            iccap_addcap_valuepershare: dataDetail.iccap_addcap_valuepershare || null,
            iccap_newcap_amount: dataDetail.iccap_newcap_amount || null,
            iccap_newcap_stock: dataDetail.iccap_newcap_stock || null,
            iccap_newcap_valuepershare: dataDetail.iccap_newcap_valuepershare || null,
            iccap_paymentpershare: dataDetail.iccap_paymentpershare || null,
            iccap_paymentdate: dataDetail.iccap_paymentdate || null,
            iccap_bank_account: dataDetail.iccap_bank_account || "",
            iccap_bank_name: dataDetail.iccap_bank_name || "",
            iccap_bank_no: dataDetail.iccap_bank_no || "",
            iccap_bank_branch: dataDetail.iccap_bank_branch || "",
            iccap_acknowledged: dataDetail.iccap_acknowledged || "",
            dccap_regiscap_amount: dataDetail.dccap_regiscap_amount || null,
            dccap_regiscap_commonstock: dataDetail.dccap_regiscap_commonstock || null,
            dccap_regiscap_preferredstock: dataDetail.dccap_regiscap_preferredstock || null,
            dccap_regiscap_valuepershare: dataDetail.dccap_regiscap_valuepershare || null,
            dccap_reducap_amount: dataDetail.dccap_reducap_amount || null,
            dccap_reducap_type: dataDetail.dccap_reducap_type || null,
            dccap_reducap_commonstock: dataDetail.dccap_reducap_commonstock || null,
            dccap_reducap_preferredstock: dataDetail.dccap_reducap_preferredstock || null,
            dccap_reducap_valuepershare: dataDetail.dccap_reducap_valuepershare || null,
            dccap_newcap_amount: dataDetail.dccap_newcap_amount || null,
            dccap_newcap_commonstock: dataDetail.dccap_newcap_commonstock || null,
            dccap_newcap_preferredstock: dataDetail.dccap_newcap_preferredstock || null,
            dccap_newcap_valuepershare: dataDetail.dccap_newcap_valuepershare || null,
            dccap_after_reducap: dataDetail.dccap_after_reducap || "",
            edit_name_th: dataDetail.edit_name_th || "",
            edit_name_en: dataDetail.edit_name_en || "",
            edit_seal_ink: dataDetail.edit_seal_ink || "",
            edit_seal: dataDetail.edit_seal || "",
            headoffice_clocation: dataDetail.headoffice_clocation || "",
            headoffice_nlocation_th: dataDetail.headoffice_nlocation_th || "",
            headoffice_nlocation_en: dataDetail.headoffice_nlocation_en || "",
            headoffice_file: dataDetail.headoffice_file || "",
            doc_add_branch: formAddBranchOffice || [{...modelAddFormBranch}],
            doc_close_branch: formCloseBranchOffice || [{...modelCloseFormBranch}],
            doc_edit_branch: formEditBranchOffice || [{...modelEditFormBranch}],
            doc_liquidator: formLiquidator || [{...modelLiquidator}],
            doc_auditor: formAuditor || [{...modelAuditor}],
            doc_ctp: formCtp || [{...modelCtp}],
            doc_cod_out: formCodOut || [{...modelCodOut}],
            doc_cod_add: formCodAdd || [{...modelCodAdd}],
            cod_out_select: dataDetail.cod_out_select || "0",
            cod_add_select: dataDetail.cod_add_select || "0",
            branchoffice_ic_select: dataDetail.branchoffice_ic_select || "",
            branchoffice_dc_select: dataDetail.branchoffice_dc_select || "",
            branchoffice_edit_select: dataDetail.branchoffice_edit_select || "",
            objective_add_select: dataDetail.objective_add_select || "",
            objective_add_file: dataDetail.objective_add_file || "",
            objective_add_other: dataDetail.objective_add_other || "",
            objective_edit_select: dataDetail.objective_edit_select || "",
            objective_edit_file: dataDetail.objective_edit_file || "",
            objective_edit_other: dataDetail.objective_edit_other || "",
            objective_main_select: dataDetail.objective_main_select || "0",
            objective_main_other: dataDetail.objective_main_other || "",
            bylaws_add_select: dataDetail.bylaws_add_select || "",
            bylaws_add_file: dataDetail.bylaws_add_file || "",
            bylaws_edit_select: dataDetail.bylaws_edit_select || "",
            bylaws_edit_file: dataDetail.bylaws_edit_file || "",
            cod_current_powerofdirector: dataDetail.cod_current_powerofdirector || "",
            cod_new_powerofdirector: dataDetail.cod_new_powerofdirector || "",
            cod_remark: dataDetail.cod_remark || "",
            coa_share_bath: dataDetail.coa_share_bath || "",
            coa_share_number: dataDetail.coa_share_number || "",
            coa_share_addition: dataDetail.coa_share_addition || "",
            coa_share_total: dataDetail.coa_share_total || "",
            coa_share_date: dataDetail.coa_share_date || null,
            dtc_powerofliquidator: dataDetail.dtc_powerofliquidator || "",
            dtc_liquidatoroffice_name: dataDetail.dtc_liquidatoroffice_name || "",
            dtc_liquidatoroffice_file: dataDetail.dtc_liquidatoroffice_file || "",
            dtc_auditoroffice: dataDetail.dtc_auditoroffice || "",
            dtc_auditorfee: dataDetail.dtc_auditorfee || null,
            dtc_remark: dataDetail.dtc_remark || "",
            col_balancesheet_file: dataDetail.col_balancesheet_file || "",
            col_docs_file: dataDetail.col_docs_file || "",
            col_acknowledged: dataDetail.col_acknowledged || "",
            col_docs_ship_date: dataDetail.col_docs_ship_date || "",
            col_docs_sent_date: dataDetail.col_docs_sent_date || "",
            other_title: dataDetail.other_title || "",
            other_detail: dataDetail.other_detail || "",
            iccap_select: dataDetail.iccap_select || "",
            dccap_select: dataDetail.dccap_select || "",
            edit_name_select: dataDetail.edit_name_select || "",
            edit_seal_select: dataDetail.edit_seal_select || "",
            headoffice_select: dataDetail.headoffice_select || "",
            branchoffice_select: dataDetail.branchoffice_select || "",
            objective_select: dataDetail.objective_select || "",
            bylaws_select: dataDetail.bylaws_select || "",
            cod_select: dataDetail.cod_select || "",
            coa_select: dataDetail.coa_select || "",
            ts_select: dataDetail.ts_select || "",
            dtc_select: dataDetail.dtc_select || "",
            col_select: dataDetail.col_select || "",
            other_select: dataDetail.other_select || "",
            id_confidential_level: dataDetail.id_confidential_level || 0,
            user_comment: dataDetail.user_comment || "",
            check_user_email: dataFormRequest?.create_request_by || dataDetail?.create_request_by || userEmail,
            require_handled_by: dataFormRequest?.require_handled_by || dataDetail?.require_handled_by || "",
            approve_request_by: dataFormRequest?.approve_request_by || dataDetail?.approve_request_by || "",
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
            create_request_by: dataFormRequest?.create_request_by || dataDetail?.create_request_by || "",
            check_request_no: dataFormRequest?.request_no || "",
        },
        onSubmit: (values) => {
             // แปลงฟิลด์ที่ต้องการให้เป็น `int` และค่าว่างเป็น `null`
            const intFields = ['ts_ctp_pershare_1', 'ts_ctp_pershare_2', 'ts_ctp_pershare_3', 'ts_ctp_pershare_4', 'ts_ctp_pershare_5', 'id_confidential_level']; // ใส่ชื่อฟิลด์ที่ต้องการแปลงที่นี่
            const nullOnlyFields = ['iccap_regiscap_amount', 'iccap_regiscap_commonstock', 'iccap_regiscap_preferredstock', 'iccap_regiscap_valuepershare', 'iccap_addcap_amount', 'iccap_addcap_commonstock'
                ,'iccap_addcap_preferredstock', 'iccap_addcap_valuepershare', 'iccap_newcap_amount', 'iccap_newcap_stock', 'iccap_newcap_valuepershare', 'iccap_paymentpershare', 'iccap_paymentdate'
                ,'dccap_regiscap_amount', 'dccap_regiscap_commonstock', 'dccap_regiscap_preferredstock', 'dccap_regiscap_valuepershare', 'dccap_reducap_amount', 'dccap_reducap_type', 'dccap_reducap_commonstock'
                ,'dccap_reducap_preferredstock', 'dccap_reducap_valuepershare', 'dccap_newcap_amount', 'dccap_newcap_commonstock', 'dccap_newcap_preferredstock', 'dccap_newcap_valuepershare', 'coa_share_date'
                ,'ts_ctp_amountshare_1', 'ts_ctp_totalshare_1', 'ts_ctp_paydate_1', 'ts_ctp_amountshare_2', 'ts_ctp_totalshare_2', 'ts_ctp_paydate_2', 'ts_ctp_amountshare_3', 'ts_ctp_totalshare_3', 'ts_ctp_paydate_3', 'ts_ctp_amountshare_4', 'ts_ctp_totalshare_4', 'ts_ctp_paydate_4', 'ts_ctp_amountshare_5', 'ts_ctp_totalshare_5', 'ts_ctp_paydate_5', 
                ,'dtc_auditorfee'];

            intFields.forEach((field) => {
                if (values[field] === "") {
                    values[field] = null; // แปลงค่าว่างเป็น null
                } else if (values[field] !== undefined && values[field] !== null) {
                    values[field] = parseInt(values[field], 10); // แปลงเป็น int ถ้าไม่เป็นค่าว่าง
                }
            });

             // แปลงฟิลด์ที่ต้องการให้ค่าว่างเป็น null โดยไม่แปลงเป็น int
            nullOnlyFields.forEach((field) => {
                if (values[field] === "") {
                    values[field] = null; // แปลงค่าว่างเป็น null
                } else if (typeof values[field] === 'string' && field !== 'iccap_addcap_valuepershare') {
                    values[field] = values[field].toString().replace(/,/g, '');
                }
            });

            const fieldNames = [
                "iccap_select", "dccap_select", "edit_name_select", "edit_seal_select",
                "headoffice_select", "branchoffice_select", "objective_select", "bylaws_select",
                "cod_select", "coa_select", "ts_select", "dtc_select", "col_select", "other_select"
            ];
        
            fieldNames.forEach(field => {
                if (dataFormDbd.id > 0) {
                    // ตรวจสอบว่าค่าใน checkboxes เปลี่ยนแปลงจากค่าเริ่มต้น ("0")
                    values[field] = checkboxes[field] !== "0" ? checkboxes[field] : values[field];
                } else {
                    // ใช้ค่าจาก checkboxes โดยตรง
                    values[field] = checkboxes[field];
                }
            });
            values.request_no = dataFormRequest.request_no; // check request_no
            values.edit_seal = fileNameEditSealMultiple.toString() !== "" ? fileNameEditSealMultiple.toString() : values.edit_seal;
            values.headoffice_file = fileNameHeadOfficeMultiple.toString() !== "" ? fileNameHeadOfficeMultiple.toString() : values.headoffice_file;
            values.objective_add_file = fileNameObjectiveAddMultiple.toString() !== "" ? fileNameObjectiveAddMultiple.toString() : values.objective_add_file;
            values.objective_edit_file = fileNameObjectiveEditMultiple.toString() !== "" ? fileNameObjectiveEditMultiple.toString() : values.objective_edit_file;
            values.bylaws_add_file = fileNameBylawAddMultiple.toString() !== "" ? fileNameBylawAddMultiple.toString() : values.bylaws_add_file;
            values.bylaws_edit_file = fileNameBylawEditMultiple.toString() !== "" ? fileNameBylawEditMultiple.toString() : values.bylaws_edit_file;
            values.dtc_liquidatoroffice_file = fileNameLiquidatorMultiple.toString() !== "" ? fileNameLiquidatorMultiple.toString() : values.dtc_liquidatoroffice_file;
            values.col_balancesheet_file = fileNameBalancesheetMultiple.toString() !== "" ? fileNameBalancesheetMultiple.toString() : values.col_balancesheet_file;
            values.col_docs_file = fileNameDocsMultiple.toString() !== "" ? fileNameDocsMultiple.toString() : values.col_docs_file;
            values.file_edit_seal = fileEditSeal;
            values.file_headoffice_file = fileHeadOffice;
            values.file_objective_add_file = fileObjectiveAdd;
            values.file_objective_edit_file = fileObjectiveEdit;
            values.file_bylaws_add_file = fileBylawAdd;
            values.file_bylaws_edit_file = fileBylawEdit;
            values.file_dtc_liquidatoroffice_file = fileLiquidator;
            values.file_col_balancesheet_file = fileBalancesheet;
            values.file_col_docs_file = fileDocs;
            values.id_business_unit = companyDisabled === true ? "-1" : (values.id_business_unit !== "") ? parseInt(values.id_business_unit) : 0;
            // values.id_business_unit = companyDisabled === true ? "-1" : values.id_business_unit;
            // values.business_unit_other = otherCompanyDisabled === true ? "" : values.business_unit_other;
            values.id_confidential_level = values?.id_confidential_level === null ? "" : String(values?.id_confidential_level);
            // values.approve_request_by = values.approve_request_by?.toLowerCase() === userEmail ? "" : values.approve_request_by?.toLowerCase();
            if(dataFormRequest?.request_no === undefined || dataFormRequest?.request_no === "draft"){
                values.approve_request_by = values.approve_request_by?.toLowerCase() === userEmail.toLowerCase() ? "" : values.approve_request_by?.toLowerCase();
            } else {
                values.approve_request_by = values.approve_request_by?.toLowerCase();
            }
            values.require_handled_by = values.require_handled_by?.toLowerCase();
            values.create_request_by = values.create_request_by?.toLowerCase();

            values.col_docs_ship_date = values.col_docs_ship_date === "" ? null : values.col_docs_ship_date;
            values.col_docs_sent_date = values.col_docs_sent_date === "" ? null : values.col_docs_sent_date;

            values.col_acknowledged = values.col_acknowledged === "" ? "0" : values.col_acknowledged;

            if (Array.isArray(values.iccap_acknowledged) && values.iccap_acknowledged.includes("on") || values.iccap_acknowledged === "1") {
                values.iccap_acknowledged = "1";
            } else {
                values.iccap_acknowledged = "0";
            }
            const arrฺAddBranchOffice = getFillArray(values.doc_add_branch, 5, modelAddFormBranch);
            const valueAddBranchOffice = arrฺAddBranchOffice.reduce((acc, item, index) => {
                acc[`branchoffice_ic_location_${index + 1}`] = item.branchoffice_ic_location ?? "";
                acc[`branchoffice_ic_tel_${index + 1}`] = item.branchoffice_ic_tel ?? "";
                acc[`branchoffice_ic_email_${index + 1}`] = item.branchoffice_ic_email ?? "";
                acc[`branchoffice_ic_fax_${index + 1}`] = item.branchoffice_ic_fax ?? "";
                acc[`branchoffice_ic_file_${index + 1}`] = item.branchoffice_ic_file ?? "";
                acc[`file_branchoffice_ic_file_${index + 1}`] = item.file_branchoffice_ic_file ?? [];
                return acc;
            }, {});
            const arrCloseBranchOffice = getFillArray(values.doc_close_branch, 5, modelCloseFormBranch);
            const valueCloseBranchOffice = arrCloseBranchOffice.reduce((acc, item, index) => {
                acc[`branchoffice_dc_location_${index + 1}`] = item.branchoffice_dc_location ?? "";
                return acc;
            }, {});
            const arrEditBranchOffice = getFillArray(values.doc_edit_branch, 5, modelEditFormBranch);
            const valueEditBranchOffice = arrEditBranchOffice.reduce((acc, item, index) => {
                acc[`branchoffice_edit_clocation_${index + 1}`] = item.branchoffice_edit_clocation ?? "";
                acc[`branchoffice_edit_nlocation_${index + 1}`] = item.branchoffice_edit_nlocation ?? "";
                return acc;
            }, {});
            const arrLiquidator = getFillArray(values.doc_liquidator, 5, modelLiquidator);
            const valueLiquidator = arrLiquidator.reduce((acc, item, index) => {
                acc[`dtc_liquidator_${index + 1}`] = item.dtc_liquidator ?? "";
                return acc;
            }, {});
            const arrFormAuditor = getFillArray(values.doc_auditor, 5, modelAuditor);
            const valueAuditor = arrFormAuditor.reduce((acc, item, index) => {
                acc[`dtc_Auditor_${index + 1}`] = item.dtc_auditor ?? "";
                return acc;
            }, {});
            const arrCtp = getFillArray(values.doc_ctp, 5, modelCtp);
            const valueCtp = arrCtp.reduce((acc, item, index) => {
                acc[`ts_ctp_transferor_${index + 1}`] = item.ts_ctp_transferor ?? "";
                acc[`ts_ctp_transferee_${index + 1}`] = item.ts_ctp_transferee ?? "";
                acc[`ts_ctp_amountshare_${index + 1}`] = item.ts_ctp_amountshare ?? "";
                acc[`ts_ctp_pershare_${index + 1}`] = item.ts_ctp_pershare === "" ? null : item.ts_ctp_pershare?.replace(/,/g, '');
                acc[`ts_ctp_totalshare_${index + 1}`] = item.ts_ctp_totalshare === "" ? null : item.ts_ctp_totalshare?.replace(/,/g, '');
                acc[`ts_ctp_paydate_${index + 1}`] = item.ts_ctp_paydate === "" ? null : item.ts_ctp_paydate;
                acc[`ts_ctp_file_${index + 1}`] = item.ts_ctp_file ?? "";
                acc[`file_ts_ctp_file_${index + 1}`] = item.file_ts_ctp_file ?? [];
                return acc;
            }, {});
            const arrCodOut = getFillArray(values.doc_cod_out, 10, modelCodOut);
            const valueCodOut = arrCodOut.reduce((acc, item, index) => {
                acc[`cod_out_name_${index + 1}`] = item.cod_out_name ?? "";
                acc[`cod_out_name_en_${index + 1}`] = item.cod_out_name_en ?? "";
                return acc;
            }, {});
            const arrCodAdd = getFillArray(values.doc_cod_add, 10, modelCodAdd);
            const valueCodAdd = arrCodAdd.reduce((acc, item, index) => {
                acc[`cod_add_name_${index + 1}`] = item.cod_add_name ?? "";
                acc[`cod_add_name_en_${index + 1}`] = item.cod_add_name_en ?? "";
                acc[`cod_add_tel_${index + 1}`] = item.cod_add_tel ?? "";
                acc[`cod_add_email_${index + 1}`] = item.cod_add_email ?? "";
                acc[`cod_add_file_${index + 1}`] = item.cod_add_file ?? "";
                acc[`file_cod_add_file_${index + 1}`] = item.file_cod_add_file ?? [];
                return acc;
            }, {});

            const data = Object.assign({}, values, valueAddBranchOffice, valueCloseBranchOffice, valueEditBranchOffice, valueLiquidator, valueAuditor, valueCtp, valueCodOut, valueCodAdd);

            onSaveDraft(data);
        }
    });

     // fields To Keep
     const fieldsToKeep = 
     [
         'id', 'id_businessunit', 'user_comment', 'check_user_email', 'require_handled_by', 
         'approve_request_by', 'approver_comment', 'create_request_by'
     ];
     
     useEffect(() => {
         const currentValues = validation.values;
         const currentValuesDraft = validationDraft.values;
 
         const newValues = Object.keys(currentValues).reduce((acc, key) => {
             if (fieldsToKeep.includes(key)) {
                 acc[key] = currentValues[key];
             } else {
                 acc[key] = validation.initialValues[key] || ''; 
             }
             return acc;
         }, {});

         const newValuesDraft = Object.keys(currentValuesDraft).reduce((acc, key) => {
            if (fieldsToKeep.includes(key)) {
                acc[key] = currentValues[key];
            } else {
                acc[key] = validationDraft.initialValues[key] || ''; 
            }
            return acc;
        }, {});
 
         validation.setValues(newValues);
         validationDraft.setValues(newValuesDraft);
     }, [validation.initialValues, validationDraft.initialValues]);

     // Synchronize local formAddBranchOffice with Formik values
     useEffect(() => {
        validation.setFieldValue('checkboxes', checkboxes);
        validationDraft.setFieldValue('checkboxes', checkboxes);
    }, [checkboxes]);

    const validationReturn = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_request: dataDetail.id_request || 0,
            id_request_type: dataDetail.id_request_type || 0,
            id_sub_request_type: dataDetail.id_sub_request_type || 0,
            id_sub_division_request_type: dataDetail.id_sub_division_request_type || 0,
            approver_comment: dataFormRequest?.approver_comment || dataDetail?.approver_comment || "",
        },
        validationSchema: Yup.object({
            // approver_comment: Yup.string().when('showCommentApprover', {
            //     is: false,
            //     then: Yup.string().required('Please enter a Comment.'),
            //     otherwise: Yup.string(),
            // }),
            approver_comment: Yup.string().trim().required("กรุณาระบุความเห็นเพิ่มเติม"),
        }),
        onSubmit: (values) => {
            //console.log(values);
        }
    });

    const resetFields = (name) => {
        let resetValue = null;
        if (name === "iccap_select") {
            const fieldsToReset = [
                "iccap_regiscap_amount",
                "iccap_regiscap_commonstock",
                "iccap_regiscap_preferredstock",
                "iccap_regiscap_valuepershare",
                "iccap_addcap_amount",
                "iccap_addcap_commonstock",
                "iccap_addcap_preferredstock",
                "iccap_addcap_valuepershare",
                "iccap_newcap_amount",
                "iccap_newcap_stock",
                "iccap_newcap_valuepershare",
                "iccap_paymentpershare",
                "iccap_paymentdate",
                "iccap_bank_account",
                "iccap_bank_name",
                "iccap_bank_no",
                "iccap_bank_branch",
                "iccap_acknowledged"
            ];
        
            fieldsToReset.forEach(field => {
                if (["iccap_bank_account", "iccap_bank_name", "iccap_bank_no", "iccap_bank_branch", "iccap_acknowledged"].includes(field)) {
                    resetValue = "";
                }
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });
        
            setStartDate("");
            setCheckboxIccapAcknowledged("0");
        } else if(name === "dccap_select"){
            const fieldsToReset = [
                "dccap_regiscap_amount",
                "dccap_regiscap_commonstock",
                "dccap_regiscap_preferredstock",
                "dccap_regiscap_valuepershare",
                "dccap_reducap_amount",
                "dccap_reducap_type",
                "dccap_reducap_commonstock",
                "dccap_reducap_preferredstock",
                "dccap_reducap_valuepershare",
                "dccap_newcap_amount",
                "dccap_newcap_commonstock",
                "dccap_newcap_preferredstock",
                "dccap_newcap_valuepershare",
            ];

            fieldsToReset.forEach(field => {
                if (["dccap_reducap_type"].includes(field)) {
                    resetValue = "";
                }
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setSelectRadioDecrease("0");
        } else if(name === "edit_name_select"){
            const fieldsToReset = [
                "edit_name_th",
                "edit_name_en",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

        } else if(name === "edit_seal_select"){
            const fieldsToReset = [
                "edit_seal_ink",
                "edit_seal",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });
            
            setFileEditSeal([]);
            setFileNameEditSealMultiple("");

        } else if(name === "headoffice_select"){
            const fieldsToReset = [
                "headoffice_clocation",
                "headoffice_nlocation_th",
                "headoffice_nlocation_en",
                "headoffice_file",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });
            
            setFileHeadOffice([]);
        } else if(name === "branchoffice_select"){
            const fieldsToReset = [
                "branchoffice_ic_select",
                "doc_add_branch",
                "branchoffice_dc_select",
                "doc_close_branch",
                "branchoffice_edit_select",
                "doc_edit_branch",
            ];

            fieldsToReset.forEach(field => {
                if(["doc_add_branch"].includes(field)){
                    resetValue = [{ ...modelAddFormBranch }];
                } else if(["doc_close_branch"].includes(field)){
                    resetValue = [{ ...modelCloseFormBranch }];
                } else if(["doc_edit_branch"].includes(field)){
                    resetValue = [{ ...modelEditFormBranch }];
                } else {
                    resetValue = "";
                }
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setCheckboxIcSelect("0");
            setCheckboxDcSelect("0");
            setCheckboxOtSelect("0");

            setFormAddBranchOffice([{...modelAddFormBranch}]);
            setFormCloseBranchOffice([{...modelCloseFormBranch}]);
            setFormEditBranchOffice([{...modelEditFormBranch}]);
            setFileBranchOffice(setStringFileNameToArray(""));

        } else if(name === "objective_select"){
            const fieldsToReset = [
                "objective_add_select",
                "objective_add_file",
                "objective_add_other",
                "objective_edit_select",
                "objective_edit_file",
                "objective_edit_other",
                "objective_main_select",
                "objective_main_other",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setCheckboxObjectiveAdd("0");
            setCheckboxObjectiveEdit("0");
            setCheckboxObjectiveMain("0");

            setFileObjectiveAdd([]);
            setFileObjectiveEdit([]);

        } else if(name === "bylaws_select"){
            const fieldsToReset = [
                "bylaws_add_select",
                "bylaws_add_file",
                "bylaws_edit_select",
                "bylaws_edit_file",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setIscheckedBylawAddSelect("0");
            setIscheckedBylawEditSelect("0");
            
            setFileBylawAdd([]);
            setFileBylawEdit([]);
            
        } else if(name === "cod_select"){
            const fieldsToReset = [
                "doc_cod_out",
                "doc_cod_add",
                "cod_current_powerofdirector",
                "cod_new_powerofdirector",
                "cod_remark",
            ];

            fieldsToReset.forEach(field => {
                if(["doc_cod_out"].includes(field)){
                    resetValue = [{ ...modelCodOut }];
                } else if(["doc_cod_add"].includes(field)){
                    resetValue = [{ ...modelCodAdd }];
                } else {
                    resetValue = "";
                }
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setFormCodOut([{...modelCodOut}]);
            setFormCodAdd([{...modelCodAdd}]);
           
            setFileCod(setStringFileNameToArray(""));

            setCheckBoxCodOut("0");
            setCheckBoxCodAdd("0");

        } else if(name === "coa_select"){
            const fieldsToReset = [
                "coa_share_bath",
                "coa_share_number",
                "coa_share_addition",
                "coa_share_total",
                "coa_share_date",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setCoaShareDate("");
            
        } else if(name === "ts_select"){
            const fieldsToReset = [
                "doc_ctp",
            ];

            fieldsToReset.forEach(field => {
                if (["doc_ctp"].includes(field)) {
                    resetValue = "";
                }
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });

            setFormCtp([{...modelCtp}]);
            setFileCtp(setStringFileNameToArray(""));

        } else if(name === "dtc_select"){
            const fieldsToReset = [
                "dtc_powerofliquidator",
                "dtc_liquidatoroffice_name",
                "dtc_liquidatoroffice_file",
                "dtc_auditoroffice",
                "dtc_auditorfee",
                "doc_liquidator",
                "doc_auditor",
                "dtc_liquidator_1",
                "dtc_liquidator_2",
                "dtc_liquidator_3",
                "dtc_liquidator_4",
                "dtc_liquidator_5",
                "dtc_auditor_1",
                "dtc_auditor_2",
                "dtc_auditor_3",
                "dtc_auditor_4",
                "dtc_auditor_5",
            ];
            
            fieldsToReset.forEach(field => {
                let resetType = "";
                if (["dtc_auditorfee"].includes(field)) {
                    resetType = null;
                } else if(["doc_liquidator"].includes(field)){
                    resetType = [{ ...modelLiquidator }];
                } else if(["doc_auditor"].includes(field)){
                    resetType = [{ ...modelAuditor }];
                } else {
                    resetType = "";
                }
                validation.setFieldValue(field, resetType);
                validationDraft.setFieldValue(field, resetType);
            });

            setFileLiquidator([]);
            setFormLiquidator([{ ...modelLiquidator }]);
            setFormAuditor([{ ...modelAuditor }]);

        } else if(name === "col_select"){
            const fieldsToReset = [
                "col_balancesheet_file",
                "col_docs_file",
                "col_acknowledged",
                "col_docs_ship_date",
                "col_docs_sent_date",
            ];

            fieldsToReset.forEach(field => {
                let resetType = "";
                if (["col_docs_ship_date"].includes(field) || ["col_docs_sent_date"].includes(field)) {
                    resetType = null;
                } else {
                    resetType = "";
                }
                validation.setFieldValue(field, resetType);
                validationDraft.setFieldValue(field, resetType);
            });

            setSelectRadioColAcknowledged("0");
            setFileBalancesheet([]);
            setFileDocs([]);
            setShipDate("");
            setSentDate("");
            
        } else if(name === "other_select"){
            const fieldsToReset = [
                "other_title",
                "other_detail",
            ];

            fieldsToReset.forEach(field => {
                resetValue = "";
                validation.setFieldValue(field, resetValue);
                validationDraft.setFieldValue(field, resetValue);
            });
        }
    };

    const OnClickPlusAddBranchOffice = () => {
        const newItem = {...modelAddFormBranch};
        if (validation.values.doc_add_branch.length < 5) {
            validation.setFieldValue("doc_add_branch", [...validation.values.doc_add_branch, newItem]);
            validationDraft.setFieldValue("doc_add_branch", [...validationDraft.values.doc_add_branch, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickMinusRemoveBranchOffice = (index) => {
        const itemToDelete = validation.values.doc_add_branch[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "")) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeAddBranchOffice(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeAddBranchOffice(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeAddBranchOffice = (index) => {
        const newItems = validation.values.doc_add_branch.filter((_, i) => i !== index);
        validation.setFieldValue("doc_add_branch", newItems);
        validationDraft.setFieldValue("doc_add_branch", newItems);
    
        // ลบไฟล์ที่ตำแหน่ง index เดียวกันใน fileBranchOffice
        const updatedFiles = fileBranchOffice.filter((_, i) => i !== index);
        setFileBranchOffice(updatedFiles);
    };

    const OnClickPlusCloseBranchOffice = () => {
        const newItem = {...modelCloseFormBranch};
        if (validation.values.doc_close_branch.length < 5) {
            validation.setFieldValue("doc_close_branch", [...validation.values.doc_close_branch, newItem]);
            validationDraft.setFieldValue("doc_close_branch", [...validationDraft.values.doc_close_branch, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickRemoveCloseBranchOffice = (index) => {
        const itemToDelete = validation.values.doc_close_branch[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "")) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeCloseBranchOffice(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeCloseBranchOffice(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeCloseBranchOffice = (index) => {
        const newItems = validation.values.doc_close_branch.filter((_, i) => i !== index);
        validation.setFieldValue("doc_close_branch", newItems);
        validationDraft.setFieldValue("doc_close_branch", newItems);
    };

    const OnClickPlusEditBranchOffice = () => {
        const newItem = {...modelEditFormBranch};
        if (validation.values.doc_edit_branch.length < 5) {
            validation.setFieldValue("doc_edit_branch", [...validation.values.doc_edit_branch, newItem]);
            validationDraft.setFieldValue("doc_edit_branch", [...validationDraft.values.doc_edit_branch, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickRemoveEditBranchOffice = (index) => {
        const itemToDelete = validation.values.doc_edit_branch[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "")) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeEditBranchOffice(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeEditBranchOffice(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeEditBranchOffice = (index) => {
        const newItems = validation.values.doc_edit_branch.filter((_, i) => i !== index);
        validation.setFieldValue("doc_edit_branch", newItems);
        validationDraft.setFieldValue("doc_edit_branch", newItems);
    };

    const OnClickPlusLiquidator = () => {
        const newItem = {...modelLiquidator};
        if (validation.values.doc_liquidator.length < 5) {
            validation.setFieldValue("doc_liquidator", [...validation.values.doc_liquidator, newItem]);
            validationDraft.setFieldValue("doc_liquidator", [...validationDraft.values.doc_liquidator, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickRemoveLiquidator = (index) => {
        const itemToDelete = validation.values.doc_liquidator[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "")) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeLiquidator(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeLiquidator(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeLiquidator = (index) => {
        const newItems = validation.values.doc_liquidator.filter((_, i) => i !== index);
        validation.setFieldValue("doc_liquidator", newItems);
        validationDraft.setFieldValue("doc_liquidator", newItems);
    };

    const OnClickPlusAuditor = () => {
        const newItem = {...modelAuditor};
        if (validation.values.doc_auditor.length < 5) {
            validation.setFieldValue("doc_auditor", [...validation.values.doc_auditor, newItem]);
            validationDraft.setFieldValue("doc_auditor", [...validationDraft.values.doc_auditor, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickRemoveAuditor = (index) => {
        const itemToDelete = validation.values.doc_auditor[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "")) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeAuditor(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeAuditor(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeAuditor = (index) => {
        const newItems = validation.values.doc_auditor.filter((_, i) => i !== index);
        validation.setFieldValue("doc_auditor", newItems);
        validationDraft.setFieldValue("doc_auditor", newItems);
    };

    const OnClickPlusCtp = () => {
        const newItem = {...modelCtp};
        if (validation.values.doc_ctp.length < 5) {
            validation.setFieldValue("doc_ctp", [...validation.values.doc_ctp, newItem]);
            validationDraft.setFieldValue("doc_ctp", [...validationDraft.values.doc_ctp, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickMinusRemoveCtp = (index) => {
        const itemToDelete = validation.values.doc_ctp[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "" && value !== null)) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeCtp(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeCtp(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeCtp = (index) => {
        const newItems = validation.values.doc_ctp.filter((_, i) => i !== index);
        validation.setFieldValue("doc_ctp", newItems);
        validationDraft.setFieldValue("doc_ctp", newItems);
    
        // ลบไฟล์ที่ตำแหน่ง index เดียวกันใน fileBranchOffice
        const updatedFiles = fileCtp.filter((_, i) => i !== index);
        setFileCtp(updatedFiles);
    };

    const OnClickPlusCodOut = () => {
        const newItem = {...modelCodOut};
        if (validation.values.doc_cod_out.length < 10) {
            validation.setFieldValue("doc_cod_out", [...validation.values.doc_cod_out, newItem]);
            validationDraft.setFieldValue("doc_cod_out", [...validationDraft.values.doc_cod_out, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickMinusRemoveCodOut = (index) => {
        const itemToDelete = validation.values.doc_cod_out[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "" && value !== null)) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeCodOut(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeCodOut(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeCodOut = (index) => {
        const newItems = validation.values.doc_cod_out.filter((_, i) => i !== index);
        validation.setFieldValue("doc_cod_out", newItems);
        validationDraft.setFieldValue("doc_cod_out", newItems);
    };

    const OnClickPlusCodAdd = () => {
        const newItem = {...modelCodAdd};
        if (validation.values.doc_cod_add.length < 10) {
            validation.setFieldValue("doc_cod_add", [...validation.values.doc_cod_add, newItem]);
            validationDraft.setFieldValue("doc_cod_add", [...validationDraft.values.doc_cod_add, newItem]);
        }
        setIsSaveEnabled(true);
    };

    const OnClickMinusRemoveCodAdd = (index) => {
        const itemToDelete = validation.values.doc_cod_add[index];
    
        if (itemToDelete && Object.values(itemToDelete).some(value => value !== "" && value !== null)) {
            // ถ้ามีข้อมูล ให้แสดง SweetAlert2 เพื่อยืนยันก่อนลบ
            Swal.fire({
                title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                html: `
                    คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                    <br>
                    Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                `,
                showCancelButton: true,
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#FEEFEF", 
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title-dbd',
                    htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                    image: 'custom-swal-image',
                    actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                    cancelButton: 'custom-swal-cancel',
                    confirmButton: 'custom-swal-remove',
                },
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    removeCodAdd(index);
                    Swal.fire({
                        iconHtml: IconBin,
                        title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                        showConfirmButton: false,
                        showCloseButton: true,
                    });
                }
            });
        } else {
            // ถ้าไม่มีข้อมูล ให้ลบได้เลยโดยไม่ต้องยืนยัน
            removeCodAdd(index);
        }
        setIsSaveEnabled(true);
    };
    
    const removeCodAdd = (index) => {
        const newItems = validation.values.doc_cod_add.filter((_, i) => i !== index);
        validation.setFieldValue("doc_cod_add", newItems);
        validationDraft.setFieldValue("doc_cod_add", newItems);
    
        const updatedFiles = fileCod.filter((_, i) => i !== index);
        setFileCod(updatedFiles);
    };

    return (
        <React.Fragment>
            <div id="form-request" className="form-request-memo">
            <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            validationDraft.handleSubmit();
                            validationReturn.handleSubmit();
                            return false;
                        }}
                    >
                        <div id="section-page-1-2">
                            <Row>
                                <Col xl={12} className="mx-auto">
                                    <div>​
                                        <span className="span-title">ข้อมูลทั่วไป (Request General Information)</span>
                                    </div>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col md={12} className="mx-auto">
                                    <Row>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label className="label-title">ประเภทคำขอ (Type of Request)</Label>
                                                <Input
                                                type="text"
                                                name="typeOfRequest"
                                                value={dataFormRequest.name_en_request_type ? dataFormRequest.name_en_request_type || "" : formTemp.name_en_request_type || ""}
                                                // onChange={onInputChanged}
                                                disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Label className="label-title">เรื่อง (Matters)</Label>
                                                <Input
                                                type="text"
                                                name="typeOfContract"
                                                value={dataFormRequest.name_en_sub_request_type ? dataFormRequest.name_en_sub_request_type || "" : formTemp.name_en_sub_request_type || ""}
                                                // onChange={onInputChanged}
                                                disabled
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                            <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCompanyName"></i>
                                            <div className="hstack flex-wrap gap-2">
                                                <UncontrolledPopover placement="right" target="PopoverRightCompanyName">
                                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุว่าจะเข้าทำสัญญาในนามของบริษัทในเครือรายใด หาก user ต้องการระบุชื่อบริษัทที่ไม่มีในรายชื่อบริษัท โปรดเลือก Others และกรอกชื่อบริษัทดังกล่าว<br/>Please indicate the company or affiliate name who is the party. If the party is not listed here, please select 'Others' and provide such company's name.</PopoverBody>
                                                </UncontrolledPopover>
                                            </div>
                                            <Label className="label-title">ชื่อบริษัท (Name of the Company)<span className="msg-require">*</span></Label>
                                            <Select id="ddlBusinessUnit"
                                                name="id_business_unit"
                                                value={selectCompany}
                                                className="txt-placeholder"
                                                placeholder={companyPlaceholder}
                                                onChange={(selected) => {
                                                    setSelectCompany(selected);
                                                    validation.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                                    validationDraft.handleChange("id_business_unit")((selected !== null) ? selected.value : "");
                                                    // handleSelectChangeCompany(selected);
                                                    setIsSaveEnabled(true);
                                                    if (selected && selected.value) {
                                                        LoadLegalAuthorized(selected.value);
                                                    }
                                                }}
                                                options={dataCompany}
                                                isClearable={true}
                                                isSearchable={true}
                                                invalid={ validation.touched.id_business_unit && validation.errors.id_business_unit ? true : false }
                                                isDisabled={companyDisabled} // Set disabled based on the variable
                                            />
                                            { validation.touched.id_business_unit && validation.errors.id_business_unit ? 
                                                ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.id_business_unit}</FormFeedback> ) : false 
                                            }
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <Input
                                                    type="checkbox"
                                                    name="checkbox_business_unit_other"
                                                    checked={isCheckedCompanyOther}
                                                    onChange={handleCheckboxChangeCompanyOther}
                                                    disabled={isDisableds}
                                                    />
                                                <Label className="label-title"> อื่นๆ (Others)</Label>
                                                <Input
                                                type="text"
                                                name="business_unit_other"
                                                className="txt-placeholder"
                                                autoComplete={autoCompletes}
                                                placeholder={otherCompanyPlaceholder}
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                                }}
                                                onBlur={validation.handleBlur}
                                                value={otherCompanyDisabled === true ? "" : validation.values.business_unit_other || ""}
                                                invalid={validation.touched.business_unit_other && validation.errors.business_unit_other ? true : false}
                                                disabled={otherCompanyDisabled}
                                                />
                                                {validation.touched.business_unit_other && validation.errors.business_unit_other ? (
                                                <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                                    {validation.errors.business_unit_other}
                                                </FormFeedback>
                                                ) : false}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={10}>
                                    <div className="line-border"></div>
                                </Col>
                            </Row>
                        </div>
                        <div id="section-page-1-3">
                            <Row>
                                <Col xl={12} className="mx-auto">
                                    <Row>
                                        <Col md={10}>
                                            <div className="label-required-doc">​
                                                <span className="span-title">เรื่องที่จะขอจดทะเบียน (Registration Request)</span>
                                            </div>
                                            {/* <i className="mdi mdi-download i-download" onClick={(e) => { OnClickOpenFile(val.name, val.document) }}></i> */}
                                            <div className="form-popup label-required-input">
                                                <Button 
                                                    id={0}
                                                    className="form-popup-input"
                                                    type="button"
                                                    onClick={() => setIsShowModal(true)}
                                                >
                                                    <i className="mdi mdi-rotate-90 mdi-plus"></i> Registration Request
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={10}>
                                            <Label className="span-sub-title">กรุณากรอกข้อมูลด้านในเอกสารที่เลือกให้ครบถ้วน</Label>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <br/>
                        { isShowSectionCheckbox("iccap_select") && (
                            <>
                            <div id="section-page-2-1">
                                <Row>
                                    <Col md={12} className="mx-auto">
                                        <Row>
                                            <Col md={10} className="section-click" onClick={() => toggleCheckbox("iccap_select")}>
                                                <FormGroup>
                                                    <i className="mdi mdi-book-open-variant icon-book"></i>
                                                    <Label className="label-title-topic">เพิ่มทุน</Label>
                                                    <i className="mdi mdi-close icon-close-book" 
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("1");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}>
                                                    </i><br/>
                                                    <Label className="label-sub-title-topic">(Increase Registered Capital)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>       
                                </Row>
                            </div> 
                            { isShowSection.iccap_select === "1" && (
                                <>
                                <Row>
                                    <Col md={12} className="mx-auto">
                                        <Row id="section-page-2-2">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b">1.ทุนจดทะเบียนบริษัท</Label><br/>
                                                    <Label className="span-sub-title-topic">Existing registered capital</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-3">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">ทุนจดทะเบียนปัจจุบัน/บาท (Existing registered capital/Baht)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_regiscap_amount"
                                                        placeholder="ระบุทุนจดทะเบียนปัจจุบัน"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_regiscap_amount) || ""}
                                                        invalid={validation.touched.iccap_regiscap_amount && validation.errors.iccap_regiscap_amount ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_regiscap_amount && validation.errors.iccap_regiscap_amount ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_regiscap_amount}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-4">
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">จำนวนหุ้นสามัญ (Number of ordinary shares)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_regiscap_commonstock"
                                                        placeholder="ระบุจำนวนหุ้นสามัญ"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumberWithoutDecimal(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_regiscap_commonstock) || ""}
                                                        invalid={validation.touched.iccap_regiscap_commonstock && validation.errors.iccap_regiscap_commonstock ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_regiscap_commonstock && validation.errors.iccap_regiscap_commonstock ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_regiscap_commonstock}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">จำนวนหุ้นบุริมสิทธิ (Number of preferred shares)<span className="msg-require">*</span></Label>
                                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightPreferredShares"></i>
                                                    <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightPreferredShares">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                        </UncontrolledPopover>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        name="iccap_regiscap_preferredstock"
                                                        placeholder="ระบุจำนวนหุ้นบุริมสิทธิ"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumberWithoutDecimal(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_regiscap_preferredstock) || ""}
                                                        invalid={validation.touched.iccap_regiscap_preferredstock && validation.errors.iccap_regiscap_preferredstock ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_regiscap_preferredstock && validation.errors.iccap_regiscap_preferredstock ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_regiscap_preferredstock}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">มูลค่าหุ้นละ/บาท (Par value)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_regiscap_valuepershare"
                                                        placeholder="ระบุมูลค่าหุ้น"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_regiscap_valuepershare) || ""}
                                                        invalid={validation.touched.iccap_regiscap_valuepershare && validation.errors.iccap_regiscap_valuepershare ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_regiscap_valuepershare && validation.errors.iccap_regiscap_valuepershare ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_regiscap_valuepershare}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className="mx-auto">
                                        <Row id="section-page-2-5">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b">2.ทุนส่วนที่จะบวกเพิ่ม</Label><br/>
                                                    <Label className="span-sub-title-topic">Additional registered capital</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-6">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">ทุนส่วนที่จะเพิ่ม/บาท(Additional registered capital/Baht)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_addcap_amount"
                                                        placeholder="ระบุทุนส่วนที่จะเพิ่ม"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_addcap_amount) || ""}
                                                        invalid={validation.touched.iccap_addcap_amount && validation.errors.iccap_addcap_amount ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_addcap_amount && validation.errors.iccap_addcap_amount ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_addcap_amount}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-7">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">จำนวนหุ้นสามัญที่เพิ่ม (Number of additional ordinary shares)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_addcap_commonstock"
                                                        placeholder="ระบุจำนวนหุ้นสามัญที่เพิ่ม"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumberWithoutDecimal(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_addcap_commonstock) || ""}
                                                        invalid={validation.touched.iccap_addcap_commonstock && validation.errors.iccap_addcap_commonstock ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_addcap_commonstock && validation.errors.iccap_addcap_commonstock ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_addcap_commonstock}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">จำนวนหุ้นบุริมสิทธิที่เพิ่ม (Number of additional preferred shares)<span className="msg-require">*</span></Label>
                                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightAddPreferredShares"></i>
                                                    <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightAddPreferredShares">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                        </UncontrolledPopover>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        name="iccap_addcap_preferredstock"
                                                        placeholder="ระบุจำนวนหุ้นบุริมสิทธิที่เพิ่ม"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumberWithoutDecimal(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_addcap_preferredstock) || ""}
                                                        invalid={validation.touched.iccap_addcap_preferredstock && validation.errors.iccap_addcap_preferredstock ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_addcap_preferredstock && validation.errors.iccap_addcap_preferredstock ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_addcap_preferredstock}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-8">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">การจองซื้อหุ้นของผู้ถือหุ้นแต่ละรายและระบุจำนวนหุ้น (Proportion of share subscriptions for each shareholder and specify the number of shares)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="textarea"
                                                        name="iccap_addcap_valuepershare"
                                                        placeholder="ตัวอย่างที่ให้ระบุ : BTSG จองซื้อ 10,000 หุ้น, นาย A จองซื้อ 100 หุ้น และ นางสาว B จองซื้อ 100 หุ้น"
                                                        autoComplete={autoCompletes}
                                                        className="txt-text-area"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            // ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.iccap_addcap_valuepershare || ""}
                                                        invalid={validation.touched.iccap_addcap_valuepershare && validation.errors.iccap_addcap_valuepershare ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_addcap_valuepershare && validation.errors.iccap_addcap_valuepershare ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_addcap_valuepershare}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-9">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b">3.ทุนจดทะเบียนใหม่</Label><br/>
                                                    <Label className="span-sub-title-topic">(Newly registered capital)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-10">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">ทุนจดทะเบียนใหม่/บาท (Newly registered capital/Baht)<span className="msg-require">*</span></Label>
                                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightRegisteredCapital"></i>
                                                    <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightRegisteredCapital">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i>กรณีทุนจดทะเบียนใหม่เกินกว่า 5 ล้านบาท ต้องใช้หนังสือรับรองยอดเงินเพิ่มทุนซึ่งออกโดยธนาคาร โดย user เป็นผู้จัดเตรียม<br/>In the case where the newly registered capital exceeding 5 million Baht, a certificate indicating the amount of capital increase issued by bank must be provided and prepared by the user</PopoverBody>
                                                        </UncontrolledPopover>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        name="iccap_newcap_amount"
                                                        placeholder="ระบุทุนจดทะเบียนใหม่"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_newcap_amount) || ""}
                                                        invalid={validation.touched.iccap_newcap_amount && validation.errors.iccap_newcap_amount ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_newcap_amount && validation.errors.iccap_newcap_amount ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_newcap_amount}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-11">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">จำนวนหุ้นสามัญใหม่ (Number of new ordinary shares)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_newcap_stock"
                                                        placeholder="ระบุจำนวนหุ้นสามัญใหม่"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumberWithoutDecimal(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_newcap_stock) || ""}
                                                        invalid={validation.touched.iccap_newcap_stock && validation.errors.iccap_newcap_stock ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_newcap_stock && validation.errors.iccap_newcap_stock ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_newcap_stock}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">จำนวนหุ้นบุริมสิทธิใหม่ (Number of new preferred shares)<span className="msg-require">*</span></Label>
                                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightNewPreferredShares"></i>
                                                    <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightNewPreferredShares">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                        </UncontrolledPopover>
                                                    </div>
                                                    <Input
                                                        type="text"
                                                        name="iccap_newcap_valuepershare"
                                                        placeholder="ระบุจำนวนหุ้นบุริมสิทธิใหม่"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumberWithoutDecimal(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_newcap_valuepershare) || ""}
                                                        invalid={validation.touched.iccap_newcap_valuepershare && validation.errors.iccap_newcap_valuepershare ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_newcap_valuepershare && validation.errors.iccap_newcap_valuepershare ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_newcap_valuepershare}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-12">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b">4.เรียกชำระครั้งแรก</Label><br/>
                                                    <Label className="span-sub-title-topic">The first payment</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-13">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">เรียกชำระครั้งแรก หุ้นละ/บาท (The first payment per share)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_paymentpershare"
                                                        placeholder="ระบุเรียกชำระครั้งแรก หุ้นละ"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.iccap_paymentpershare) || ""}
                                                        invalid={validation.touched.iccap_paymentpershare && validation.errors.iccap_paymentpershare ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_paymentpershare && validation.errors.iccap_paymentpershare ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_paymentpershare}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className="mx-auto">
                                        <Row id="section-page-2-14">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b">5.ชำระเงิน</Label><br/>
                                                    <Label className="span-sub-title-topic">Payment</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-15">
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">วันที่ชำระเงิน/บาท (Payment date)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="date"
                                                        // min={new Date().toISOString().split('T')[0]}
                                                        id="termPaymentDate"
                                                        name="iccap_paymentdate"
                                                        className="form-control"
                                                        value={startDate || ""}
                                                        invalid={validation.touched.iccap_paymentdate && validation.errors.iccap_paymentdate ? true : false}
                                                        onChange={handleStartDateChange}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_paymentdate && validation.errors.iccap_paymentdate ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_paymentdate}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-16">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b">6.บัญชีที่เงินเข้า</Label><br/>
                                                    <Label className="span-sub-title-topic">Bank Account</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-17">
                                            <Col md={10}>
                                                <FormGroup className="radio-gap">
                                                    <Input
                                                        id="iccapAcknowledged"
                                                        type="checkbox"
                                                        name="iccap_acknowledged"
                                                        checked={checkboxIccapAcknowledged === "1"}
                                                        invalid={validation.touched.iccap_acknowledged && validation.errors.iccap_acknowledged ? true : false}
                                                        onChange={(e) => {
                                                            const value = e.target.checked;
                                                            if(value){
                                                                setCheckboxIccapAcknowledged("1");
                                                            } else {
                                                                setCheckboxIccapAcknowledged("0");
                                                            }
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        disabled={isDisableds}
                                                        />
                                                    <Label className="label-title-agree-th" htmlFor="iccapAcknowledged">
                                                        ข้าพเจ้ารับทราบแล้วว่า "กรณีทุนจดทะเบียนใหม่เกินกว่า 5 ล้านบาท ต้องใช้หนังสือรับรองยอดเงินเพิ่มทุนซึ่งออกโดยธนาคาร ตามรายละเอียดในข้อ 6."
                                                        <br/>
                                                        <span className="label-title-agree-en">I agree that in the case where the newly registered capital exceeding 5 million Baht,<br/> a certificate indicating the amount of capital increase issued by the bank, as detailed in item 6 must be provided.</span>
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup>
                                                { validation.touched.iccap_acknowledged && validation.errors.iccap_acknowledged ? ( 
                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                        {validation.errors.iccap_acknowledged}
                                                    </FormFeedback>
                                                ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-18">
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">เงินเข้าบัญชีธนาคาร (Bank Account)<span className="msg-require">*</span></Label>
                                                    {/* <Select id="ddlBankAccount"
                                                        name="id_bank_account"
                                                        value={selectBank}
                                                        className="txt-placeholder"
                                                        placeholder={"กรุณาเลือก/Please select"}
                                                        onChange={(selected) => {
                                                            setSelectBank(selected);
                                                            validation.handleChange("id_bank_account")((selected !== null) ? selected.value : "");
                                                            validationDraft.handleChange("id_bank_account")((selected !== null) ? selected.value : "");
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        options={dataBank}
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        // invalid={ validation.touched.service_fee_payment_type && validation.errors.service_fee_payment_type ? true : false }
                                                        isDisabled={isDisableds}
                                                    /> */}
                                                    <Input
                                                        type="text"
                                                        name="iccap_bank_account"
                                                        placeholder="ระบุชื่อธนาคาร"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            // ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.iccap_bank_account || ""}
                                                        invalid={validation.touched.iccap_bank_account && validation.errors.iccap_bank_account ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_bank_account && validation.errors.iccap_bank_account ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_bank_account}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-19">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-title">ชื่อบัญชี (Account Name)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_bank_name"
                                                        placeholder="ระบุชื่อบัญชี"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.iccap_bank_name || ""}
                                                        invalid={validation.touched.iccap_bank_name && validation.errors.iccap_bank_name ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_bank_name && validation.errors.iccap_bank_name ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_bank_name}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-2-20">
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">เลขที่บัญชี (Account No.)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_bank_no"
                                                        placeholder="ระบุเลขที่บัญชี"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.iccap_bank_no || ""}
                                                        invalid={validation.touched.iccap_bank_no && validation.errors.iccap_bank_no ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_bank_no && validation.errors.iccap_bank_no ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_bank_no}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label className="label-title">สาขา (Branch)<span className="msg-require">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="iccap_bank_branch"
                                                        placeholder="ระบุสาขา"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.iccap_bank_branch || ""}
                                                        invalid={validation.touched.iccap_bank_branch && validation.errors.iccap_bank_branch ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.iccap_bank_branch && validation.errors.iccap_bank_branch ? ( 
                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                            {validation.errors.iccap_bank_branch}
                                                        </FormFeedback>
                                                    ) : false }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                               
                                </>
                            )}
                            <Row id="section-page-2-21">
                                <Col md={10}>
                                    <div className="section-line"></div>
                                </Col>
                            </Row>
                            </>
                        )}
                        { isShowSectionCheckbox("dccap_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-3-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("dccap_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">ลดทุน</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("2");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}>
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Decrease Registered Capital)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                            { isShowSection.dccap_select === "1" && (
                                                <>
                                                <Row id="section-page-3-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-sub-title-topic-b">1.ทุนจดทะเบียนปัจจุบัน</Label><br/>
                                                            <Label className="span-sub-title-topic">Existing registered capital</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-3-3">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">ทุนจดทะเบียนปัจจุบัน/บาท (Existing registered capital/Baht)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="dccap_regiscap_amount"
                                                                placeholder="ระบุทุนจดทะเบียนปัจจุบัน"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumber(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.dccap_regiscap_amount) || ""}
                                                                invalid={validation.touched.dccap_regiscap_amount && validation.errors.dccap_regiscap_amount ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.dccap_regiscap_amount && validation.errors.dccap_regiscap_amount ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.dccap_regiscap_amount}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-3-4">
                                                    <Col md={5}>
                                                        <FormGroup>
                                                            <Label className="label-title">จำนวนหุ้นสามัญ (Number of ordinary shares)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="dccap_regiscap_commonstock"
                                                                placeholder="ระบุจำนวนหุ้นสามัญ"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumberWithoutDecimal(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.dccap_regiscap_commonstock) || ""}
                                                                invalid={validation.touched.dccap_regiscap_commonstock && validation.errors.dccap_regiscap_commonstock ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.dccap_regiscap_commonstock && validation.errors.dccap_regiscap_commonstock ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.dccap_regiscap_commonstock}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={5}>
                                                        <FormGroup>
                                                            <Label className="label-title">จำนวนหุ้นบุริมสิทธิ (Number of preferred shares)<span className="msg-require">*</span></Label>
                                                            <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightDe1PreferredShares"></i>
                                                            <div className="hstack flex-wrap gap-2">
                                                                <UncontrolledPopover placement="right" target="PopoverRightDe1PreferredShares">
                                                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                                </UncontrolledPopover>
                                                            </div>
                                                            <Input
                                                                type="text"
                                                                name="dccap_regiscap_preferredstock"
                                                                placeholder="ระบุจำนวนหุ้นบุริมสิทธิ"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumberWithoutDecimal(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.dccap_regiscap_preferredstock) || ""}
                                                                invalid={validation.touched.dccap_regiscap_preferredstock && validation.errors.dccap_regiscap_preferredstock ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.dccap_regiscap_preferredstock && validation.errors.dccap_regiscap_preferredstock ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.dccap_regiscap_preferredstock}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-3-5">
                                                    <Col md={5}>
                                                        <FormGroup>
                                                            <Label className="label-title">มูลค่าหุ้นละ/บาท (Par value)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="dccap_regiscap_valuepershare"
                                                                placeholder="ระบุมูลค่าหุ้นละ"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumber(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.dccap_regiscap_valuepershare) || ""}
                                                                invalid={validation.touched.dccap_regiscap_valuepershare && validation.errors.dccap_regiscap_valuepershare ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.dccap_regiscap_valuepershare && validation.errors.dccap_regiscap_valuepershare ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.dccap_regiscap_valuepershare}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-3-6">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-sub-title-topic-b">2.ทุนจดทะเบียนส่วนที่ลดลง</Label><br/>
                                                            <Label className="span-sub-title-topic">Decrease registered capital</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-3-7">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">ทุนจดทะเบียนส่วนที่ลดลง/บาท (Decreased registered capital/Baht)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="dccap_reducap_amount"
                                                                placeholder="ระบุลดทุนจดทะเบียนจำนวน"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumber(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.dccap_reducap_amount) || ""}
                                                                invalid={validation.touched.dccap_reducap_amount && validation.errors.dccap_reducap_amount ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.dccap_reducap_amount && validation.errors.dccap_reducap_amount ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.dccap_reducap_amount}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-3-8">
                                                    <div className="mt-4 mt-lg-0 label-ddl">
                                                        <div className="form-check form-check-inline label-sub-content-checkbox-p-b">
                                                            <Input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="dccap_reducap_type"
                                                                id="idDecreasRadio1"
                                                                value="1"
                                                                checked={selectRadioDecrease === "1"}
                                                                onChange={handleDecreasRadio}
                                                                disabled={isDisableds}
                                                                invalid={ validation.touched.dccap_reducap_type && validation.errors.dccap_reducap_type ? true : false }
                                                            />
                                                            <Label className="form-check-label" htmlFor="idDecreasRadio1">
                                                            ลดจำนวนหุ้นลง (Decreasing number of)
                                                            </Label>
                                                        </div>
                                                    </div>
                                                </Row>
                                                    { selectRadioDecrease === "1" && (
                                                        <>
                                                            <Row id="section-page-3-9">
                                                                <Col md={10}>
                                                                    <FormGroup>
                                                                        <Label className="label-title">จำนวนหุ้นสามัญส่วนที่ลดลง (Number of ordinary shares decreased)<span className="msg-require">*</span></Label>
                                                                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightDe2PreferredShares1"></i>
                                                                        <div className="hstack flex-wrap gap-2">
                                                                            <UncontrolledPopover placement="right" target="PopoverRightDe2PreferredShares1">
                                                                                <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                                            </UncontrolledPopover>
                                                                        </div>
                                                                        <Input
                                                                            type="text"
                                                                            name="dccap_reducap_commonstock"
                                                                            placeholder="ระบุหุ้นสามัญ"
                                                                            autoComplete={autoCompletes}
                                                                            className="txt-placeholder"
                                                                            // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                            onChange={(e) => {
                                                                                ValidateNumberWithoutDecimal(e);
                                                                                validation.handleChange(e);
                                                                                validationDraft.handleChange(e);
                                                                                setIsSaveEnabled(true);
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={ formatNumberWithComma(validation.values.dccap_reducap_commonstock) || ""}
                                                                            invalid={validation.touched.dccap_reducap_commonstock && validation.errors.dccap_reducap_commonstock ? true : false}
                                                                            disabled={isDisableds}
                                                                        />
                                                                        { validation.touched.dccap_reducap_commonstock && validation.errors.dccap_reducap_commonstock ? ( 
                                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                {validation.errors.dccap_reducap_commonstock}
                                                                            </FormFeedback>
                                                                        ) : false }
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row id="section-page-3-10">
                                                                <Col md={10}>
                                                                    <FormGroup>
                                                                        <Label className="label-title">จำนวนหุ้นบุริมสิทธิส่วนที่ลดลง (Number of preferred shares decreased)<span className="msg-require">*</span></Label>
                                                                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightDe2PreferredShares2"></i>
                                                                        <div className="hstack flex-wrap gap-2">
                                                                            <UncontrolledPopover placement="right" target="PopoverRightDe2PreferredShares2">
                                                                                <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                                            </UncontrolledPopover>
                                                                        </div>
                                                                        <Input
                                                                            type="text"
                                                                            name="dccap_reducap_preferredstock"
                                                                            placeholder="ระบุหุ้นบุริมสิทธิ"
                                                                            autoComplete={autoCompletes}
                                                                            className="txt-placeholder"
                                                                            // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                            onChange={(e) => {
                                                                                ValidateNumberWithoutDecimal(e);
                                                                                validation.handleChange(e);
                                                                                validationDraft.handleChange(e);
                                                                                setIsSaveEnabled(true);
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={ formatNumberWithComma(validation.values.dccap_reducap_preferredstock) || ""}
                                                                            invalid={validation.touched.dccap_reducap_preferredstock && validation.errors.dccap_reducap_preferredstock ? true : false}
                                                                            disabled={isDisableds}
                                                                        />
                                                                        { validation.touched.dccap_reducap_preferredstock && validation.errors.dccap_reducap_preferredstock ? ( 
                                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                {validation.errors.dccap_reducap_preferredstock}
                                                                            </FormFeedback>
                                                                        ) : false }
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </>    
                                                    )}
                                                    <Row id="section-page-3-11">
                                                        <div className="mt-4 mt-lg-0 label-ddl">
                                                            <div className="form-check form-check-inline label-sub-content-checkbox-p-b">
                                                                <Input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="dccap_reducap_type"
                                                                    id="idDecreasRadio2"
                                                                    value="2"
                                                                    checked={selectRadioDecrease === "2"}
                                                                    onChange={handleDecreasRadio}
                                                                    disabled={isDisableds}
                                                                    invalid={ validation.touched.dccap_reducap_type && validation.errors.dccap_reducap_type ? true : false }
                                                                />
                                                                <Label className="form-check-label" htmlFor="idDecreasRadio2">
                                                                ลดมูลค่าหุ้นลง ( Reduction of the par value)
                                                                </Label>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                    { selectRadioDecrease === "2" && (
                                                        <>
                                                            <Row id="section-page-3-12">
                                                                <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="label-title">มูลค่าหุ้นส่วนที่ลดลงหุ้นละ/บาท (Reduction of the par value per share/Baht)<span className="msg-require">*</span></Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="dccap_reducap_valuepershare"
                                                                        placeholder="ระบุลดมูลค่าหุ้นลงหุ้นละ"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                        onChange={(e) => {
                                                                            ValidateNumber(e);
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        value={ formatNumberWithComma(validation.values.dccap_reducap_valuepershare) || ""}
                                                                        invalid={validation.touched.dccap_reducap_valuepershare && validation.errors.dccap_reducap_valuepershare ? true : false}
                                                                        disabled={isDisableds}
                                                                    />
                                                                    { validation.touched.dccap_reducap_valuepershare && validation.errors.dccap_reducap_valuepershare ? ( 
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {validation.errors.dccap_reducap_valuepershare}
                                                                        </FormFeedback>
                                                                    ) : false }
                                                                </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )}
                                                    <Row id="section-page-3-13">
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                { validation.touched.dccap_reducap_type && validation.errors.dccap_reducap_type ? ( 
                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                        {validation.errors.dccap_reducap_type}
                                                                    </FormFeedback>
                                                                ) : false }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row id="section-page-3-14">
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                <Label className="label-sub-title-topic-b">3.ทุนจดทะเบียนหลังการลดทุน</Label><br/>
                                                                <Label className="span-sub-title-topic">Registered capital after decrease</Label>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row id="section-page-3-15">
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                <Label className="label-title">ทุนจดทะเบียน/บาท (Registered capital/Baht)<span className="msg-require">*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    name="dccap_newcap_amount"
                                                                    placeholder="ระบุทุนจดทะเบียนใหม่"
                                                                    autoComplete={autoCompletes}
                                                                    className="txt-placeholder"
                                                                    // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                    onChange={(e) => {
                                                                        ValidateNumber(e);
                                                                        validation.handleChange(e);
                                                                        validationDraft.handleChange(e);
                                                                        setIsSaveEnabled(true);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={ formatNumberWithComma(validation.values.dccap_newcap_amount) || ""}
                                                                    invalid={validation.touched.dccap_newcap_amount && validation.errors.dccap_newcap_amount ? true : false}
                                                                    disabled={isDisableds}
                                                                />
                                                                { validation.touched.dccap_newcap_amount && validation.errors.dccap_newcap_amount ? ( 
                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                        {validation.errors.dccap_newcap_amount}
                                                                    </FormFeedback>
                                                                ) : false }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row id="section-page-3-16">
                                                        <Col md={5}>
                                                            <FormGroup>
                                                                <Label className="label-title">จำนวนหุ้นสามัญ (Number of ordinary shares)<span className="msg-require">*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    name="dccap_newcap_commonstock"
                                                                    placeholder="ระบุจำนวนหุ้นสามัญใหม่"
                                                                    autoComplete={autoCompletes}
                                                                    className="txt-placeholder"
                                                                    // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                    onChange={(e) => {
                                                                        ValidateNumberWithoutDecimal(e);
                                                                        validation.handleChange(e);
                                                                        validationDraft.handleChange(e);
                                                                        setIsSaveEnabled(true);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={ formatNumberWithComma(validation.values.dccap_newcap_commonstock) || ""}
                                                                    invalid={validation.touched.dccap_newcap_commonstock && validation.errors.dccap_newcap_commonstock ? true : false}
                                                                    disabled={isDisableds}
                                                                />
                                                                { validation.touched.dccap_newcap_commonstock && validation.errors.dccap_newcap_commonstock ? ( 
                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                        {validation.errors.dccap_newcap_commonstock}
                                                                    </FormFeedback>
                                                                ) : false }
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={5}>
                                                            <FormGroup>
                                                                <Label className="label-title">จำนวนหุ้นบุริมสิทธิ (Number of preferred shares)<span className="msg-require">*</span></Label>
                                                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightDe3PreferredShares"></i>
                                                                <div className="hstack flex-wrap gap-2">
                                                                    <UncontrolledPopover placement="right" target="PopoverRightDe3PreferredShares">
                                                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "0"<br/>If not available, please specify "0"</PopoverBody>
                                                                    </UncontrolledPopover>
                                                                </div>
                                                                <Input
                                                                    type="text"
                                                                    name="dccap_newcap_preferredstock"
                                                                    placeholder="ระบุจำนวนหุ้นบุริมสิทธิใหม่"
                                                                    autoComplete={autoCompletes}
                                                                    className="txt-placeholder"
                                                                    // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                    onChange={(e) => {
                                                                        ValidateNumberWithoutDecimal(e);
                                                                        validation.handleChange(e);
                                                                        validationDraft.handleChange(e);
                                                                        setIsSaveEnabled(true);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={ formatNumberWithComma(validation.values.dccap_newcap_preferredstock) || ""}
                                                                    invalid={validation.touched.dccap_newcap_preferredstock && validation.errors.dccap_newcap_preferredstock ? true : false}
                                                                    disabled={isDisableds}
                                                                />
                                                                { validation.touched.dccap_newcap_preferredstock && validation.errors.dccap_newcap_preferredstock ? ( 
                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                        {validation.errors.dccap_newcap_preferredstock}
                                                                    </FormFeedback>
                                                                ) : false }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row id="section-page-3-17">
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                <Label className="label-title">ราคาหุ้นใหม่/บาท (New par value)<span className="msg-require">*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    name="dccap_newcap_valuepershare"
                                                                    placeholder="ระบุราคาหุ้นใหม่"
                                                                    autoComplete={autoCompletes}
                                                                    className="txt-placeholder"
                                                                    // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                    onChange={(e) => {
                                                                        ValidateNumber(e);
                                                                        validation.handleChange(e);
                                                                        validationDraft.handleChange(e);
                                                                        setIsSaveEnabled(true);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={ formatNumberWithComma(validation.values.dccap_newcap_valuepershare) || ""}
                                                                    invalid={validation.touched.dccap_newcap_valuepershare && validation.errors.dccap_newcap_valuepershare ? true : false}
                                                                    disabled={isDisableds}
                                                                />
                                                                { validation.touched.dccap_newcap_valuepershare && validation.errors.dccap_newcap_valuepershare ? ( 
                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                        {validation.errors.dccap_newcap_valuepershare}
                                                                    </FormFeedback>
                                                                ) : false }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row id="section-page-3-18">
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                <Label className="label-title">จำนวนการถือหุ้นภายหลังการลดทุน (The number of shares held after the capital reduction)<span className="msg-require">*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    name="dccap_after_reducap"
                                                                    placeholder="ตัวอย่าง ‘ BTSG ถือหุ้น 24,999 หุ้น, นาย A ถือหุ้น 1 หุ้น และบริษัท B ถือหุ้น 15,000 หุ้น ‘"
                                                                    autoComplete={autoCompletes}
                                                                    className="txt-placeholder"
                                                                    // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                    onChange={(e) => {
                                                                        validation.handleChange(e);
                                                                        validationDraft.handleChange(e);
                                                                        setIsSaveEnabled(true);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={ validation.values.dccap_after_reducap || ""}
                                                                    invalid={validation.touched.dccap_after_reducap && validation.errors.dccap_after_reducap ? true : false}
                                                                    disabled={isDisableds}
                                                                />
                                                                { validation.touched.dccap_after_reducap && validation.errors.dccap_after_reducap ? ( 
                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                        {validation.errors.dccap_after_reducap}
                                                                    </FormFeedback>
                                                                ) : false }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                    <Row id="section-page-3-19">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("edit_name_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-4-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("edit_name_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">แก้ไขชื่อ</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("3");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}>
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Company's Name)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.edit_name_select === "1" && (
                                            <>
                                            <Row id="section-page-4-2">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="label-sub-title-topic-b-name">ชื่อใหม่บริษัท</Label><br/>
                                                        <Label className="span-sub-title-topic-name">New name of the Company</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-4-3">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="label-title">1.ชื่อภาษาไทย (Thai Name)<span className="msg-require">*</span></Label>
                                                        <Input
                                                            type="text"
                                                            name="edit_name_th"
                                                            placeholder="ระบุชื่อภาษาไทย"
                                                            autoComplete={autoCompletes}
                                                            className="txt-placeholder"
                                                            // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                            onChange={(e) => {
                                                                validation.handleChange(e);
                                                                validationDraft.handleChange(e);
                                                                setIsSaveEnabled(true);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.edit_name_th || ""}
                                                            invalid={validation.touched.edit_name_th && validation.errors.edit_name_th ? true : false}
                                                            disabled={isDisableds}
                                                        />
                                                        { validation.touched.edit_name_th && validation.errors.edit_name_th ? ( 
                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                {validation.errors.edit_name_th}
                                                            </FormFeedback>
                                                        ) : false }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-4-4">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="label-title">2.ชื่อภาษาอังกฤษ (English Name)<span className="msg-require">*</span></Label>
                                                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCompanyEng"></i>
                                                        <div className="hstack flex-wrap gap-2">
                                                            <UncontrolledPopover placement="right" target="PopoverRightCompanyEng">
                                                                <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุ Company Limited หรือ Co., Ltd. ด้วย โดยต้องสอดคล้องกับตราประทับ(ถ้ามี)<br/>Please specify the company's name with "Company Limited" or "Co., Ltd." accordingly, to correspond with the seal (if applicable).</PopoverBody>
                                                            </UncontrolledPopover>
                                                        </div>
                                                        <Input
                                                            type="text"
                                                            name="edit_name_en"
                                                            placeholder="ระบุชื่อภาษาอังกฤษ"
                                                            autoComplete={autoCompletes}
                                                            className="txt-placeholder"
                                                            // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                            onChange={(e) => {
                                                                validation.handleChange(e);
                                                                validationDraft.handleChange(e);
                                                                setIsSaveEnabled(true);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.edit_name_en || ""}
                                                            invalid={validation.touched.edit_name_en && validation.errors.edit_name_en ? true : false}
                                                            disabled={isDisableds}
                                                        />
                                                        { validation.touched.edit_name_en && validation.errors.edit_name_en ? ( 
                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                {validation.errors.edit_name_en}
                                                            </FormFeedback>
                                                        ) : false }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            </>
                                        )}
                                        <Row id="section-page-4-5">
                                            <Col md={10}>
                                                <div className="section-line"></div>
                                            </Col>
                                        </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("edit_seal_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-5-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("edit_seal_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">แก้ไขตราประทับบริษัท</Label>
                                                <i className="mdi mdi-close icon-close-book"  
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("4");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Company's Seal)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.edit_seal_select === "1" && (
                                            <>
                                                <Row id="section-page-5-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">สีน้ำหมึกของตราประทับบริษัท (Ink color for the Company’s seal)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="edit_seal_ink"
                                                                placeholder="กรอกสีน้ำหมึกของตราประทับที่ต้องการ"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.edit_seal_ink || ""}
                                                                invalid={validation.touched.edit_seal_ink && validation.errors.edit_seal_ink ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.edit_seal_ink && validation.errors.edit_seal_ink ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.edit_seal_ink}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-5-3">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-sub-title-topic-b-name">กรุณาแนบไฟล์ตราประทับบริษัทที่ระบุขนาดกว้างxยาว (.ai)</Label><span className="msg-require fs-16">*</span><br/>
                                                            <Label className="span-sub-title-topic-name">Please attach the file of the Company seal in ".ai" format and specify the dimensions as width x length</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-5-4">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                        <MultipleUploadfile inputID="fileEditSeal" folder={dataFormRequest.request_no} dataFile={fileEditSeal} setDataFile={OnSetFileEditSeal} fileType={"ai"} isDisable={false}/>
                                                        { validation.touched.edit_seal && validation.errors.edit_seal ? 
                                                            ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.edit_seal}</FormFeedback> ) : false 
                                                        }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    <Row id="section-page-5-5">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("headoffice_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-6-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("headoffice_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">แก้ไขที่ตั้งสำนักงานใหญ่</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("5");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Head Office Address)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.headoffice_select === "1" && (
                                            <>
                                                <Row id="section-page-6-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">ที่ตั้งปัจจุบัน (Present address)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="textarea"
                                                                name="headoffice_clocation"
                                                                placeholder="ระบุที่ตั้งปัจจุบัน"
                                                                autoComplete={autoCompletes}
                                                                className="txt-text-area"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.headoffice_clocation || ""}
                                                                invalid={validation.touched.headoffice_clocation && validation.errors.headoffice_clocation ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.headoffice_clocation && validation.errors.headoffice_clocation ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.headoffice_clocation}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-6-3">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">ที่ตั้งใหม่ภาษาไทย (New address in Thai)<span className="msg-require">*</span></Label>
                                                            <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightLocationCompanyTh"></i>
                                                            <div className="hstack flex-wrap gap-2">
                                                                <UncontrolledPopover placement="right" target="PopoverRightLocationCompanyTh">
                                                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> รวมถึงการแก้ไขที่ตั้งโดยการระบุรายละเอียดเพิ่ม เช่น ชั้น, อาคาร, เลขห้อง เป็นต้น<br/>Including amendment of the address by specifying more details such as floor, building, unit etc.</PopoverBody>
                                                                </UncontrolledPopover>
                                                            </div>
                                                            <Input
                                                                type="textarea"
                                                                name="headoffice_nlocation_th"
                                                                placeholder="ระบุที่ตั้งใหม่ภาษาไทย"
                                                                autoComplete={autoCompletes}
                                                                className="txt-text-area"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.headoffice_nlocation_th || ""}
                                                                invalid={validation.touched.headoffice_nlocation_th && validation.errors.headoffice_nlocation_th ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.headoffice_nlocation_th && validation.errors.headoffice_nlocation_th ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.headoffice_nlocation_th}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-6-4">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">ที่ตั้งใหม่ภาษาอังกฤษ (New address in English)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="textarea"
                                                                name="headoffice_nlocation_en"
                                                                placeholder="ระบุที่ตั้งใหม่ภาษาอังกฤษ"
                                                                autoComplete={autoCompletes}
                                                                className="txt-text-area"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.headoffice_nlocation_en || ""}
                                                                invalid={validation.touched.headoffice_nlocation_en && validation.errors.headoffice_nlocation_en ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.headoffice_nlocation_en && validation.errors.headoffice_nlocation_en ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.headoffice_nlocation_en}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-6-5">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">กรุณาแนบไฟล์ทะเบียนบ้านที่ตั้งใหม่และแผนที่ (ไม่ใช้แผนที่ดาวเทียม)<span className="msg-require">*</span><br/>Please attach the new house registration and map (satellite map is not permitted)</Label>
                                                            <FormGroup>
                                                                <MultipleUploadfile inputID="fileHeadOffice" folder={dataFormRequest.request_no} dataFile={fileHeadOffice} setDataFile={OnSetFileHeadOffice} isDisable={false}/>
                                                                { validation.touched.headoffice_file && validation.errors.headoffice_file ? 
                                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.headoffice_file}</FormFeedback> ) : false 
                                                                }
                                                            </FormGroup>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    <Row id="section-page-6-6">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("branchoffice_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-7-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("branchoffice_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">แก้ไขที่ตั้งสำนักงานสาขา</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("6");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Branch Office Address)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.branchoffice_select === "1" && (
                                            <>
                                                <Row id="section-page-7-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">สามารถเลือกได้มากกว่า 1 ช่อง</Label><br/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-7-3">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                        <Input
                                                        id="branchofficeIcSelect"
                                                        type="checkbox"
                                                        name="branchoffice_ic_select"
                                                        className=""
                                                        invalid={validation.touched.selected_check_branch && validation.errors.selected_check_branch ? true : false}
                                                        checked={checkboxIcSelect === "1"}
                                                        disabled={isDisableds}
                                                        onChange={(e) => {
                                                            const value = e.target.checked;

                                                            // ตรวจสอบว่า doc_add_branch มีข้อมูลจริงหรือไม่
                                                            const docAddBranch = validation.values.doc_add_branch || [];
                                                            const hasData = docAddBranch.some(item => 
                                                                Object.values(item).some(val => val !== "" && val !== null && val !== undefined)
                                                            );

                                                            if (!value && hasData) {
                                                                
                                                                Swal.fire({
                                                                    title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                                                                    html: `
                                                                        คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                                                                        <br>
                                                                        Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                                                                    `,
                                                                    showCancelButton: true,
                                                                    confirmButtonText: "Remove",
                                                                    cancelButtonText: "Cancel",
                                                                    confirmButtonColor: "#FEEFEF", 
                                                                    customClass: {
                                                                        popup: 'custom-swal-popup',
                                                                        title: 'custom-swal-title-dbd',
                                                                        htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                                                                        image: 'custom-swal-image',
                                                                        actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                                                                        cancelButton: 'custom-swal-cancel',
                                                                        confirmButton: 'custom-swal-remove',
                                                                    },
                                                                    reverseButtons: true,
                                                                }).then((result) => {
                                                                    if (result.isConfirmed) {
                                                                        setCheckboxIcSelect("0");
                                                                        setCheckBoxAddBranchOffice("0");

                                                                        validation.setFieldValue("doc_add_branch", [{ ...modelAddFormBranch }]);
                                                                        validationDraft.setFieldValue("doc_add_branch", [{ ...modelAddFormBranch }]);

                                                                        setIsSaveEnabled(true);
                                                                        validation.setFieldValue("branchoffice_ic_select", "0");
                                                                        validationDraft.setFieldValue("branchoffice_ic_select", "0");

                                                                        setFileBranchOffice(setStringFileNameToArray(""));

                                                                        Swal.fire({
                                                                            iconHtml: IconBin,
                                                                            title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                                                                            showConfirmButton: false,
                                                                            showCloseButton: true,
                                                                        });
                                                                    }
                                                                });
                                                            } else {
                                                                // ถ้าไม่มีข้อมูล เอาออกได้เลย
                                                                setCheckboxIcSelect(value ? "1" : "0");
                                                                setCheckBoxAddBranchOffice(value ? "1" : "0");

                                                                validation.setFieldValue("doc_add_branch", [{ ...modelAddFormBranch }]);
                                                                validationDraft.setFieldValue("doc_add_branch", [{ ...modelAddFormBranch }]);
                                                                
                                                                validation.setFieldValue("branchoffice_ic_select", value ? "1" : "0");
                                                                validationDraft.setFieldValue("branchoffice_ic_select", value ? "1" : "0");

                                                                setIsSaveEnabled(true);
                                                            }
                                                        }}
                                                        />
                                                            <Label className="label-title-checkbox-select" htmlFor="branchofficeIcSelect">เพิ่มสาขา (Adding the new branch office)</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { checkboxIcSelect === "1" && (
                                                    <>
                                                        {validation.values.doc_add_branch.map((item, index) => {
                                                            const docBranchError = validation.errors.doc_add_branch?.length && validation.errors.doc_add_branch[index] || {};
                                                            const docBranchTouch = validation.touched.doc_add_branch?.length && validation.touched.doc_add_branch[index] || {};
                                                            return (
                                                                <div id={"section-page-7-" + (index + 4)} key={"reqDocAddBranch" + index}>
                                                                    <Row>
                                                                        <Col md={10}>
                                                                            <FormGroup>
                                                                                <Label className="label-title-number-section">สาขาที่ {index+1}.</Label><br/>
                                                                                <Label className="label-title">ที่ตั้งสาขา (Address)<span className="msg-require">*</span></Label><br/>
                                                                                <Input id={`txtDocBranchLocation${index + 1}`}
                                                                                    type="text"
                                                                                    name={`doc_add_branch[${index}].branchoffice_ic_location`}
                                                                                    placeholder="ระบุที่ตั้งสาขา"
                                                                                    className="txt-placeholder"
                                                                                    value={item.branchoffice_ic_location}
                                                                                    onChange={(e) => {
                                                                                        validation.handleChange(e);
                                                                                        validationDraft.handleChange(e);
                                                                                        setIsSaveEnabled(true);
                                                                                    }}
                                                                                    onBlur={validation.handleBlur}
                                                                                    invalid={ docBranchTouch.branchoffice_ic_location && docBranchError.branchoffice_ic_location ? true : false }
                                                                                    disabled={checkBoxAddBranchOffice === "0" || isDisableds}
                                                                                />
                                                                                {docBranchTouch.branchoffice_ic_location && docBranchError.branchoffice_ic_location ? (
                                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                        {docBranchError.branchoffice_ic_location}
                                                                                    </FormFeedback>
                                                                                ) : null}
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd">
                                                                            <FormGroup>
                                                                                {index === 0 && validation.values.doc_add_branch.length < 5 ? (
                                                                                    <i className={`mdi mdi-plus-circle ${checkBoxAddBranchOffice === "0" || isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxAddBranchOffice === "0" || isDisableds ? null : OnClickPlusAddBranchOffice}  ></i>
                                                                                ) : (
                                                                                    index === 0 && validation.values.doc_add_branch.length === 5 && ( 
                                                                                        <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                                    )
                                                                                )}
                                                                                {index > 0 && (
                                                                                    <i className={`mdi mdi-minus-circle ${checkBoxAddBranchOffice === "0" || isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={checkBoxAddBranchOffice === "0" || isDisableds ? null : () => OnClickMinusRemoveBranchOffice(index)} ></i>
                                                                                )}
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={5}>
                                                                            <FormGroup>
                                                                                <Label className="label-title">เบอร์โทรศัพท์ (Telephone Number)<span className="msg-require">*</span></Label><br/>
                                                                                <Input id={`txtDocBranchTel${index + 1}`}
                                                                                    type="text"
                                                                                    name={`doc_add_branch[${index}].branchoffice_ic_tel`}
                                                                                    placeholder="ระบุเบอร์โทรศัพท์"
                                                                                    className="txt-placeholder"
                                                                                    value={item.branchoffice_ic_tel}
                                                                                    onChange={(e) => {
                                                                                        validation.handleChange(e);
                                                                                        validationDraft.handleChange(e);
                                                                                        setIsSaveEnabled(true);
                                                                                    }}
                                                                                    onBlur={validation.handleBlur}
                                                                                    invalid={ docBranchTouch.branchoffice_ic_tel && docBranchError.branchoffice_ic_tel ? true : false }
                                                                                    disabled={checkBoxAddBranchOffice === "0" || isDisableds}
                                                                                />
                                                                                {docBranchTouch.branchoffice_ic_tel && docBranchError.branchoffice_ic_tel ? (
                                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                        {docBranchError.branchoffice_ic_tel}
                                                                                    </FormFeedback>
                                                                                ) : null}
                                                                            </FormGroup>
                                                                        </Col>
                                                                        <Col md={5}>
                                                                            <FormGroup>
                                                                                <Label className="label-title">อีเมล (Email)<span className="msg-require">*</span></Label><br/>
                                                                                <Input id={`txtDocBranchEmail${index + 1}`}
                                                                                    type="text"
                                                                                    name={`doc_add_branch[${index}].branchoffice_ic_email`}
                                                                                    placeholder="ระบุเบอร์โทรศัพท์"
                                                                                    className="txt-placeholder"
                                                                                    value={item.branchoffice_ic_email}
                                                                                    onChange={(e) => {
                                                                                        validation.handleChange(e);
                                                                                        validationDraft.handleChange(e);
                                                                                        setIsSaveEnabled(true);
                                                                                    }}
                                                                                    onBlur={validation.handleBlur}
                                                                                    invalid={ docBranchTouch.branchoffice_ic_email && docBranchError.branchoffice_ic_email ? true : false }
                                                                                    disabled={checkBoxAddBranchOffice === "0" || isDisableds}
                                                                                />
                                                                                {docBranchTouch.branchoffice_ic_email && docBranchError.branchoffice_ic_email ? (
                                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                        {docBranchError.branchoffice_ic_email}
                                                                                    </FormFeedback>
                                                                                ) : null}
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={5}>
                                                                            <FormGroup>
                                                                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightFaxBranch"></i>
                                                                                <div className="hstack flex-wrap gap-2">
                                                                                    <UncontrolledPopover placement="right" target="PopoverRightFaxBranch">
                                                                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "ไม่มี"<br/>If not available, please specify "None"</PopoverBody>
                                                                                    </UncontrolledPopover>
                                                                                </div>
                                                                                <Label className="label-title">โทรสาร (Fax)<span className="msg-require">*</span></Label>
                                                                                <Input id={`txtDocBranchFax${index + 1}`}
                                                                                    type="text"
                                                                                    name={`doc_add_branch[${index}].branchoffice_ic_fax`}
                                                                                    placeholder="ระบุเบอร์โทรศัพท์"
                                                                                    className="txt-placeholder"
                                                                                    value={item.branchoffice_ic_fax}
                                                                                    onChange={(e) => {
                                                                                        validation.handleChange(e);
                                                                                        validationDraft.handleChange(e);
                                                                                        setIsSaveEnabled(true);
                                                                                    }}
                                                                                    onBlur={validation.handleBlur}
                                                                                    invalid={ docBranchTouch.branchoffice_ic_fax && docBranchError.branchoffice_ic_fax ? true : false }
                                                                                    disabled={checkBoxAddBranchOffice === "0" || isDisableds}
                                                                                />
                                                                                {docBranchTouch.branchoffice_ic_fax && docBranchError.branchoffice_ic_fax ? (
                                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                        {docBranchError.branchoffice_ic_fax}
                                                                                    </FormFeedback>
                                                                                ) : null}
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={10}>
                                                                            <FormGroup>
                                                                                <Label className="label-title">กรุณาแนบไฟล์ทะเบียนบ้านที่ตั้งใหม่ (Please attach the new house registration)<span className="msg-require">*</span></Label><br/>
                                                                                <MultipleUploadfile 
                                                                                    inputID={`fileBranchOffice${index + 1}`} 
                                                                                    folder={dataFormRequest.request_no} 
                                                                                    dataFile={fileBranchOffice[index] || setStringFileNameToArray(item?.branchoffice_ic_file) || []} 
                                                                                    setDataFile={(files) => {
                                                                                        const updatedFiles = [...fileBranchOffice];
                                                                                        updatedFiles[index] = files;
                                                                                        const names = files.map(file => file.name).join(",");
                                                                                        setFileBranchOffice(updatedFiles);
                                                                                        validation.setFieldValue(`doc_add_branch[${index}].file_branchoffice_ic_file`, updatedFiles[index] || []);
                                                                                        validationDraft.setFieldValue(`doc_add_branch[${index}].file_branchoffice_ic_file`, updatedFiles[index] || []);
                                                                                        validation.setFieldValue(`doc_add_branch[${index}].branchoffice_ic_file`, names || "");
                                                                                        validationDraft.setFieldValue(`doc_add_branch[${index}].branchoffice_ic_file`, names || "");
                                                                                        setIsSaveEnabled(true);
                                                                                    }}  
                                                                                    isDisable={false}
                                                                                />
                                                                                {docBranchTouch.branchoffice_ic_file && docBranchError.branchoffice_ic_file ? (
                                                                                    <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                        {docBranchError.branchoffice_ic_file}
                                                                                    </FormFeedback>
                                                                                ) : null}
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            );
                                                        })}
                                                        <Row id="section-page-8-1"> 
                                                            <Col md={10}>
                                                                <div class="section-line"></div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                <Row id="section-page-9-1">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                            <Input
                                                                id="branchofficeDcSelect"
                                                                type="checkbox"
                                                                name="branchoffice_dc_select"
                                                                className=""
                                                                checked={checkboxDcSelect === "1"}
                                                                invalid={validation.touched.selected_check_branch && validation.errors.selected_check_branch ? true : false}
                                                                disabled={isDisableds}
                                                                onChange={(e) => {
                                                                    const value = e.target.checked;
        
                                                                    // ตรวจสอบว่า doc_close_branch มีข้อมูลจริงหรือไม่
                                                                    const docCloseBranch = validation.values.doc_close_branch || [];
                                                                    const hasData = docCloseBranch.some(item => 
                                                                        Object.values(item).some(val => val !== "" && val !== null && val !== undefined)
                                                                    );
        
                                                                    if (!value && hasData) {
                                                                        
                                                                        Swal.fire({
                                                                            title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                                                                            html: `
                                                                                คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                                                                                <br>
                                                                                Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                                                                            `,
                                                                            showCancelButton: true,
                                                                            confirmButtonText: "Remove",
                                                                            cancelButtonText: "Cancel",
                                                                            confirmButtonColor: "#FEEFEF", 
                                                                            customClass: {
                                                                                popup: 'custom-swal-popup',
                                                                                title: 'custom-swal-title-dbd',
                                                                                htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                                                                                image: 'custom-swal-image',
                                                                                actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                                                                                cancelButton: 'custom-swal-cancel',
                                                                                confirmButton: 'custom-swal-remove',
                                                                            },
                                                                            reverseButtons: true,
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                setCheckboxDcSelect("0");
                                                                                setCheckBoxCloseBranchOffice("0");
        
                                                                                validation.setFieldValue("doc_close_branch", [{ ...modelCloseFormBranch }]);
                                                                                validationDraft.setFieldValue("doc_close_branch", [{ ...modelCloseFormBranch }]);
        
                                                                                setIsSaveEnabled(true);
                                                                                validation.setFieldValue("branchoffice_dc_select", "0");
                                                                                validationDraft.setFieldValue("branchoffice_dc_select", "0");
        
                                                                                Swal.fire({
                                                                                    iconHtml: IconBin,
                                                                                    title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                                                                                    showConfirmButton: false,
                                                                                    showCloseButton: true,
                                                                                });
                                                                            }
                                                                        });
                                                                    } else {
                                                                        // ถ้าไม่มีข้อมูล เอาออกได้เลย
                                                                        setCheckboxDcSelect(value ? "1" : "0");
                                                                        setCheckBoxCloseBranchOffice(value ? "1" : "0");

                                                                        validation.setFieldValue("doc_close_branch", [{ ...modelCloseFormBranch }]);
                                                                            validationDraft.setFieldValue("doc_close_branch", [{ ...modelCloseFormBranch }]);
        
                                                                        validation.setFieldValue("branchoffice_dc_select", value ? "1" : "0");
                                                                        validationDraft.setFieldValue("branchoffice_dc_select", value ? "1" : "0");
        
                                                                        setIsSaveEnabled(true);
                                                                    }
                                                                }}
                                                            />
                                                            <Label className="label-title-checkbox-select" htmlFor="branchofficeDcSelect">ลดสาขา (Closing the branch office)</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { checkboxDcSelect === "1" && (
                                                    <>
                                                        {validation.values.doc_close_branch.map((item, index) => {
                                                            const docCloseBranchError = validation.errors.doc_close_branch?.length && validation.errors.doc_close_branch[index] || {};
                                                            const docCloseBranchTouch = validation.touched.doc_close_branch?.length && validation.touched.doc_close_branch[index] || {};
                                                            return (
                                                                <div id={"section-page-9-" + (index + 2)} key={"reqDocCloseBranch" + index}>
                                                                    <Row>
                                                                        <Col md={10}>
                                                                        <FormGroup>
                                                                        <Label className="label-title-number-section">สาขาที่ {index+1}.</Label><br/>
                                                                            <Label className="label-title">ที่ตั้งสาขา (Address)<span className="msg-require">*</span></Label><br/>
                                                                            <Input id={`txtBranchofficeDcLocation${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_close_branch[${index}].branchoffice_dc_location`}
                                                                                placeholder="ระบุที่ตั้งสาขา"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={item.branchoffice_dc_location}
                                                                                invalid={ docCloseBranchTouch.branchoffice_dc_location && docCloseBranchError.branchoffice_dc_location ? true : false }
                                                                                disabled={checkBoxCloseBranchOffice === "0" || isDisableds}
                                                                            />
                                                                            {docCloseBranchTouch.branchoffice_dc_location && docCloseBranchError.branchoffice_dc_location ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCloseBranchError.branchoffice_dc_location}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                        </Col>
                                                                        <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd">
                                                                            <FormGroup>
                                                                                {index === 0 && validation.values.doc_close_branch.length < 5 ? (
                                                                                    <i className={`mdi mdi-plus-circle ${checkBoxCloseBranchOffice === "0" || isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxCloseBranchOffice === "0" || isDisableds ? null : OnClickPlusCloseBranchOffice}  ></i>
                                                                                ) : (
                                                                                    index === 0 && validation.values.doc_close_branch.length === 5 && ( 
                                                                                        <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                                    )
                                                                                )}
                                                                                {index > 0 && (
                                                                                    <i className={`mdi mdi-minus-circle ${checkBoxCloseBranchOffice === "0" || isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={checkBoxCloseBranchOffice === "0" || isDisableds ? null : () => OnClickRemoveCloseBranchOffice(index)} ></i>
                                                                                )}
                                                                            </FormGroup>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            );
                                                        })}
                                                        <Row id="section-page-10-1">
                                                            <Col md={10}>
                                                                <div class="section-line"></div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                <Row id="section-page-11-1">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                            <Input
                                                                id="branchofficeEdSelect"
                                                                type="checkbox"
                                                                name="branchoffice_edit_select"
                                                                className=""
                                                                checked={checkboxOtSelect === "1"}
                                                                invalid={validation.touched.selected_check_branch && validation.errors.selected_check_branch ? true : false}
                                                                disabled={isDisableds}
                                                                onChange={(e) => {
                                                                    const value = e.target.checked;
        
                                                                    // ตรวจสอบว่า doc_edit_branch มีข้อมูลจริงหรือไม่
                                                                    const docEditBranch = validation.values.doc_edit_branch || [];
                                                                    const hasData = docEditBranch.some(item => 
                                                                        Object.values(item).some(val => val !== "" && val !== null && val !== undefined)
                                                                    );
        
                                                                    if (!value && hasData) {
                                                                        
                                                                        Swal.fire({
                                                                            title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                                                                            html: `
                                                                                คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                                                                                <br>
                                                                                Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                                                                            `,
                                                                            showCancelButton: true,
                                                                            confirmButtonText: "Remove",
                                                                            cancelButtonText: "Cancel",
                                                                            confirmButtonColor: "#FEEFEF", 
                                                                            customClass: {
                                                                                popup: 'custom-swal-popup',
                                                                                title: 'custom-swal-title-dbd',
                                                                                htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                                                                                image: 'custom-swal-image',
                                                                                actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                                                                                cancelButton: 'custom-swal-cancel',
                                                                                confirmButton: 'custom-swal-remove',
                                                                            },
                                                                            reverseButtons: true,
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                setCheckboxOtSelect("0");
                                                                                setCheckBoxEditBranchOffice("0");
        
                                                                                validation.setFieldValue("doc_edit_branch", [{ ...modelEditFormBranch }]);
                                                                                validationDraft.setFieldValue("doc_edit_branch", [{ ...modelEditFormBranch }]);
        
                                                                                setIsSaveEnabled(true);
                                                                                validation.setFieldValue("branchoffice_edit_select", "0");
                                                                                validationDraft.setFieldValue("branchoffice_edit_select", "0");
        
                                                                                Swal.fire({
                                                                                    iconHtml: IconBin,
                                                                                    title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                                                                                    showConfirmButton: false,
                                                                                    showCloseButton: true,
                                                                                });
                                                                            }
                                                                        });
                                                                    } else {
                                                                        // ถ้าไม่มีข้อมูล เอาออกได้เลย
                                                                        setCheckboxOtSelect(value ? "1" : "0");
                                                                        setCheckBoxEditBranchOffice(value ? "1" : "0");

                                                                        validation.setFieldValue("doc_edit_branch", [{ ...modelEditFormBranch }]);
                                                                        validationDraft.setFieldValue("doc_edit_branch", [{ ...modelEditFormBranch }]);
        
                                                                        validation.setFieldValue("branchoffice_edit_select", value ? "1" : "0");
                                                                        validationDraft.setFieldValue("branchoffice_edit_select", value ? "1" : "0");
        
                                                                        setIsSaveEnabled(true);
                                                                    }
                                                                }}
                                                            />
                                                            <Label className="label-title-checkbox-select" htmlFor="branchofficeEdSelect">แก้ไขสาขา (Amendment of the branch office address)</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { checkboxOtSelect === "1" && (
                                                    <>
                                                    {validation.values.doc_edit_branch.map((item, index) => {
                                                        const docEditBranchError = validation.errors.doc_edit_branch?.length && validation.errors.doc_edit_branch[index] || {};
                                                        const docEditBranchTouch = validation.touched.doc_edit_branch?.length && validation.touched.doc_edit_branch[index] || {};
                                                        return (
                                                            <div id={"section-page-11-" + (index + 2)} key={"reqDocEditBranch" + index}>
                                                                <Row>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                        <Label className="label-title-number-section">สาขาที่ {index+1}.</Label><br/>
                                                                            <Label className="label-title">ที่ตั้งสาขาปัจจุบัน (Present address)<span className="msg-require">*</span></Label><br/>
                                                                            <Input id={`txtBranchofficeEditClocation${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_edit_branch[${index}].branchoffice_edit_clocation`}
                                                                                placeholder="ระบุที่ตั้งสาขาปัจจุบัน"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={item.branchoffice_edit_clocation}
                                                                                invalid={ docEditBranchTouch.branchoffice_edit_clocation && docEditBranchError.branchoffice_edit_clocation ? true : false }
                                                                                disabled={checkBoxEditBranchOffice === "0" || isDisableds}
                                                                            />
                                                                            {docEditBranchTouch.branchoffice_edit_clocation && docEditBranchError.branchoffice_edit_clocation ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docEditBranchError.branchoffice_edit_clocation}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <br/>
                                                                    <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd">
                                                                        <FormGroup>
                                                                            {index === 0 && validation.values.doc_edit_branch.length < 5 ? (
                                                                                <i className={`mdi mdi-plus-circle ${checkBoxEditBranchOffice === "0" || isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={checkBoxEditBranchOffice === "0" || isDisableds ? null : OnClickPlusEditBranchOffice}  ></i>
                                                                            ) : (
                                                                                index === 0 && validation.values.doc_edit_branch.length === 5 && ( 
                                                                                    <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                                )
                                                                            )}
                                                                            {index > 0 && (
                                                                                <i className={`mdi mdi-minus-circle ${checkBoxEditBranchOffice === "0" || isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={checkBoxEditBranchOffice === "0" || isDisableds ? null : () => OnClickRemoveEditBranchOffice(index)} ></i>
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">ที่ตั้งสาขาใหม่ (New address)<span className="msg-require">*</span></Label><br/>
                                                                            <Input id={`txtBranchofficeEditNlocation${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_edit_branch[${index}].branchoffice_edit_nlocation`}
                                                                                placeholder="ระบุที่ตั้งสาขาใหม่"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={item.branchoffice_edit_nlocation}
                                                                                invalid={ docEditBranchTouch.branchoffice_edit_nlocation && docEditBranchError.branchoffice_edit_nlocation ? true : false }
                                                                                disabled={checkBoxEditBranchOffice === "0" || isDisableds}
                                                                            />
                                                                            {docEditBranchTouch.branchoffice_edit_nlocation && docEditBranchError.branchoffice_edit_nlocation ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docEditBranchError.branchoffice_edit_nlocation}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        );
                                                    })}
                                                    </>
                                                )}
                                            </>
                                        )}
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                { validation.touched.selected_check_branch && validation.errors.selected_check_branch ? 
                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.selected_check_branch}</FormFeedback> ) : false 
                                                }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-12-1">
                                            <Col md={10}>
                                                <div className="section-line"></div>
                                            </Col>
                                        </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("objective_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-13-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("objective_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">แก้ไขวัตถุประสงค์</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("7");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Company's Objective(s))</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.objective_select === "1" && (
                                            <>
                                                <Row id="section-page-13-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">สามารถเลือกได้มากกว่า 1 ช่อง</Label><br/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-13-3">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                            <Input
                                                                id="objectiveAddSelect"
                                                                type="checkbox"
                                                                name="objective_add_select"
                                                                className=""
                                                                checked={checkboxObjectiveAdd === "1"}
                                                                disabled={isDisableds}
                                                                invalid={validation.touched.selected_check_objective && validation.errors.selected_check_objective ? true : false}
                                                                onChange={(e) => {
                                                                    const value = e.target.checked;
                                                                    if(value){
                                                                        setCheckboxObjectiveAdd("1");
                                                                    } else {
                                                                        setCheckboxObjectiveAdd("0");
                                                                        validation.setFieldValue("objective_add_other", "");
                                                                        validationDraft.setFieldValue("objective_add_other", "");
                                                                        setFileNameObjectiveAddMultiple("");
                                                                        setFileObjectiveAdd([]);
                                                                        validation.handleChange("objective_add_file")("");
                                                                        validationDraft.handleChange("objective_add_file")("");
                                                                    }
                                                                    setIsSaveEnabled(true);
                                                                    validation.setFieldValue("objective_add_select", value ? "1" : "0");
                                                                    validationDraft.setFieldValue("objective_add_select", value ? "1" : "0");
                                                                }}
                                                                />
                                                            <Label className="label-title-checkbox-select" htmlFor="objectiveAddSelect">เพิ่มวัตถุประสงค์ (ข้อใหม่) (Adding the new objective(s))</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { checkboxObjectiveAdd === "1" && (
                                                    <>
                                                        <Row id="section-page-13-4">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="span-sub-title-topic-name">กรุณาแนบไฟล์ข้อความวัตถุประสงค์ที่ต้องการเพิ่ม (.doc)<span className="msg-require">*</span></Label><br/>
                                                                    <Label className="span-sub-title-topic-name">Please attach the document in .doc format (.doc) specifying the details of the new objective(s)</Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row id="section-page-13-5">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                <MultipleUploadfile inputID="fileObjectiveAdd" folder={dataFormRequest.request_no} dataFile={fileObjectiveAdd} setDataFile={OnSetFileObjectiveAdd} fileType={"doc"} isDisable={false}/>
                                                                { validation.touched.objective_add_file && validation.errors.objective_add_file ? 
                                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.objective_add_file}</FormFeedback> ) : false 
                                                                }
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}  
                                                <Row id="section-page-13-6">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                            <Input
                                                                id="objectiveEditSelect"
                                                                type="checkbox"
                                                                name="objective_edit_select"
                                                                className=""
                                                                checked={checkboxObjectiveEdit === "1"}
                                                                disabled={isDisableds}
                                                                invalid={validation.touched.selected_check_objective && validation.errors.selected_check_objective ? true : false}
                                                                onChange={(e) => {
                                                                    const value = e.target.checked;
                                                                    if(value){
                                                                        setCheckboxObjectiveEdit("1");
                                                                    } else {
                                                                        setCheckboxObjectiveEdit("0");
                                                                        setFileNameObjectiveEditMultiple("");
                                                                        setFileObjectiveEdit([]);
                                                                        validation.handleChange("objective_edit_file")("");
                                                                        validationDraft.handleChange("objective_edit_file")("");
                                                                    }
                                                                    setIsSaveEnabled(true);
                                                                    validation.setFieldValue("objective_edit_select", value ? "1" : "0");
                                                                    validationDraft.setFieldValue("objective_edit_select", value ? "1" : "0");
                                                                }}
                                                                />
                                                            <div>
                                                                <Label className="label-title-checkbox-select" htmlFor="objectiveEditSelect">
                                                                    แก้ไขวัตถุประสงค์ข้อเดิม (Amending the original objective(s))
                                                                </Label>
                                                                <span>
                                                                    <i className="mdi mdi-help-circle icon-hint-padding" id="PopoverRightMoreDetail1"></i>
                                                                </span>
                                                            </div>
                                                            <UncontrolledPopover placement="right" target="PopoverRightMoreDetail1">
                                                                <PopoverBody className="msg-show-hint">
                                                                    <i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุเลขข้อที่ต้องการแก้ไขด้วย<br/>
                                                                    Please specify the objective number you want to amend
                                                                </PopoverBody>
                                                            </UncontrolledPopover>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { checkboxObjectiveEdit === "1" && (
                                                    <>
                                                        <Row id="section-page-13-7">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="span-sub-title-topic-name">กรุณาแนบไฟล์ข้อความวัตถุประสงค์ที่ต้องการแก้ไข (.doc)<span className="msg-require">*</span></Label><br/>
                                                                    <Label className="span-sub-title-topic-name">Please attach the document in .doc format (.doc) specifying the details of new objective(s)</Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row id="section-page-13-8">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                <MultipleUploadfile inputID="fileObjectiveEdit" folder={dataFormRequest.request_no} dataFile={fileObjectiveEdit} setDataFile={OnSetFileObjectiveEdit} fileType={"doc"} isDisable={false}/>
                                                                { validation.touched.objective_edit_file && validation.errors.objective_edit_file ? 
                                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.objective_edit_file}</FormFeedback> ) : false 
                                                                }
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                <Row id="section-page-13-9">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                            <Input
                                                                id="objectiveMainSelect"
                                                                type="checkbox"
                                                                name="objective_main_select"
                                                                className=""
                                                                checked={checkboxObjectiveMain === "1"}
                                                                disabled={isDisableds}
                                                                invalid={validation.touched.selected_check_objective && validation.errors.selected_check_objective ? true : false}
                                                                onChange={(e) => {
                                                                    const value = e.target.checked;
                                                                    if(value){
                                                                        setCheckboxObjectiveMain("1");
                                                                    } else {
                                                                        setCheckboxObjectiveMain("0");
                                                                        validation.setFieldValue("objective_main_other", "");
                                                                        validationDraft.setFieldValue("objective_main_other", "");
                                                                    }
                                                                    setIsSaveEnabled(true);
                                                                    validation.setFieldValue("objective_main_select", value ? "1" : "0");
                                                                    validationDraft.setFieldValue("objective_main_select", value ? "1" : "0");
                                                                }}
                                                                />
                                                            <Label className="label-title-checkbox-select" htmlFor="objectiveMainSelect">วัตถุประสงค์หลัก (ระบุใน สสช.1) The main objective (specify in SSCH1 form)</Label> 
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { checkboxObjectiveMain === "1" && (
                                                    <Row id="section-page-13-10">
                                                        <Col md={10}>
                                                            <FormGroup>
                                                                <Label className="label-title">ระบุวัตถุประสงค์หลัก (The main objective)<span className="msg-require">*</span></Label>
                                                                <Input
                                                                    type="textarea"
                                                                    name="objective_main_other"
                                                                    placeholder="ระบุวัตถุประสงค์หลัก"
                                                                    autoComplete={autoCompletes}
                                                                    className="txt-text-area"
                                                                    // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                    onChange={(e) => {
                                                                        validation.handleChange(e);
                                                                        validationDraft.handleChange(e);
                                                                        setIsSaveEnabled(true);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.objective_main_other || ""}
                                                                    invalid={validation.touched.objective_main_other && validation.errors.objective_main_other ? true : false}
                                                                    disabled={isDisableds}
                                                                />
                                                                { validation.touched.objective_main_other && validation.errors.objective_main_other ? 
                                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.objective_main_other}</FormFeedback> ) : false 
                                                                }
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                )}
                                                <Row>
                                                    <Col md={10}>
                                                        <FormGroup>
                                                        { validation.touched.selected_check_objective && validation.errors.selected_check_objective ? 
                                                            ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.selected_check_objective}</FormFeedback> ) : false 
                                                        }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    <Row id="section-page-13-11">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("bylaws_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-14-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("bylaws_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">แก้ไขข้อบังคับ</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("8");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                ></i>
                                                <br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Article of Association)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.bylaws_select === "1" && (
                                            <>
                                                <Row id="section-page-14-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">สามารถเลือกได้มากกว่า 1 ข้อ</Label><br/>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-14-3">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                            <Input
                                                                id="bylawsAaddSelect"
                                                                type="checkbox"
                                                                name="bylaws_add_select"
                                                                className=""
                                                                checked={ischeckedBylawAddSelect === "1"}
                                                                disabled={isDisableds}
                                                                invalid={validation.touched.selected_check_bylaws && validation.errors.selected_check_bylaws ? true : false}
                                                                onChange={(e) => {
                                                                    const value = e.target.checked;
                                                                    if(value){
                                                                        setIscheckedBylawAddSelect("1");
                                                                    } else {
                                                                        setIscheckedBylawAddSelect("0");
                                                                        validation.handleChange("bylaws_add_file")("");
                                                                        validationDraft.handleChange("bylaws_add_file")("");
                                                                        setFileNameBylawAddMultiple("");
                                                                        setFileBylawAdd([]);
                                                                    }
                                                                    setIsSaveEnabled(true);
                                                                    validation.setFieldValue("bylaws_add_select", value ? "1" : "0");
                                                                    validationDraft.setFieldValue("bylaws_add_select", value ? "1" : "0");
                                                                }}
                                                                />
                                                            <Label className="label-title-checkbox-select" htmlFor="bylawsAaddSelect">เพิ่มข้อบังคับ (ข้อใหม่)<br/>(Adding the new Article(s) of Association)</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { ischeckedBylawAddSelect === "1" && (
                                                    <>
                                                        <Row id="section-page-14-4">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="span-sub-title-topic-name">กรุณาแนบไฟล์ข้อความที่ต้องการเพิ่ม (.doc)<span className="msg-require">*</span></Label><br/>
                                                                    <Label className="span-sub-title-topic-name">Please attach the document in .doc format (.doc) specifying the details of the new article(s)</Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row id="section-page-14-5">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                <MultipleUploadfile inputID="fileBylawAdd" folder={dataFormRequest.request_no} dataFile={fileBylawAdd} setDataFile={OnSetFileBylawAdd} fileType={"doc"} isDisable={false}/>
                                                                { validation.touched.bylaws_add_file && validation.errors.bylaws_add_file ? 
                                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.bylaws_add_file}</FormFeedback> ) : false 
                                                                }
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                <Row id="section-page-14-6">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap-checkbox">
                                                                <Input
                                                                    id="bylawsEditSelect"
                                                                    type="checkbox"
                                                                    name="bylaws_edit_select"
                                                                    className=""
                                                                    checked={ischeckedBylawEditSelect === "1"}
                                                                    disabled={isDisableds}
                                                                    invalid={validation.touched.selected_check_bylaws && validation.errors.selected_check_bylaws ? true : false}
                                                                    onChange={(e) => {
                                                                        const value = e.target.checked;
                                                                        if(value){
                                                                            setIscheckedBylawEditSelect("1");
                                                                        } else {
                                                                            setIscheckedBylawEditSelect("0");
                                                                            validation.handleChange("bylaws_edit_file")("");
                                                                            validationDraft.handleChange("bylaws_edit_file")("");
                                                                            setFileNameBylawEditMultiple("");
                                                                            setFileBylawEdit([]);
                                                                        }
                                                                        setIsSaveEnabled(true);
                                                                        validation.setFieldValue("bylaws_edit_select", value ? "1" : "0");
                                                                        validationDraft.setFieldValue("bylaws_edit_select", value ? "1" : "0");
                                                                    }}
                                                                />
                                                            <div>
                                                                <Label className="label-title-checkbox-select" htmlFor="bylawsEditSelect">
                                                                แก้ไขข้อบังคับข้อเดิม/เปลี่ยนทั้งฉบับ
                                                                </Label>
                                                                <span>
                                                                    <i className="mdi mdi-help-circle icon-hint-padding" id="PopoverRightByLawAdd2"></i>
                                                                </span>
                                                            </div>
                                                            <UncontrolledPopover placement="right" target="PopoverRightByLawAdd2">
                                                                <PopoverBody className="msg-show-hint">
                                                                    <i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุเลขข้อที่ต้องการแก้ไขด้วย<br/>
                                                                    Please specify the objective number you want to amend
                                                                </PopoverBody>
                                                            </UncontrolledPopover>

                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                { ischeckedBylawEditSelect === "1" && (
                                                    <>
                                                        <Row id="section-page-14-7">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="span-sub-title-topic-name">กรุณาแนบไฟล์ข้อความที่ต้องการแก้ไข (.doc)<span className="msg-require">*</span></Label><br/>
                                                                    <Label className="span-sub-title-topic-name">Please attach the document in .doc format (.doc) specifying the details of the new article(s)</Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row id="section-page-14-8">
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                <MultipleUploadfile inputID="fileBylawEdit" folder={dataFormRequest.request_no} dataFile={fileBylawEdit} setDataFile={OnSetFileBylawEdit} isDisable={false}/>
                                                                { validation.touched.bylaws_edit_file && validation.errors.bylaws_edit_file ? 
                                                                    ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.bylaws_edit_file}</FormFeedback> ) : false 
                                                                }
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                <Row>
                                                    <Col md={10}>
                                                        <FormGroup>
                                                        { validation.touched.selected_check_bylaws && validation.errors.selected_check_bylaws ? 
                                                            ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.selected_check_bylaws}</FormFeedback> ) : false 
                                                        }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    <Row id="section-page-14-9">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("cod_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-15-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("cod_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">เปลี่ยนแปลงรายชื่อกรรมการ และ/หรือเปลี่ยนแปลงกรรมการผู้มีอำนาจลงนามผูกพันบริษัท</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("9");
                                                            setIsSaveEnabled(true);
                                                            console.log(1);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Amendment of the Directors and/or  the Authorized Directors)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    { isShowSection.cod_select === "1" && (
                                        <>
                                        <Row>
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="span-sub-title pdleft-40">สามารถเลือกได้มากกว่า 1 ข้อ</Label><br/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-15-2">
                                            <Col md={10}>
                                                <FormGroup className="radio-gap-checkbox cod-checkbox no-margin-bottom">
                                                    <Input
                                                        id="codOutSelect"
                                                        type="checkbox"
                                                        name="cod_out_select"
                                                        className=""
                                                        checked={checkBoxCodOut === "1"}
                                                        disabled={isDisableds}
                                                        invalid={validation.touched.cod_out_select && validation.errors.cod_out_select ? true : false}
                                                        onChange={(e) => {
                                                            const value = e.target.checked;
                                                            // ตรวจสอบว่า doc_cod_out มีข้อมูลจริงหรือไม่
                                                            const docCodOut = validation.values.doc_cod_out || [];
                                                            const hasData = docCodOut.some(item => 
                                                                Object.values(item).some(val => val !== "" && val !== null && val !== undefined)
                                                            );

                                                            if (!value && hasData) {
                                                                
                                                                Swal.fire({
                                                                    title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                                                                    html: `
                                                                        คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                                                                        <br>
                                                                        Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                                                                    `,
                                                                    showCancelButton: true,
                                                                    confirmButtonText: "Remove",
                                                                    cancelButtonText: "Cancel",
                                                                    confirmButtonColor: "#FEEFEF", 
                                                                    customClass: {
                                                                        popup: 'custom-swal-popup',
                                                                        title: 'custom-swal-title-dbd',
                                                                        htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                                                                        image: 'custom-swal-image',
                                                                        actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                                                                        cancelButton: 'custom-swal-cancel',
                                                                        confirmButton: 'custom-swal-remove',
                                                                    },
                                                                    reverseButtons: true,
                                                                }).then((result) => {
                                                                    if (result.isConfirmed) {
                                                                        setCheckBoxCodOut("0");

                                                                        validation.setFieldValue("doc_cod_out", [{ ...modelCodOut }]);
                                                                        validationDraft.setFieldValue("doc_cod_out", [{ ...modelCodOut }]);

                                                                        setIsSaveEnabled(true);
                                                                        validation.setFieldValue("cod_out_select", "0");
                                                                        validationDraft.setFieldValue("cod_out_select", "0");

                                                                        Swal.fire({
                                                                            iconHtml: IconBin,
                                                                            title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                                                                            showConfirmButton: false,
                                                                            showCloseButton: true,
                                                                        });
                                                                    }
                                                                });
                                                            } else {
                                                                // ถ้าไม่มีข้อมูล เอาออกได้เลย
                                                                setCheckBoxCodOut(value ? "1" : "0");

                                                                validation.setFieldValue("doc_cod_out", [{ ...modelCodOut }]);
                                                                validationDraft.setFieldValue("doc_cod_out", [{ ...modelCodOut }]);

                                                                validation.setFieldValue("cod_out_select", value ? "1" : "0");
                                                                validationDraft.setFieldValue("cod_out_select", value ? "1" : "0");
                                                                
                                                                setIsSaveEnabled(true);
                                                            }
                                                        }}
                                                        />
                                                    <Label htmlFor="codOutSelect" className="label-sub-title-topic-b-radio">1.กรรมการที่ลาออก/พ้นวาระ<br/><p className="form-check-label-2row-detail">(The resigned / Rotated Director (s))</p></Label>
                                                    {/* <Label className="form-check-label-2row-detail">(The Resigned Director(s))</Label> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div>
                                            { checkBoxCodOut === "1" && (
                                                <>
                                                    {validation.values.doc_cod_out.map((item, index) => {
                                                        const docCodOutError = validation.errors.doc_cod_out?.length && validation.errors.doc_cod_out[index] || {};
                                                        const docCodOutTouch = validation.touched.doc_cod_out?.length && validation.touched.doc_cod_out[index] || {};
                                                        return (
                                                            <div id={"section-page-15-" + (index + 3)} key={"reqCodOut" + index}>
                                                                <Row>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">1.{index+1} คำนำหน้า ชื่อและนามสกุลภาษาไทย (Name-Surname in Thai)<span className="msg-require">*</span></Label><br/>
                                                                            <Input
                                                                                id={`txtCodOutName${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_cod_out[${index}].cod_out_name`}
                                                                                placeholder="ระบุคำนำหน้า ชื่อและนามสกุลภาษาไทย"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                value={item.cod_out_name}
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                invalid={ docCodOutTouch.cod_out_name && docCodOutError.cod_out_name ? true : false }
                                                                                disabled={isDisableds}
                                                                            />
                                                                            {docCodOutTouch.cod_out_name && docCodOutError.cod_out_name ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCodOutError.cod_out_name}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd-cod">
                                                                        <FormGroup>
                                                                            {index === 0 && validation.values.doc_cod_out.length < 10 ? (
                                                                                <i className={`mdi mdi-plus-circle ${isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={isDisableds ? null : OnClickPlusCodOut}  ></i>
                                                                            ) : (
                                                                                index === 0 && validation.values.doc_cod_out.length === 10 && ( 
                                                                                    <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                                )
                                                                            )}
                                                                            {index > 0 && (
                                                                                <i className={`mdi mdi-minus-circle ${isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={isDisableds ? null : () => OnClickMinusRemoveCodOut(index)} ></i>
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">คำนำหน้า ชื่อและนามสกุลภาษาอังกฤษ (Name-Surname in English)<span className="msg-require">*</span></Label><br/>
                                                                            <Input
                                                                                id={`txtCodOutNameEn${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_cod_out[${index}].cod_out_name_en`}
                                                                                placeholder="ระบุคำนำหน้า ชื่อและนามสกุลภาษาอังกฤษ"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                value={item.cod_out_name_en}
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                invalid={ docCodOutTouch.cod_out_name_en && docCodOutError.cod_out_name_en ? true : false }
                                                                                disabled={isDisableds}
                                                                            />
                                                                            {docCodOutTouch.cod_out_name_en && docCodOutError.cod_out_name_en ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCodOutError.cod_out_name_en}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        );
                                                    })}
                                                    <Row id="section-page-15-14">
                                                        <Col md={10}>
                                                            <div className="line-border-dbd"></div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                            
                                            <Row id="section-page-15-15">
                                                <Col md={10}>
                                                    <FormGroup className="radio-gap-checkbox cod-checkbox">
                                                        <Input
                                                            id="codAddSelect"
                                                            type="checkbox"
                                                            name="cod_add_select"
                                                            className=""
                                                            checked={checkBoxCodAdd === "1"}
                                                            disabled={isDisableds}
                                                            invalid={validation.touched.cod_add_select && validation.errors.cod_add_select ? true : false}
                                                            onChange={(e) => {
                                                                const value = e.target.checked;
                                                                // ตรวจสอบว่า doc_cod_add มีข้อมูลจริงหรือไม่
                                                                const docCodAdd = validation.values.doc_cod_add || [];
                                                                const hasData = docCodAdd.some(item => 
                                                                    Object.values(item).some(val => val !== "" && val !== null && val !== undefined)
                                                                );

                                                                if (!value && hasData) {
                                                                    
                                                                    Swal.fire({
                                                                        title: "Remove Information (นำข้อมูลออก)", // หัวข้อ
                                                                        html: `
                                                                            คุณยืนยันที่จะนำข้อมูลนี้ออกหรือไม่? หากนำออกแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก
                                                                            <br>
                                                                            Are you sure you want to remove the information? If you removed, it will not be able to be recovered.
                                                                        `,
                                                                        showCancelButton: true,
                                                                        confirmButtonText: "Remove",
                                                                        cancelButtonText: "Cancel",
                                                                        confirmButtonColor: "#FEEFEF", 
                                                                        customClass: {
                                                                            popup: 'custom-swal-popup',
                                                                            title: 'custom-swal-title-dbd',
                                                                            htmlContainer: 'custom-swal-text', // สำหรับ text หรือ html container
                                                                            image: 'custom-swal-image',
                                                                            actions: 'custom-swal-actions', // กำหนด class สำหรับ actions ของปุ่ม
                                                                            cancelButton: 'custom-swal-cancel',
                                                                            confirmButton: 'custom-swal-remove',
                                                                        },
                                                                        reverseButtons: true,
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            setCheckBoxCodAdd("0");
                                                                            setFileCod([]);

                                                                            validation.setFieldValue("doc_cod_add", [{ ...modelCodAdd }]);
                                                                            validationDraft.setFieldValue("doc_cod_add", [{ ...modelCodAdd }]);

                                                                            setIsSaveEnabled(true);
                                                                            validation.setFieldValue("cod_add_select", "0");
                                                                            validationDraft.setFieldValue("cod_add_select", "0");

                                                                            Swal.fire({
                                                                                iconHtml: IconBin,
                                                                                title: 'นำข้อมูลออกแล้ว\nThe information has been removed.',
                                                                                showConfirmButton: false,
                                                                                showCloseButton: true,
                                                                            });
                                                                        }
                                                                    });
                                                                } else {
                                                                    // ถ้าไม่มีข้อมูล เอาออกได้เลย
                                                                    setCheckBoxCodAdd(value ? "1" : "0");
                                                                    setFileCod([]);

                                                                    validation.setFieldValue("doc_cod_add", [{ ...modelCodAdd }]);
                                                                    validationDraft.setFieldValue("doc_cod_add", [{ ...modelCodAdd }]);

                                                                    validation.setFieldValue("cod_add_select", value ? "1" : "0");
                                                                    validationDraft.setFieldValue("cod_add_select", value ? "1" : "0");
                                                                    
                                                                    setIsSaveEnabled(true);
                                                                }
                                                            }}
                                                            />
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="d-flex align-items-center gap-1">
                                                                <Label htmlFor="codAddSelect" className="label-sub-title-topic-b-radio mb-0">
                                                                2.กรรมการที่เข้าใหม่
                                                                </Label>
                                                                <i
                                                                className="mdi mdi-help-circle icon-hint-padding"
                                                                id="PopoverRightOut2"
                                                                style={{ cursor: 'pointer' }}
                                                                ></i>
                                                            </div>

                                                            <p className="form-check-label-2row-detail mb-0">(The New Director(s))</p>
                                                        </div>

                                                        <UncontrolledPopover placement="right" target="PopoverRightOut2">
                                                        <PopoverBody className="msg-show-hint">
                                                            <i className="mdi mdi-help-circle msg-icon-hint"></i>
                                                            ถ้าเป็นกรรมการชาวต่างชาติ ให้ระบุรายละเอียดที่อยู่ของกรรมการทั้งภาษาไทยและภาษาอังกฤษลงในข้อ 5.<br />
                                                            If there are the new foreign director(s), please provide the details of their addresses in both Thai and English in item 5.
                                                        </PopoverBody>
                                                        </UncontrolledPopover>
                                                        {/* <Label className="span-sub-title-topic-name">(The New Director(s))</Label> */}
                                                        {/* <Label className="form-check-label-2row-detail">(The Resigned Director(s))</Label> */}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            { checkBoxCodAdd === "1" && (
                                                <>
                                                    {validation.values.doc_cod_add.map((item, index) => {
                                                        const docCodAddError = validation.errors.doc_cod_add?.length && validation.errors.doc_cod_add[index] || {};
                                                        const docCodAddTouch = validation.touched.doc_cod_add?.length && validation.touched.doc_cod_add[index] || {};
                                                        return (
                                                            <div id={"section-page-15-" + (index + 16)} key={"reqCodAdd" + index}>
                                                                <Row>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">2.{index+1} คำนำหน้า ชื่อและนามสกุลภาษาไทย (Name-Surname in Thai)<span className="msg-require">*</span></Label><br/>
                                                                            <Input
                                                                                id={`txtCodAddName${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_cod_add[${index}].cod_add_name`}
                                                                                placeholder="ระบุคำนำหน้า ชื่อและนามสกุลภาษาไทย"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                value={item.cod_add_name}
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                invalid={ docCodAddTouch.cod_add_name && docCodAddError.cod_add_name ? true : false }
                                                                                disabled={isDisableds}
                                                                            />
                                                                            {docCodAddTouch.cod_add_name && docCodAddError.cod_add_name ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCodAddError.cod_add_name}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd-cod">
                                                                        <FormGroup>
                                                                            {index === 0 && validation.values.doc_cod_add.length < 10 ? (
                                                                                <i className={`mdi mdi-plus-circle ${isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={isDisableds ? null : OnClickPlusCodAdd}  ></i>
                                                                            ) : (
                                                                                index === 0 && validation.values.doc_cod_add.length === 10 && ( 
                                                                                    <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                                )
                                                                            )}
                                                                            {index > 0 && (
                                                                                <i className={`mdi mdi-minus-circle ${isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={isDisableds ? null : () => OnClickMinusRemoveCodAdd(index)} ></i>
                                                                            )}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">คำนำหน้า ชื่อและนามสกุลภาษาอังกฤษ (Name-Surname in English)<span className="msg-require">*</span></Label><br/>
                                                                            <Input
                                                                                id={`txtCodAddNameEn${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_cod_add[${index}].cod_add_name_en`}
                                                                                placeholder="ระบุคำนำหน้า ชื่อและนามสกุลภาษาอังกฤษ"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                value={item.cod_add_name_en}
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                invalid={ docCodAddTouch.cod_add_name_en && docCodAddError.cod_add_name_en ? true : false }
                                                                                disabled={isDisableds}
                                                                            />
                                                                            {docCodAddTouch.cod_add_name_en && docCodAddError.cod_add_name_en ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCodAddError.cod_add_name_en}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={5}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">เบอร์โทรศัพท์ (Telephone No.)<span className="msg-require">*</span></Label><br/>
                                                                            <Input
                                                                                id={`txtCodAddTel${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_cod_add[${index}].cod_add_tel`}
                                                                                placeholder="ระบุเบอร์โทรศัพท์"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                value={item.cod_add_tel}
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                invalid={ docCodAddTouch.cod_add_tel && docCodAddError.cod_add_tel ? true : false }
                                                                                disabled={isDisableds}
                                                                            />
                                                                            {docCodAddTouch.cod_add_tel && docCodAddError.cod_add_tel ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCodAddError.cod_add_tel}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={5}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">อีเมล (Email)<span className="msg-require">*</span></Label><br/>
                                                                            <Input
                                                                                id={`txtCodAddEmail${index + 1}`}
                                                                                type="text"
                                                                                name={`doc_cod_add[${index}].cod_add_email`}
                                                                                placeholder="ระบุชื่ออีเมล"
                                                                                autoComplete={autoCompletes}
                                                                                className="txt-placeholder"
                                                                                value={item.cod_add_email}
                                                                                onChange={(e) => {
                                                                                    validation.handleChange(e);
                                                                                    validationDraft.handleChange(e);
                                                                                    setIsSaveEnabled(true);
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                invalid={ docCodAddTouch.cod_add_email && docCodAddError.cod_add_email ? true : false }
                                                                                disabled={isDisableds}
                                                                            />
                                                                            {docCodAddTouch.cod_add_email && docCodAddError.cod_add_email ? (
                                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                    {docCodAddError.cod_add_email}
                                                                                </FormFeedback>
                                                                            ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                            <Label className="label-title">แนบไฟล์สำเนาบัตรประชาชน/หนังสือเดินทาง (Passport) และ Work Permit ที่มีรายละเอียดบนหน้าบัตรชัดเจนและยังไม่หมดอายุ (.pdf)<span className="msg-require">*</span><br/>Attach the copy (.pdf) of Thai National ID Card / Passport and Work permit with the clear details and not expired</Label>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={10}>
                                                                        <FormGroup>
                                                                        <MultipleUploadfile 
                                                                            inputID={`fileCod${index + 1}`} 
                                                                            folder={dataFormRequest.request_no} 
                                                                            dataFile={fileCod[index] || setStringFileNameToArray(item?.cod_add_file) || []} 
                                                                            setDataFile={(files) => {
                                                                                const updatedFiles = [...fileCod];
                                                                                updatedFiles[index] = files;
                                                                                const names = files.map(file => file.name).join(",");
                                                                                setFileCod(updatedFiles);
                                                                                validation.setFieldValue(`doc_cod_add[${index}].file_cod_add_file`, updatedFiles[index] || []);
                                                                                validationDraft.setFieldValue(`doc_cod_add[${index}].file_cod_add_file`, updatedFiles[index] || []);
                                                                                validation.setFieldValue(`doc_cod_add[${index}].cod_add_file`, names || "");
                                                                                validationDraft.setFieldValue(`doc_cod_add[${index}].cod_add_file`, names || "");
                                                                                setIsSaveEnabled(true);
                                                                            }}  
                                                                            isDisable={false}
                                                                        />
                                                                        {docCodAddTouch.cod_add_file && docCodAddError.cod_add_file ? (
                                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                                {docCodAddError.cod_add_file}
                                                                            </FormFeedback>
                                                                        ) : null}
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        );
                                                    })}
                                                    <Row id="section-page-15-27">
                                                        <Col md={10}>
                                                            <div className="line-border-dbd"></div>
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </div>
                                        <div>
                                            <Row id="section-page-15-28">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="label-sub-title-topic-b-radio pdleft-30">3.อำนาจของกรรมการซึ่งลงลายมือชื่อผูกพันบริษัท (ปัจจุบัน)</Label><span className="msg-require">*</span><br/>
                                                        <Label className="form-check-label-2row-detail pdleft-30">(The authority of the current directors)</Label>
                                                        {/* <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightDirectorCurrent"></i>
                                                        <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightDirectorCurrent">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "ไม่มี"<br/>If not available, please specify "None"</PopoverBody>
                                                        </UncontrolledPopover>
                                                        </div> */}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-15-29">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Input
                                                            type="textarea"
                                                            name="cod_current_powerofdirector"
                                                            placeholder="ระบุข้อมูล"
                                                            autoComplete={autoCompletes}
                                                            className="txt-text-area"
                                                            onChange={(e) => {
                                                                validation.handleChange(e);
                                                                validationDraft.handleChange(e);
                                                                setIsSaveEnabled(true);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.cod_current_powerofdirector || ""}
                                                            invalid={validation.touched.cod_current_powerofdirector && validation.errors.cod_current_powerofdirector ? true : false}
                                                            disabled={isDisableds}
                                                        />
                                                        {validation.touched.cod_current_powerofdirector && validation.errors.cod_current_powerofdirector ? (
                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                {validation.errors.cod_current_powerofdirector}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-15-30">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="label-sub-title-topic-b-radio pdleft-30">4.อำนาจของกรรมการซึ่งลงลายมือชื่อผูกพันบริษัท (ใหม่)</Label><span className="msg-require">*</span><br/>
                                                        <Label className="form-check-label-2row-detail pdleft-30">(The authority of the new directors)</Label>
                                                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightDirectorNew"></i>
                                                        <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightDirectorNew">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> หากไม่เปลี่ยนอำนาจของกรรมการซึ่งลงลายมือชื่อผูกพันบริษัท ให้ระบุ “ไม่เปลี่ยนแปลง”<br/>If there is no change, please specify “No change"</PopoverBody>
                                                        </UncontrolledPopover>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-15-31">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Input
                                                            type="textarea"
                                                            name="cod_new_powerofdirector"
                                                            placeholder="ระบุข้อมูล"
                                                            autoComplete={autoCompletes}
                                                            className="txt-text-area"
                                                            onChange={(e) => {
                                                                validation.handleChange(e);
                                                                validationDraft.handleChange(e);
                                                                setIsSaveEnabled(true);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.cod_new_powerofdirector || ""}
                                                            invalid={validation.touched.cod_new_powerofdirector && validation.errors.cod_new_powerofdirector ? true : false}
                                                            disabled={isDisableds}
                                                        />
                                                        {validation.touched.cod_new_powerofdirector && validation.errors.cod_new_powerofdirector ? (
                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                {validation.errors.cod_new_powerofdirector}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-15-32">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="label-sub-title-topic-b-radio pdleft-30">5.ระบุเพิ่มเติม</Label><span className="msg-require">*</span><br/>
                                                        <Label className="form-check-label-2row-detail pdleft-30">(Please specify more details)</Label>
                                                        <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightRemark"></i>
                                                        <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightRemark">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "ไม่มี"<br/>If not available, please specify "None"</PopoverBody>
                                                        </UncontrolledPopover>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row id="section-page-15-33">
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Input
                                                            type="textarea"
                                                            name="cod_remark"
                                                            placeholder="ระบุข้อมูลเพิ่มเติม"
                                                            autoComplete={autoCompletes}
                                                            className="txt-text-area"
                                                            onChange={(e) => {
                                                                validation.handleChange(e);
                                                                validationDraft.handleChange(e);
                                                                setIsSaveEnabled(true);
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.cod_remark || ""}
                                                            invalid={validation.touched.cod_remark && validation.errors.cod_remark ? true : false}
                                                            disabled={isDisableds}
                                                        />
                                                        {validation.touched.cod_remark && validation.errors.cod_remark ? (
                                                            <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                {validation.errors.cod_remark}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                        </>
                                    )}
                                    <Row id="section-page-15-34">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("coa_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-16-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("coa_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">เรียกชำระค่าหุ้นเพิ่ม </Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("10");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Calling of the Additional Share Payment)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.coa_select === "1" && (
                                            <>
                                                <Row id="section-page-16-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">1.ราคาค่าหุ้นที่เรียกชำระแล้ว...บาท/หุ้น (Paid-up share price : Baht/Share)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="coa_share_bath"
                                                                placeholder="ระบุราคาค่าหุ้น"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumber(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.coa_share_bath) || "" }
                                                                invalid={validation.touched.coa_share_bath && validation.errors.coa_share_bath ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.coa_share_bath && validation.errors.coa_share_bath ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.coa_share_bath}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-16-3">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">2.จำนวนหุ้นที่จะเรียกชำระ...หุ้น (Number of shares to be called for payment : Shares)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="coa_share_number"
                                                                placeholder="ระบุจำนวนหุ้น"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumberWithoutDecimal(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.coa_share_number) || ""}
                                                                invalid={validation.touched.coa_share_number && validation.errors.coa_share_number ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.coa_share_number && validation.errors.coa_share_number ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.coa_share_number}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-16-4">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">3.ราคาค่าหุ้นที่เรียกชำระเพิ่ม...บาท/หุ้น (Additional share price : Baht/Share)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="coa_share_addition"
                                                                placeholder="ระบุราคาค่าหุ้น"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumber(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.coa_share_addition) || ""}
                                                                invalid={validation.touched.coa_share_addition && validation.errors.coa_share_addition ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.coa_share_addition && validation.errors.coa_share_addition ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.coa_share_addition}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-16-5">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">4.รวมเป็นจำนวนเงินที่เรียกชำระในครั้งนี้...บาท (The total amount due for this payment : Baht)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="coa_share_total"
                                                                placeholder="ระบุจำนวนเงิน"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                // placeholder="โปรดระบุรายละเอียดที่อยู่โดยละเอียด Please specify the address of place of performance."
                                                                onChange={(e) => {
                                                                    ValidateNumber(e);
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={ formatNumberWithComma(validation.values.coa_share_total) || ""}
                                                                invalid={validation.touched.coa_share_total && validation.errors.coa_share_total ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.coa_share_total && validation.errors.coa_share_total ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.coa_share_total}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-16-6">
                                                    <Col md={5}>
                                                        <FormGroup>
                                                            <Label className="label-title">5.วันที่ชำระค่าหุ้นเพิ่ม (Payment date)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="date"
                                                                // min={new Date().toISOString().split('T')[0]}
                                                                id="termPaymentDate"
                                                                name="coa_share_date"
                                                                className="form-control"
                                                                value={coaShareDate || ""}
                                                                invalid={validation.touched.coa_share_date && validation.errors.coa_share_date ? true : false}
                                                                onChange={handleCoaShareDateChange}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.coa_share_date && validation.errors.coa_share_date ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.coa_share_date}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    <Row id="section-page-16-7">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("ts_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-17-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("ts_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">โอนหุ้น</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("11");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i><br/>
                                                <Label className="label-sub-title-topic">(Share Transfer)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.ts_select === "1" && (
                                            <>
                                            <Row>
                                                <Col md={10}>
                                                    <FormGroup>
                                                        <Label className="span-sub-title pdleft-15">สามารถเลือกเพิ่มคู่สัญญาได้</Label><br/>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            {validation.values.doc_ctp.map((item, index) => {
                                                const docCtpError = validation.errors.doc_ctp?.length && validation.errors.doc_ctp[index] || {};
                                                const docCtpTouch = validation.touched.doc_ctp?.length && validation.touched.doc_ctp[index] || {};
                                                return (
                                                    <div id={"section-page-17-" + (index + 2)} key={"reqCtp" + index}>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="label-title-number-section">คู่สัญญาที่ {index+1} The contracting party No.{index+1}</Label><br/>
                                                                    <Label className="label-title">ชื่อผู้โอน (transferor)<span className="msg-require">*</span></Label><br/>
                                                                    <Input
                                                                        id={`txtTsCtpTransferor${index + 1}`}
                                                                        type="text"
                                                                        name={`doc_ctp[${index}].ts_ctp_transferor`}
                                                                        placeholder="ระบุชื่อผู้โอน"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        value={item.ts_ctp_transferor}
                                                                        onChange={(e) => {
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={ docCtpTouch.ts_ctp_transferor && docCtpError.ts_ctp_transferor ? true : false }
                                                                        disabled={isDisableds}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_transferor && docCtpError.ts_ctp_transferor ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_transferor}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd">
                                                                <FormGroup>
                                                                    {index === 0 && validation.values.doc_ctp.length < 5 ? (
                                                                        <i className={`mdi mdi-plus-circle ${isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={isDisableds ? null : OnClickPlusCtp}  ></i>
                                                                    ) : (
                                                                        index === 0 && validation.values.doc_ctp.length === 5 && ( 
                                                                            <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                        )
                                                                    )}
                                                                    {index > 0 && (
                                                                        <i className={`mdi mdi-minus-circle ${isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={isDisableds ? null : () => OnClickMinusRemoveCtp(index)} ></i>
                                                                    )}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="label-title">ชื่อผู้รับโอน (Transferee)<span className="msg-require">*</span></Label><br/>
                                                                    <Input
                                                                        id={`txtTsCtpTransferee${index + 1}`}
                                                                        type="text"
                                                                        name={`doc_ctp[${index}].ts_ctp_transferee`}
                                                                        placeholder="ระบุชื่อผู้รับโอน"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        value={item.ts_ctp_transferee}
                                                                        onChange={(e) => {
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={ docCtpTouch.ts_ctp_transferee && docCtpError.ts_ctp_transferee ? true : false }
                                                                        disabled={isDisableds}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_transferee && docCtpError.ts_ctp_transferee ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_transferee}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="label-title">ประเภทหุ้นและจำนวนหุ้นที่โอน (Type and total of share transferred)<span className="msg-require">*</span></Label><br/>
                                                                    <Input
                                                                        id={`txtTsCtpAmountshare${index + 1}`}
                                                                        type="text"
                                                                        name={`doc_ctp[${index}].ts_ctp_amountshare`}
                                                                        placeholder="ระบุประเภทหุ้นและจำนวนหุ้นที่โอน"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        value={item.ts_ctp_amountshare}
                                                                        onChange={(e) => {
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={ docCtpTouch.ts_ctp_amountshare && docCtpError.ts_ctp_amountshare ? true : false }
                                                                        disabled={isDisableds}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_amountshare && docCtpError.ts_ctp_amountshare ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_amountshare}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="label-title">ราคาซื้อขายหุ้นละ/บาท (Transfer price of each share)<span className="msg-require">*</span></Label><br/>
                                                                    <Input
                                                                        id={`txtTsCtpPerShare${index + 1}`}
                                                                        type="text"
                                                                        name={`doc_ctp[${index}].ts_ctp_pershare`}
                                                                        placeholder="ระบุราคาซื้อขายหุ้น"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        value={ formatNumberWithComma(item.ts_ctp_pershare)}
                                                                        onChange={(e) => {
                                                                            ValidateNumber(e);
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={ docCtpTouch.ts_ctp_pershare && docCtpError.ts_ctp_pershare ? true : false }
                                                                        disabled={isDisableds}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_pershare && docCtpError.ts_ctp_pershare ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_pershare}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="label-title">รวมราคาซื้อขายทั้งสิ้น/บาท (The total of transfer price)<span className="msg-require">*</span></Label><br/>
                                                                    <Input
                                                                        id={`txtTsCtpTotalShare${index + 1}`}
                                                                        type="text"
                                                                        name={`doc_ctp[${index}].ts_ctp_totalshare`}
                                                                        placeholder="ระบุรวมราคาซื้อขายทั้งสิ้น"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        value={ formatNumberWithComma(item.ts_ctp_totalshare)}
                                                                        onChange={(e) => {
                                                                            ValidateNumber(e);
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={ docCtpTouch.ts_ctp_totalshare && docCtpError.ts_ctp_totalshare ? true : false }
                                                                        disabled={isDisableds}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_totalshare && docCtpError.ts_ctp_totalshare ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_totalshare}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={5}>
                                                                <FormGroup>
                                                                    <Label className="label-title">จ่ายเงินวันที่ (Payment date)<span className="msg-require">*</span></Label><br/>
                                                                    <Input
                                                                        id={`txtTsCtpTotalShare${index + 1}`}
                                                                        type="date"
                                                                        name={`doc_ctp[${index}].ts_ctp_paydate`}
                                                                        placeholder="ระบุรวมราคาซื้อขายทั้งสิ้น"
                                                                        autoComplete={autoCompletes}
                                                                        className="txt-placeholder"
                                                                        value={item.ts_ctp_paydate}
                                                                        onChange={(e) => {
                                                                            validation.handleChange(e);
                                                                            validationDraft.handleChange(e);
                                                                            setIsSaveEnabled(true);
                                                                        }}
                                                                        onBlur={validation.handleBlur}
                                                                        invalid={ docCtpTouch.ts_ctp_paydate && docCtpError.ts_ctp_paydate ? true : false }
                                                                        disabled={isDisableds}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_paydate && docCtpError.ts_ctp_paydate ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_paydate}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <Label className="span-sub-title-topic-name">แนบไฟล์สำเนาบัตรประชาชน/หนังสือเดินทางและ ใบอนุญาตทำงาน/หนังสือรับรองบริษัทของผู้โอนและ ผู้รับโอน ที่มีรายละเอียดบนหน้าบัตรชัดเจนและยังไม่หมดอายุ (.pdf)<span className="msg-require">*</span><br/>Attach the copy (.pdf) of Thai National ID Card / Passport and Work Permit / Affidavit of the transferor and transferee with clear details and not expired.</Label><br/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={10}>
                                                                <FormGroup>
                                                                    <MultipleUploadfile 
                                                                        inputID={`fileCtp${index + 1}`} 
                                                                        folder={dataFormRequest.request_no} 
                                                                        dataFile={fileCtp[index] || setStringFileNameToArray(item?.ts_ctp_file) || []} 
                                                                        setDataFile={(files) => {
                                                                            const updatedFiles = [...fileCtp];
                                                                            updatedFiles[index] = files;
                                                                            const names = files.map(file => file.name).join(",");
                                                                            setFileCtp(updatedFiles);
                                                                            validation.setFieldValue(`doc_ctp[${index}].file_ts_ctp_file`, updatedFiles[index] || []);
                                                                            validationDraft.setFieldValue(`doc_ctp[${index}].file_ts_ctp_file`, updatedFiles[index] || []);
                                                                            validation.setFieldValue(`doc_ctp[${index}].ts_ctp_file`, names || "");
                                                                            validationDraft.setFieldValue(`doc_ctp[${index}].ts_ctp_file`, names || "");
                                                                            setIsSaveEnabled(true);
                                                                        }}  
                                                                        isDisable={false}
                                                                    />
                                                                    {docCtpTouch.ts_ctp_file && docCtpError.ts_ctp_file ? (
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {docCtpError.ts_ctp_file}
                                                                        </FormFeedback>
                                                                    ) : null}
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                );
                                            })}
                                            </>
                                        )}
                                        <Row id="section-page-17-8"> 
                                            <Col md={10}>
                                                <div class="section-line"></div>
                                            </Col>
                                        </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("dtc_select") && (
                            <>
                                <div id="section-page-18-1">
                                    <Row>
                                        <Col md={12} className="mx-auto">
                                            <Row>
                                                <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("dtc_select")}>
                                                    <FormGroup>
                                                        <i className="mdi mdi-book-open-variant icon-book"></i>
                                                        <Label className="label-title-topic">เลิกบริษัท</Label>
                                                        <i className="mdi mdi-close icon-close-book"
                                                            onClick={(event) => {
                                                                if(!isDisableds){
                                                                    event.stopPropagation(); 
                                                                    handleDeleteClick("12");
                                                                    setIsSaveEnabled(true);
                                                                }
                                                            }}
                                                        >
                                                        </i>
                                                        <br/>
                                                        <Label className="label-sub-title-topic">(Company Liquidation)</Label>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                                { isShowSection.dtc_select === "1" && (
                                    <>
                                        <Row id="section-page-18-2">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">1.ชื่อ-นามสกุลผู้ชำระบัญชี</Label>
                                                    <i className="mdi mdi-help-circle icon-hint-padding" id="PopoverRightName1"></i>
                                                    <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightName1">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "ไม่มี"<br/>If not available, please specify "None"</PopoverBody>
                                                        </UncontrolledPopover>
                                                    </div>
                                                    <Label className="span-sub-title-topic-name">The name of the liquidator(s)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {validation.values.doc_liquidator.map((item, index) => {
                                            const docLiquidatorError = validation.errors.doc_liquidator?.length && validation.errors.doc_liquidator[index] || {};
                                            const docLiquidatorTouch = validation.touched.doc_liquidator?.length && validation.touched.doc_liquidator[index] || {};
                                            return (
                                                <div id={"section-page-18-" + (index + 3)} key={"reqDocLiquidator" + index}>
                                                    <Row>
                                                        <Col md={10}>
                                                        <FormGroup>
                                                        <Label className="label-title">1.{index+1} คำนำหน้า ชื่อและนามสกุล (Name-Surname)<span className="msg-require">*</span></Label><br/>
                                                            <Input id={`txtLiquidator${index + 1}`}
                                                                type="text"
                                                                name={`doc_liquidator[${index}].dtc_liquidator`}
                                                                placeholder="ระบุคำนำหน้า ชื่อและนามสกุล"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={item.dtc_liquidator}
                                                                invalid={ docLiquidatorTouch.dtc_liquidator && docLiquidatorError.dtc_liquidator ? true : false }
                                                                disabled={isDisableds}
                                                            />
                                                            {docLiquidatorTouch.dtc_liquidator && docLiquidatorError.dtc_liquidator ? (
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {docLiquidatorError.dtc_liquidator}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </FormGroup>
                                                        </Col>
                                                        <Col md={1} className="d-flex justify-content-start align-items-center icon-inline-dbd-dtc">
                                                            <FormGroup>
                                                                {index === 0 && validation.values.doc_liquidator.length < 5 ? (
                                                                    <i className={`mdi mdi-plus-circle ${isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={isDisableds ? null : OnClickPlusLiquidator}  ></i>
                                                                ) : (
                                                                    index === 0 && validation.values.doc_liquidator.length === 5 && ( 
                                                                        <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                    )
                                                                )}
                                                                {index > 0 && (
                                                                    <i className={`mdi mdi-minus-circle ${isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={isDisableds ? null : () => OnClickRemoveLiquidator(index)} ></i>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })}
                                        <Row id="section-page-18-6">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">2. อำนาจผู้ชำระบัญชี<span className="msg-require">*</span></Label><br/>
                                                    <Label className="span-sub-title-topic-name">The power of the liquidator(s)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-7">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name="dtc_powerofliquidator"
                                                        placeholder="ระบุข้อมูล"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.dtc_powerofliquidator || ""}
                                                        invalid={validation.touched.dtc_powerofliquidator && validation.errors.dtc_powerofliquidator ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.dtc_powerofliquidator && validation.errors.dtc_powerofliquidator ? 
                                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.dtc_powerofliquidator}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-8">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">3. สำนักงานผู้ชำระบัญชี<span className="msg-require">*</span></Label><br/>
                                                    <Label className="span-sub-title-topic-name">The office(s) of the liquidator(s)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-9">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name="dtc_liquidatoroffice_name"
                                                        placeholder="ระบุข้อมูล"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.dtc_liquidatoroffice_name || ""}
                                                        invalid={validation.touched.dtc_liquidatoroffice_name && validation.errors.dtc_liquidatoroffice_name ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.dtc_liquidatoroffice_name && validation.errors.dtc_liquidatoroffice_name ? 
                                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.dtc_liquidatoroffice_name}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-10">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">4. กรุณาแนบไฟล์ทะเบียนบ้านสำนักงานผู้ชำระบัญชี<span className="msg-require">*</span></Label><br/>
                                                    <Label className="span-sub-title-topic-name">Please Attach the copy(.pdf) of the House Registration of the office(s) of liquidator(s)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-11">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <MultipleUploadfile inputID="fileLiquidator" folder={dataFormRequest.request_no} dataFile={fileLiquidator} fileType={"pdf"} setDataFile={OnSetFileLiquidator} isDisable={false}/>
                                                    { validation.touched.dtc_liquidatoroffice_file && validation.errors.dtc_liquidatoroffice_file ? 
                                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.dtc_liquidatoroffice_file}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-12">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">5.ชื่อ-นามสกุลผู้สอบบัญชี</Label>
                                                    <i className="mdi mdi-help-circle icon-hint-padding" id="PopoverRightName5"></i>
                                                    <div className="hstack flex-wrap gap-2">
                                                        <UncontrolledPopover placement="right" target="PopoverRightName5">
                                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ถ้าไม่มีให้ระบุ "ไม่มี"<br/>If not available, please specify "None"</PopoverBody>
                                                        </UncontrolledPopover>
                                                    </div>
                                                    <Label className="span-sub-title-topic-name">The name of the auditor(s)</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {validation.values.doc_auditor.map((item, index) => {
                                            const docAuditorError = validation.errors.doc_auditor?.length && validation.errors.doc_auditor[index] || {};
                                            const docAuditorTouch = validation.touched.doc_auditor?.length && validation.touched.doc_auditor[index] || {};
                                            return (
                                                <div id={"section-page-18-" + (index + 3)} key={"reqDocAuditor" + index}>
                                                    <Row>
                                                        <Col md={10}>
                                                        <FormGroup>
                                                        <Label className="label-title">5.{index+1} คำนำหน้า ชื่อและนามสกุล (Name-Surname)<span className="msg-require">*</span></Label><br/>
                                                            <Input id={`txtAuditor${index + 1}`}
                                                                type="text"
                                                                name={`doc_auditor[${index}].dtc_auditor`}
                                                                placeholder="ระบุคำนำหน้า ชื่อและนามสกุล"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={item.dtc_auditor}
                                                                invalid={ docAuditorTouch.dtc_auditor && docAuditorError.dtc_auditor ? true : false }
                                                                disabled={isDisableds}
                                                            />
                                                            {docAuditorTouch.dtc_auditor && docAuditorError.dtc_auditor ? (
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {docAuditorError.dtc_auditor}
                                                                </FormFeedback>
                                                            ) : null}
                                                        </FormGroup>
                                                        </Col>
                                                        <Col md={1} className="d-flex justify-content-start align-items-center icon-inline">
                                                            <FormGroup>
                                                                {index === 0 && validation.values.doc_auditor.length < 5 ? (
                                                                    <i className={`mdi mdi-plus-circle ${isDisableds ? "icon-disabled" : "icon-plus"}`}  onClick={isDisableds ? null : OnClickPlusAuditor}  ></i>
                                                                ) : (
                                                                    index === 0 && validation.values.doc_auditor.length === 5 && ( 
                                                                        <i className="mdi mdi-plus-circle icon-disabled" onClick={() => setIsShowModalLimit(true)}></i>
                                                                    )
                                                                )}
                                                                {index > 0 && (
                                                                    <i className={`mdi mdi-minus-circle ${isDisableds ? "icon-disabled" : "icon-minus-dbd"}`} onClick={isDisableds ? null : () => OnClickRemoveAuditor(index)} ></i>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })}
                                        <Row id="section-page-18-16">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">6. ชื่อสำนักงานของผู้สอบบัญชี<span className="msg-require">*</span></Label><br/>
                                                    <Label className="span-sub-title-topic-name">The name of the auditor's office</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-17">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name="dtc_auditoroffice"
                                                        placeholder="ระบุชื่อสำนักงานของผู้สอบบัญชี"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.dtc_auditoroffice || ""}
                                                        invalid={validation.touched.dtc_auditoroffice && validation.errors.dtc_auditoroffice ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.dtc_auditoroffice && validation.errors.dtc_auditoroffice ? 
                                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.dtc_auditoroffice}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-18">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Label className="label-sub-title-topic-b-radio pdleft-15">7. ค่าสินจ้างผู้สอบบัญชี/บาท<span className="msg-require">*</span></Label><br/>
                                                    <Label className="span-sub-title-topic-name">The audit fee/Baht</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row id="section-page-18-19">
                                            <Col md={10}>
                                                <FormGroup>
                                                    <Input
                                                        type="text"
                                                        name="dtc_auditorfee"
                                                        placeholder="ระบุค่าสินจ้างผู้สอบบัญชี"
                                                        autoComplete={autoCompletes}
                                                        className="txt-placeholder"
                                                        onChange={(e) => {
                                                            ValidateNumber(e);
                                                            validation.handleChange(e);
                                                            validationDraft.handleChange(e);
                                                            setIsSaveEnabled(true);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={ formatNumberWithComma(validation.values.dtc_auditorfee) || ""}
                                                        invalid={validation.touched.dtc_auditorfee && validation.errors.dtc_auditorfee ? true : false}
                                                        disabled={isDisableds}
                                                    />
                                                    { validation.touched.dtc_auditorfee && validation.errors.dtc_auditorfee ? 
                                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.dtc_auditorfee}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <Row id="section-page-18-22">
                                    <Col md={10}>
                                        <div className="section-line"></div>
                                    </Col>
                                </Row>
                            </>
                        )}
                        { isShowSectionCheckbox("col_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-19-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("col_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">เสร็จการชำระบัญชี</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("13");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i>
                                                <br/>
                                                <Label className="label-sub-title-topic">(The Completeness of Liquidation)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.col_select === "1" && (
                                            <>
                                                <Row id="section-page-19-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-sub-title-topic-title">1.กรุณาแนบไฟล์งบดุลวันที่เลิกบริษัท<span className="msg-require">*</span></Label>
                                                            <i className="mdi mdi-help-circle icon-hint-padding" id="PopoverRightCompanyCash"></i>
                                                            <div className="hstack flex-wrap gap-2">
                                                                <UncontrolledPopover placement="right" target="PopoverRightCompanyCash">
                                                                    <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ต้นฉบับงบดุลวันที่เลิกบริษัทต้องนำส่งให้ฝ่ายกฎหมายจำนวน 1 ฉบับ เพื่อใช้ยื่นจดทะเบียนต่อ DBD<br/>The original of the Company’s report and financial statements closing on the date of Company's liquidation must be submitted to the legal department for registration with the DBD</PopoverBody>
                                                                </UncontrolledPopover>
                                                            </div>
                                                            <Label className="span-sub-title-topic-name">Please Attach the copy(.pdf) of the House Registration of the office(s) of liquidator(s)</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-19-3">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <MultipleUploadfile inputID="fileBalancesheet" folder={dataFormRequest.request_no} dataFile={fileBalancesheet} setDataFile={OnSetFileBalancesheet} isDisable={false}/>
                                                            { validation.touched.col_balancesheet_file && validation.errors.col_balancesheet_file ? 
                                                                ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.col_balancesheet_file}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-19-4">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-sub-title-topic-title">2.แนบไฟล์รายการสมุดบัญชีและสรรพเอกสารทั้งหลาย (ดาวน์โหลดตัวอย่างไฟล์ที่ให้แนบได้ที่ด้านล่าง)</Label><br/>
                                                            <Label className="span-sub-title-topic-name">Attach the list of the account books and any documents (Download the example file attached below)</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-19-5">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <MultipleDownloadfile folder="exampleDbdFile" dataFile={fileExample} />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-19-6">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-sub-title-topic-title">2.1 แนบไฟล์ที่ระบุรายการสมุดบัญชีและสรรพเอกสารทั้งหลาย<span className="msg-require">*</span></Label><br/>
                                                            <Label className="span-sub-title-topic-name">Attach the file specifying the list of the account books and any</Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-19-7">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <MultipleUploadfile inputID="fileDocs" folder={dataFormRequest.request_no} dataFile={fileDocs} setDataFile={OnSetFileDocs} isDisable={false}/>
                                                            { validation.touched.col_docs_file && validation.errors.col_docs_file ? 
                                                                ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.col_docs_file}</FormFeedback> ) : false 
                                                            }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-19-8">
                                                    <Col md={10}>
                                                        <br/>
                                                        <Label className="span-sub-title">
                                                            { validation.touched.col_acknowledged && validation.errors.col_acknowledged && selectRadioColAcknowledged === "0" ? ( 
                                                                       <span className="msg-require">
                                                                            {validation.errors.col_acknowledged}
                                                                        </span>
                                                                    ) : "กรุณาเลือกข้อใดข้อนึง" }
                                                        </Label><br/><br/>
                                                        <FormGroup className="radio-gap">
                                                            <Input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="col_acknowledged"
                                                                id="idColAcknowledged1"
                                                                value="1"
                                                                checked={selectRadioColAcknowledged === "1"}
                                                                onChange={handleColAcknowledged}
                                                                disabled={isDisableds}
                                                                invalid={ validation.touched.col_acknowledged && validation.errors.col_acknowledged && selectRadioColAcknowledged === "0" ? true : false }
                                                            />
                                                            <Label className="label-sub-title-topic-b-radio" htmlFor="idColAcknowledged1">
                                                            ข้าพเจ้านำส่งต้นฉบับงบดุลวันที่เลิกบริษัทให้ฝ่ายกฎหมายแล้ว เมื่อวันที่ 
                                                            </Label><br/>
                                                            <Label className="span-subheader-title-desc" htmlFor="idColAcknowledged1">
                                                            I have sent the original of the Company’s report and financial statements closing on the date of Company's liquidation to the legal department on 
                                                            </Label><br/>
                                                            <Col md={5}>
                                                                <Label className="label-title">วันที่นำส่งเอกสาร
                                                                {  selectRadioColAcknowledged === "1" && (
                                                                    <span className="msg-require">*</span>
                                                                )}
                                                                </Label><br/>
                                                                    <Input
                                                                        type="date"
                                                                        max={new Date().toISOString().split('T')[0]} 
                                                                        id="colDocsShipDate"
                                                                        name="col_docs_ship_date"
                                                                        className="form-control"
                                                                        value={shipDate || ""}
                                                                        invalid={validation.touched.col_docs_ship_date && validation.errors.col_docs_ship_date && selectRadioColAcknowledged === "1" ? true : false}
                                                                        onChange={handleShipDateChange}
                                                                        onBlur={(e)=>{
                                                                            const inputDate = e.target.value;
                                                                            const maxDate = new Date().toISOString().split('T')[0];
                                                                            if (inputDate >= maxDate) {
                                                                                setShipDate(maxDate);
                                                                            }
                                                                        }}
                                                                        disabled={isDisableds || selectRadioColAcknowledged === "2" || selectRadioColAcknowledged === "0"}
                                                                    />
                                                                    { validation.touched.col_docs_ship_date && validation.errors.col_docs_ship_date && selectRadioColAcknowledged === "1"? ( 
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {validation.errors.col_docs_ship_date}
                                                                        </FormFeedback>
                                                                    ) : false }
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Row><br/>
                                                <Row id="section-page-19-9">
                                                    <Col md={10}>
                                                        <FormGroup className="radio-gap">
                                                            <Input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="col_acknowledged"
                                                                id="idColAcknowledged2"
                                                                value="2"
                                                                checked={selectRadioColAcknowledged === "2"}
                                                                onChange={handleColAcknowledged}
                                                                disabled={isDisableds}
                                                                invalid={ validation.touched.col_acknowledged && validation.errors.col_acknowledged && selectRadioColAcknowledged === "0" ? true : false }
                                                            />
                                                            <Label className="label-sub-title-topic-b-radio" htmlFor="idColAcknowledged2">
                                                            ข้าพเจ้าจะจัดส่งต้นฉบับงบดุลวันที่เลิกบริษัทให้ฝ่ายกฎหมาย ในวันที่ 
                                                            </Label><br/>
                                                            <Label className="span-subheader-title-desc" htmlFor="idColAcknowledged2">
                                                            I will send the original of the Company’s report and financial statements closing on the date of Company's liquidation to the legal department on 
                                                            </Label><br/>
                                                            <Col md={5}>
                                                                <Label className="label-title">วันที่จะจัดส่ง
                                                                    {  selectRadioColAcknowledged === "2" && (
                                                                        <span className="msg-require">*</span>
                                                                    )}
                                                                </Label><br/>
                                                                    <Input
                                                                        type="date"
                                                                        min={new Date().toISOString().split('T')[0]}
                                                                        id="colDocsSentDate"
                                                                        name="col_docs_sent_date"
                                                                        className="form-control"
                                                                        value={sentDate || ""}
                                                                        invalid={validation.touched.col_docs_sent_date && validation.errors.col_docs_sent_date && selectRadioColAcknowledged === "2" ? true : false}
                                                                        onChange={handleSentDateChange}
                                                                        onBlur={(e)=>{
                                                                            const inputDate = e.target.value;
                                                                            const minDate = new Date().toISOString().split('T')[0];
                                                                            if (inputDate < minDate) {
                                                                                setSentDate(minDate);
                                                                            }
                                                                        }}
                                                                        disabled={isDisableds || selectRadioColAcknowledged === "1" || selectRadioColAcknowledged === "0"}
                                                                    />
                                                                    { validation.touched.col_docs_sent_date && validation.errors.col_docs_sent_date && selectRadioColAcknowledged === "2" ? ( 
                                                                        <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                            {validation.errors.col_docs_sent_date}
                                                                        </FormFeedback>
                                                                    ) : false }
                                                            </Col>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    <Row id="section-page-19-10">
                                        <Col md={10}>
                                            <div className="section-line"></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        )}
                        { isShowSectionCheckbox("other_select") && (
                            <div>
                                <Col md={12} className="mx-auto">
                                    <Row id="section-page-20-1">
                                        <Col md={10} style={{cursor:"pointer"}} onClick={() => toggleCheckbox("other_select")}>
                                            <FormGroup>
                                                <i className="mdi mdi-book-open-variant icon-book"></i>
                                                <Label className="label-title-topic">อื่นๆ</Label>
                                                <i className="mdi mdi-close icon-close-book"
                                                    onClick={(event) => {
                                                        if(!isDisableds){
                                                            event.stopPropagation(); 
                                                            handleDeleteClick("14");
                                                            setIsSaveEnabled(true);
                                                        }
                                                    }}
                                                >
                                                </i>
                                                <br/>
                                                <Label className="label-sub-title-topic">(Others)</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                        { isShowSection.other_select === "1" && (
                                            <>
                                                <Row id="section-page-20-2">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">1.ชื่อเรื่อง (Title)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                name="other_title"
                                                                placeholder="ระบุชื่อเรื่อง"
                                                                autoComplete={autoCompletes}
                                                                className="txt-placeholder"
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.other_title || ""}
                                                                invalid={validation.touched.other_title && validation.errors.other_title ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.other_title && validation.errors.other_title ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.other_title}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row id="section-page-20-3">
                                                    <Col md={10}>
                                                        <FormGroup>
                                                            <Label className="label-title">2.ระบุรายละเอียดเพิ่มเติมให้ชัดเจน (Please specify complete information)<span className="msg-require">*</span></Label>
                                                            <Input
                                                                type="textarea"
                                                                name="other_detail"
                                                                placeholder="ระบุข้อมูลเพิ่มเติม"
                                                                autoComplete={autoCompletes}
                                                                className="txt-text-area"
                                                                onChange={(e) => {
                                                                    validation.handleChange(e);
                                                                    validationDraft.handleChange(e);
                                                                    setIsSaveEnabled(true);
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.other_detail || ""}
                                                                invalid={validation.touched.other_detail && validation.errors.other_detail ? true : false}
                                                                disabled={isDisableds}
                                                            />
                                                            { validation.touched.other_detail && validation.errors.other_detail ? ( 
                                                                <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">
                                                                    {validation.errors.other_detail}
                                                                </FormFeedback>
                                                            ) : false }
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                        <Row id="section-page-20-4">
                                            <Col md={10}>
                                                <div className="section-line"></div>
                                            </Col>
                                        </Row>
                                </Col>
                            </div>
                        )}
                        { areAllCheckboxesZero && ( 
                            <Col md={10}>
                                <div className="line-border"></div>
                            </Col>
                        )}
                        <div id="section-page-21-1">
                            <Col xl={12} className="mx-auto">
                                <div>​
                                    <span className="span-title">อื่นๆ (Others)</span>
                                </div>
                            </Col>
                            <br/>
                            <Col md={10}>
                                <FormGroup>
                                    <Label className="label-title-confidential">ระดับชั้นความลับ (Confidentiality Level)<span className="msg-require">*</span></Label>
                                    <i className="mdi mdi-help-circle icon-hint-right" id="PopoverTopConfidential"></i>
                                    <div className="hstack flex-wrap gap-2">
                                        <UncontrolledPopover placement="top" target="PopoverTopConfidential">
                                            <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> "ทั่วไป" หมายถึง สามารถเปิดเผยให้ฝ่ายกฎหมายและผู้ที่เกี่ยวข้องได้ <br/>"เป็นความลับ" หมายถึง เอกสารนี้จะเปิดเผยให้แก่ฝ่ายกฎหมายที่ถูกระบุชื่อ และฝ่ายกฎหมายระดับ Associate Director ขึ้นไปเท่านั้น​<br/>"General" means that this request will be shared with all legal team members and related persons. ​<br/> "Confidential" means that this request will be shared with the specified legal person and legal associate directors or higher level.</PopoverBody>
                                        </UncontrolledPopover>
                                    </div>
                                    
                                    <Select id="ddlConfidential"
                                        name="id_confidential_level"
                                        value={selectConfidential}
                                        className="txt-placeholder"
                                        placeholder={"เลือกระดับความลับของเอกสาร"}
                                        onChange={(selected) => {
                                            setSelectConfidential(selected);
                                            validation.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                            validationDraft.handleChange("id_confidential_level")((selected !== null) ? selected.value : "");
                                            setIsSaveEnabled(true);
                                        }}
                                        options={dataConfidential}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_confidential_level && validation.errors.id_confidential_level ? true : false }
                                        isDisabled={isDisableds}
                                    />
                                    { validation.touched.id_confidential_level && validation.errors.id_confidential_level ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}} className="msg-show-hint">{validation.errors.id_confidential_level}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverTopLegalHandle"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="top" target="PopoverTopLegalHandle">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> ระบุอีเมลของนักกฎหมายที่เคยรับผิดชอบเอกสารนี้ (ขั้นตอนนี้ไม่ใช่การกำหนดเลือกคนทำงาน ฝ่ายกฎหมายขอสงวนสิทธิ์ในการกำหนดคนทำงานนี้ต่อไป)<br/>This request will be sent to the e-mail address of the e-mail person. (This step is not to select workers. The Legal Department reserves the right to solely decide and assign people to do this work.)</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Label className="label-title">นักกฎหมายที่เคยตรวจเอกสารนี้ (Legal team who has handled this work)</Label>
                                <Input 
                                    id="txtRequireHandledBy" 
                                    name="require_handled_by"
                                    autoComplete={autoCompletes}
                                    className="txt-placeholder"
                                    placeholder="กรอกอีเมล"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.require_handled_by || ""}
                                    invalid={validation.touched.require_handled_by && validation.errors.require_handled_by ? true : false}
                                    disabled={dataFormRequest.id_workflow_status > 4 ? true : isDisableds}
                                />
                                {validation.touched.require_handled_by && validation.errors.require_handled_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.require_handled_by}
                                    </FormFeedback>
                                    ) : false}
                                </FormGroup>
                            </Col>
                            <Col md={10}>
                                <FormGroup>
                                <Label className="label-title">ผู้อนุมัติแบบคำขอ (User Approver)<span className="msg-require">*</span></Label>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightApproval"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="PopoverRightApproval" >
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุชื่อผู้อนุมัติคำขอ โดยคำขอทุกฉบับต้องได้รับการอนุมัติจากผู้มีตำแหน่ง Director ขึ้นไปในฝ่ายผู้ขอ <br/>(Please specify the approver's name. Kindly note that all requests must be approved by director or higher level in your function.)​</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Input
                                    type="text"
                                    id="txtApproveRequestBy"
                                    name="approve_request_by"
                                    autoComplete={autoCompletes}
                                    className="txt-placeholder"
                                    placeholder="กรอกอีเมล"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        // console.log(e.target.value);
                                        setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.approve_request_by || ""}
                                    invalid={validation.touched.approve_request_by && validation.errors.approve_request_by ? true : false}
                                    disabled={isDisableds || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.approve_request_by || dataFormRequest.id_workflow_status > 4 ? true : false}
                                />
                                    {validation.touched.approve_request_by && validation.errors.approve_request_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.approve_request_by}
                                    </FormFeedback>
                                    ) : false}
                                
                                </FormGroup>
                            </Col>
                            { checkShowInputUserCoordinator ? (
                            <Col md={10}>
                                <FormGroup>
                                <i className="mdi mdi-help-circle icon-hint-right" id="PopoverRightCoodinator"></i>
                                <div className="hstack flex-wrap gap-2">
                                    <UncontrolledPopover placement="right" target="PopoverRightCoodinator">
                                        <PopoverBody className="msg-show-hint"><i className="mdi mdi-help-circle msg-icon-hint"></i> โปรดระบุอีเมลของผู้ประสานงานสำหรับคำขอนี้โดยจะต้องเป็นผู้ที่มีรายชื่อเป็นผู้ประสานงานตามที่บริษัทกำหนดและได้แจ้งฝ่ายกฎหมาย BTSG ไว้แล้ว <br/>Please specify the email address of the coordinator for this request. The specified person must be listed as a coordinator as designated by the company and has been informed to BTSG legal team.</PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                                <Label className="label-title">ชื่อผู้ประสานงาน (Name of User Coordinator)<span className="msg-require">*</span></Label>
                                <Input
                                    type="text"
                                    id="txtCreateRequestBy"
                                    name="create_request_by"
                                    autoComplete={autoCompletes}
                                    className="txt-placeholder"
                                    placeholder="กรอกอีเมลผู้ประสานงาน"
                                    onChange={(e) => {
                                        validation.handleChange(e);
                                        validationDraft.handleChange(e);
                                        // console.log(e.target.value);
                                        setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.create_request_by || ""}
                                    invalid={validation.touched.create_request_by && validation.errors.create_request_by ? true : false}
                                    disabled={isDisableds || dataFormRequest.request_no !== "draft" && dataUser.email === dataFormRequest.create_request_by || dataFormRequest.id_workflow_status > 4 ? true : false}
                                />
                                    {validation.touched.create_request_by && validation.errors.create_request_by ? (
                                    <FormFeedback type="invalid" style={{ display: "block" }} className="msg-show-hint">
                                        {validation.errors.create_request_by}
                                    </FormFeedback>
                                    ) : false}
                                
                                </FormGroup>
                            </Col>
                            ):""}
                            { showCommentApprover === true || Boolean(dataFormDbd.approver_comment && dataFormDbd.approver_comment !== "") ? (
                                <>
                                <Col md={12}>
                                    <div className="line-border"></div>
                                </Col>
                                <Col md={10}>
                                    <div className="page-content-approver">
                                        <div className="approver-header-content">
                                        {dataUser.email === dataFormRequest.approve_request_by ? "ระบุความเห็นเพื่อส่งไปยังผู้ร้องขอ (Please specify comments to send to the requester.)" : "คุณมีความเห็นจากผู้อนุมัติ (You have a comments from the approver)"}
                                        </div>
                                        <FormGroup>
                                        <Col md={10} className="approver-col">
                                            <Label className="label-title-approver-comment">ความเห็นของผู้อนุมัติ (Approver's Comment)</Label>
                                            <Input
                                                type="text"
                                                id="txtApproveComment"
                                                name="approver_comment"
                                                autoComplete={autoCompletes}
                                                className="txt-approver-comment"
                                                placeholder="ความเห็นเพิ่มเติมของผู้อนุมัติ"
                                                onChange={(e) => {
                                                    validation.handleChange(e);
                                                    validationDraft.handleChange(e);
                                                    validationReturn.handleChange(e);
                                                    //setIsSaveEnabled(true); // Set save enabled to true when the input changes
                                                }}
                                                onBlur={validationReturn.handleBlur}
                                                value={validation.values.approver_comment || ""}
                                                invalid={validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? true : false}
                                                disabled={(dataUser.email === dataFormRequest.request_by) || (dataUser.email === dataFormRequest.create_request_by) || (dataUser.email === dataFormRequest.approve_request_by && dataFormRequest.id_workflow_status === 4) ? true : false}
                                            />
                                            {validationReturn.touched.approver_comment && validationReturn.errors.approver_comment ? (
                                            <FormFeedback type="invalid" className="alert-validation-approver-comment">
                                                {validationReturn.errors.approver_comment}
                                            </FormFeedback>
                                            ) : false}
                                        </Col>
                                        </FormGroup>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="line-border"></div>
                                </Col>
                                </>
                            ):null}
                            <Col md={10}>
                                <Alert className="border-0 border-0 remark-content">
                                <i className="mdi mdi-alert icon-remark-color"></i><strong className="remark-color"> หมายเหตุ (Remark) </strong><br/>
                                <span className="span-remark">ใช้ระยะเวลาในการดำเนินการประมาณ 15 วัน ขึ้นอยู่กับตารางกำหนดการของกรรมการที่ลงนาม (The processing time is approximately 15 days, subject to the signing director's schedule.)</span><br/>
                                {/* <span className="span-remark">"Users are fully aware that this request form is strictly private and confidential for internal use within BTS Group's affiliates only. Any employee disclosing this request form to the third party is considered a serious misconduct."</span> */}
                                </Alert>
                            </Col>
                        </div>
                        <br/>
               {   
                    dataFormRequest.id_workflow_status >= 0 && // Check if status is 0 or greater
                    dataFormRequest.id_workflow_status <= 4 ||
                    dataFormDbd.id === 0 ? (
                    <Row>
                        <div className="page-footer">
                            <div className="layout-width-footer">
                                <div className="navbar-footer">
                                    <>
                                    <div className="d-flex align-items-center">
                                        <Link to={GetUrlBack()} className="logo">
                                            <Button 
                                                color="outline secondary" 
                                                type="button" 
                                                // onClick={handleBack}
                                            >
                                            Back
                                            </Button>
                                        </Link>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        {dataFormRequest.request_no === "draft" ? (
                                            <Button 
                                                color="outline secondary" 
                                                type="button" 
                                                // onClick={handleBack}
                                                onClick={() => onCancelRequest(dataFormRequest)}
                                            >
                                            Delete
                                            </Button>
                                        ): null}
                                        {checkUserIsApproverShowReturnBtn ?(
                                            <>
                                            {/* case if requestor && approver ถ้าคนเปิด request และ คนอนุมัติเป็นคนเดียวกันจะปิด ปุ่ม return  */}
                                            {checkUserCreateTicketAndApproveIsSame ?(
                                            <Button 
                                            className="btn-return-style"
                                            color="outline secondary" 
                                            type="button" 
                                            disabled={isSaveEnabled}
                                            onClick={() => onCheckReturn()}
                                            >
                                                Return
                                            </Button>
                                            ):null}
                                            </>
                                        ):null}
                                        {(changeButtonIsStateRequestorOrApprover) ?(
                                            <>
                                                <Button 
                                                    className="float-end btn-save-style"  
                                                    color={isSaveEnabled ? "primary" : "secondary"} 
                                                    outline 
                                                    type="button" 
                                                    disabled={!isSaveEnabled}
                                                    onClick={() => onCheckSaveDraft()}
                                                >
                                                    Save
                                                </Button>
                                                <Button 
                                                    className="float-end btn-submit-style" 
                                                    color="primary" 
                                                    type="button"
                                                    disabled={dataUser.email === dataFormRequest.approve_request_by ? isSaveEnabled : false}
                                                    onClick={() => onCheckSubmit()}
                                                >
                                                {/* {userEmail +"/"+ dataFormRequest.request_by} */}
                                                {dataUser.email === dataFormRequest.approve_request_by ? "Approve" : "Submit"}
                                                </Button>
                                            </>
                                        ):null}
                                    </div>
                                    </>
                                </div>
                            </div>
                        </div>
                    </Row>
                    ):
                    <>
                        <div id="footer-modal" className="footer-modal-memo">
                            <hr className="line-footer"></hr>
                            <Col md={12}>
                                <Button 
                                    className="float-end btn-submit-style" 
                                    color="primary" 
                                    type="button"
                                    onClick={() => validation.submitForm()}
                                >
                                    Update
                                </Button>
                                <Button 
                                    className="float-end btn-cancel" 
                                    color="outline secondary" 
                                    type="button" 
                                    onClick={() => onCancelRequest(false)}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </div>
                    </>
                }
            </Form>
            </div>
            <Modal id="modalFormDbd"
                    isOpen={isShowModal}
                    toggle={() => { setIsShowModal(!isShowModal); }}
                    backdrop={'static'}
                    size="lg"
                    className="custom-modal"
                >
                    <ModalHeader className="custom-header">
                        <Col md={12}>
                            <Row>
                                <Col md={11} className="modal-popup-header">
                                    <span className="span-title">เรื่องที่จะขอจดทะเบียน (Registration Request)</span>
                                </Col>        
                                <Col md={1}>
                                    <div> 
                                        <i className="mdi mdi-close-circle-outline modal-icon-close" onClick={() => setIsShowModal(false)} ></i>
                                    </div>
                                </Col>
                            </Row>
                        </Col>  
                    </ModalHeader>
                    <ModalBody>
                        <Col md={12} className="mx-auto">
                            <label className="label-title">สามารถเลือกได้มากกว่า 1 เอกสาร (You can select more than 1 document)</label>
                            <div className="modal-popup-content">
                                <FormGroup>
                                    <Input
                                        id="increaseCap"
                                        type="checkbox"
                                        name="iccap_select"
                                        checked={isSelectedCheckbox("iccap_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("iccap_select") || isDisableds}
                                        className={isShowSectionCheckbox("iccap_select") ? "input-checkbox-disabled" : ""}
                                        />
                                    <Label className="label-title" htmlFor="increaseCap"> เพิ่มทุน (Increase Registered Capital)</Label><br/>
                                    <Input
                                        id="decreaseCap"
                                        type="checkbox"
                                        name="dccap_select"
                                        checked={isSelectedCheckbox("dccap_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("dccap_select") || isDisableds}
                                        className={isShowSectionCheckbox("dccap_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="decreaseCap"> ลดทุน (Decrease Registered Capital)</Label><br/>
                                    <Input
                                        id="editCompany"
                                        type="checkbox"
                                        name="edit_name_select"
                                        checked={isSelectedCheckbox("edit_name_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("edit_name_select") || isDisableds}
                                        className={isShowSectionCheckbox("edit_name_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="editCompany"> แก้ไขชื่อ (Amendment of the Company's Name)</Label><br/>
                                    <Input
                                        id="companySeal"
                                        type="checkbox"
                                        name="edit_seal_select"
                                        checked={isSelectedCheckbox("edit_seal_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("edit_seal_select") || isDisableds}
                                        className={isShowSectionCheckbox("edit_seal_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="companySeal"> แก้ไขตราประทับบริษัท (Amendment of the Company seal)</Label><br/>
                                    <Input
                                        id="headOffice"
                                        type="checkbox"
                                        name="headoffice_select"
                                        checked={isSelectedCheckbox("headoffice_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("headoffice_select") || isDisableds}
                                        className={isShowSectionCheckbox("headoffice_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="headOffice"> แก้ไขที่ตั้งสำนักงานใหญ่ (Amendment of the Head Office Address)</Label><br/>
                                    <Input
                                        id="branchOffice"
                                        type="checkbox"
                                        name="branchoffice_select"
                                        checked={isSelectedCheckbox("branchoffice_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("branchoffice_select") || isDisableds}
                                        className={isShowSectionCheckbox("branchoffice_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="branchOffice"> แก้ไขที่ตั้งสำนักสาขา (Amendment of the Branch Office Address)</Label><br/>
                                    <Input
                                        id="companyObject"
                                        type="checkbox"
                                        name="objective_select"
                                        checked={isSelectedCheckbox("objective_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("objective_select") || isDisableds}
                                        className={isShowSectionCheckbox("objective_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="companyObject"> แก้ไขวัตถุประสงค์ (Amendment of the Company's Objectives)</Label><br/>
                                    <Input
                                        id="articleAssociation"
                                        type="checkbox"
                                        name="bylaws_select"
                                        checked={isSelectedCheckbox("bylaws_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("bylaws_select") || isDisableds}
                                        className={isShowSectionCheckbox("bylaws_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="articleAssociation"> แก้ไขข้อบังคับ (Amendment of the Article of Association)</Label><br/>
                                    <Input
                                        id="authorizedDirectors"
                                        type="checkbox"
                                        name="cod_select"
                                        checked={isSelectedCheckbox("cod_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("cod_select") || isDisableds}
                                        className={isShowSectionCheckbox("cod_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="authorizedDirectors">เปลี่ยนแปลงรายชื่อกรรมการ และ/หรือเปลี่ยนแปลงกรรมการผู้มีอำนาจลงนามผูกพันบริษัท <br/>(Amendment of the Directors and/or  the Authorized Directors)</Label><br/>
                                    <Input
                                        id="sharePayment"
                                        type="checkbox"
                                        name="coa_select"
                                        checked={isSelectedCheckbox("coa_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("coa_select") || isDisableds}
                                        className={isShowSectionCheckbox("coa_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="sharePayment"> เรียกชำระค่าหุ้นเพิ่ม (Calling of the Additional Share Payment)</Label><br/>
                                    <Input
                                        id="shareTransfer"
                                        type="checkbox"
                                        name="ts_select"
                                        checked={isSelectedCheckbox("ts_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("ts_select") || isDisableds}
                                        className={isShowSectionCheckbox("ts_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="shareTransfer"> โอนหุ้น (Share Transfer)</Label><br/>
                                    <Input
                                        id="companyLiq"
                                        type="checkbox"
                                        name="dtc_select"
                                        checked={isSelectedCheckbox("dtc_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("dtc_select") || isDisableds}
                                        className={isShowSectionCheckbox("dtc_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="companyLiq">เลิกบริษัท (Company Liquidation) </Label><br/>
                                    <Input
                                        id="completeLiq"
                                        type="checkbox"
                                        name="col_select"
                                        checked={isSelectedCheckbox("col_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("col_select") || isDisableds}
                                        className={isShowSectionCheckbox("col_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="completeLiq">เสร็จการชำระบัญชี (The Completeness of Liquidation)</Label><br/>
                                    <Input
                                        id="other"
                                        type="checkbox"
                                        name="other_select"
                                        checked={isSelectedCheckbox("other_select")}
                                        onChange={handleTempCheckboxChange}
                                        disabled={isShowSectionCheckbox("other_select") || isDisableds}
                                        className={isShowSectionCheckbox("other_select") ? "input-checkbox-disabled" : ""}
                                       
                                        />
                                    <Label className="label-title" htmlFor="other">อื่นๆ (Others) </Label><br/>
                                </FormGroup>
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <hr className="line-footer"></hr>
                        <Col md={12}>
                            <Button 
                                className="float-end btn-submit-style" 
                                color="primary" 
                                type="button"
                                onClick={selectFormDoc}
                            >
                                Submit
                            </Button>
                            <Button 
                                className="float-end btn-cancel btn-right" 
                                color="outline secondary" 
                                type="button" 
                                onClick={() => setIsShowModal(false)}
                            >
                                Cancel
                            </Button>
                        </Col>
                    </ModalFooter>
            </Modal>
            
            <Modal id="modalFormDbdAddlimit"
                    isOpen={isShowModalLimit}
                    toggle={() => { setIsShowModalLimit(!isShowModalLimit); }}
                    backdrop={'static'}
                    size="l"
                    centered
                    className="custom-modal"
                >
                    <ModalBody style={{paddingLeft:"40px"}}>
                            <Row>
                                <p><i className="mdi mdi-alert-decagram modal-alert-dbd"></i></p>
                                <p className="modal-note-dbd">เพิ่มข้อมูลถึงขีดจำกัดแล้ว</p>
                                <p className="modal-content-approve">ถึงขีดจำกัดสูงสุดแล้ว ลบข้อมูลบางรายการเพื่อเพิ่มข้อมูลเพิ่ม<br/>You cannot add more items. The limit has been reached.Please remove some items to add more.</p> 
                            </Row>
                    </ModalBody>
                    <ModalFooter>
                            <Row>
                                <Col md="12">
                                    <Button 
                                        className="float-end" 
                                        color="primary" 
                                        type="button"
                                        onClick={() => setIsShowModalLimit(false) } 
                                    >
                                        Ok
                                    </Button>
                                </Col>
                            </Row>
                    </ModalFooter>
            </Modal>

            <Modal id="modalDeleteSection"
                    isOpen={isShowDeleteModal}
                    toggle={() => { setIsShowDeleteModal(!isShowDeleteModal); }}
                    backdrop={'static'}
                    size="lg"
                    className="custom-modal modal-delete-section"
                    centered
                >
                    <ModalHeader className="custom-header">
                    <Col md={12}>
                        <Row>
                            <Col md={10} className="modal-popup-header-padding">
                                <span className="span-title">Delete Form (ลบเอกสาร)</span>
                            </Col>        
                            <Col md={2}>
                                <div className="delete-close-popup"> 
                                    <i className="mdi mdi-close-circle-outline modal-icon-close" onClick={() => setIsShowDeleteModal(false)} ></i>
                                </div>
                            </Col>
                        </Row>
                    </Col>  
                    </ModalHeader>
                    <ModalBody>
                        <Col md={12} className="mx-auto">
                            <label className="label-title-content">คุณยืนยันที่จะลบเอกสารหรือไม่? หากลบเอกสารแล้ว จะไม่สามารถกู้คืนข้อมูลนี้ได้อีก<br/>Are you sure you want to delete the document? If you delete the document, it will not be able to be recovered</label>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <hr className="line-footer"></hr>
                        <Col md={12}>
                            <Button 
                                className="float-end btn-delete-style" 
                                color="outline danger" 
                                type="button"
                                onClick={confirmDelete}
                            >
                                Delete
                            </Button>
                            <Button 
                                className="float-end btn-cancel btn-right" 
                                color="outline secondary" 
                                type="button" 
                                onClick={() => setIsShowDeleteModal(false)}
                            >
                                Cancel
                            </Button>
                        </Col>
                    </ModalFooter>
            </Modal>
        </React.Fragment>
        );
    };

export default RequestFormDbd;